/* tslint:disable */
/* eslint-disable */
/**
 * dz.poker - API文档
 * <b>注意：仅开启swagger选项有效，建议上线前关闭该选项</b>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @enum {string}
 */

export const BASEMENUTYPEE = {
    Link: 'link',
    Dir: 'dir'
} as const;

export type BASEMENUTYPEE = typeof BASEMENUTYPEE[keyof typeof BASEMENUTYPEE];


/**
 *
 * @export
 * @enum {string}
 */

export const BASEROUTETYPEE = {
    AdminPage: 'admin_page',
    CommonPage: 'common_page'
} as const;

export type BASEROUTETYPEE = typeof BASEROUTETYPEE[keyof typeof BASEROUTETYPEE];


/**
 *
 * @export
 * @enum {string}
 */

export const BILLPAYTYPEE = {
    Wechat: 'wechat',
    Cash: 'cash',
    Coins: 'coins',
    Points: 'points',
    Coupon: 'coupon',
    Other: 'other'
} as const;

export type BILLPAYTYPEE = typeof BILLPAYTYPEE[keyof typeof BILLPAYTYPEE];


/**
 *
 * @export
 * @enum {string}
 */

export const BILLSTATUSE = {
    Unpaid: 'unpaid',
    PayFailed: 'pay_failed',
    Waiting: 'waiting',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type BILLSTATUSE = typeof BILLSTATUSE[keyof typeof BILLSTATUSE];


/**
 *
 * @export
 * @enum {string}
 */

export const BILLTYPEE = {
    Order: 'order',
    Recharge: 'recharge'
} as const;

export type BILLTYPEE = typeof BILLTYPEE[keyof typeof BILLTYPEE];


/**
 *
 * @export
 * @interface BaseApiAdminVo
 */
export interface BaseApiAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseApiAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'path'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'method'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'tagName'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'summary'?: string;
    /**
     *
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'allowAll': boolean;
    /**
     *
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'enable': boolean;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BaseDictionaryAdminVo
 */
export interface BaseDictionaryAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'key': string;
    /**
     *
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'value': string;
    /**
     *
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BaseLogAdminVo
 */
export interface BaseLogAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseLogAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'level': string;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'message': string;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'category'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'start'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseLogAdminVo
     */
    'end'?: string;
    /**
     *
     * @type {number}
     * @memberof BaseLogAdminVo
     */
    'startId'?: number;
    /**
     *
     * @type {number}
     * @memberof BaseLogAdminVo
     */
    'endId'?: number;
}
/**
 *
 * @export
 * @interface BaseMenuAdminVo
 */
export interface BaseMenuAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'url'?: string;
    /**
     *
     * @type {BASEMENUTYPEE}
     * @memberof BaseMenuAdminVo
     */
    'type': BASEMENUTYPEE;
    /**
     *
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'icon'?: string;
    /**
     *
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'sequence': number;
    /**
     *
     * @type {boolean}
     * @memberof BaseMenuAdminVo
     */
    'enable': boolean;
    /**
     *
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 *
 * @export
 * @interface BaseOperateAdminVo
 */
export interface BaseOperateAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseOperateAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'key': string;
    /**
     *
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'name': string;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseOperateAdminVo
     */
    'roleIds': Array<number>;
    /**
     *
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BaseOrganizationAdminVo
 */
export interface BaseOrganizationAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'name': string;
    /**
     *
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BasePageQueryVo
 */
export interface BasePageQueryVo {
    /**
     *
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'pageSize': number;
}
/**
 *
 * @export
 * @interface BaseResultVo
 */
export interface BaseResultVo {
    /**
     *
     * @type {boolean}
     * @memberof BaseResultVo
     */
    'success': boolean;
    /**
     *
     * @type {string}
     * @memberof BaseResultVo
     */
    'msg'?: string;
    /**
     *
     * @type {any}
     * @memberof BaseResultVo
     */
    'data'?: any;
}
/**
 *
 * @export
 * @interface BaseRoleAdminVo
 */
export interface BaseRoleAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'key': string;
    /**
     *
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     *
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'level'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BaseRouteAdminVo
 */
export interface BaseRouteAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {BASEROUTETYPEE}
     * @memberof BaseRouteAdminVo
     */
    'type': BASEROUTETYPEE;
    /**
     *
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'allowAll': boolean;
    /**
     *
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'path': string;
    /**
     *
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'componentName': string;
    /**
     *
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isNest': boolean;
    /**
     *
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     *
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'enable': boolean;
    /**
     *
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 *
 * @export
 * @interface BaseTenantAdminVo
 */
export interface BaseTenantAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseTenantAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'name': string;
    /**
     *
     * @type {any}
     * @memberof BaseTenantAdminVo
     */
    'meta'?: any;
    /**
     *
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BaseUserAdminVo
 */
export interface BaseUserAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'phone'?: number;
    /**
     *
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {any}
     * @memberof BaseUserAdminVo
     */
    'meta'?: any;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'roleIds': Array<number>;
    /**
     *
     * @type {Array<string>}
     * @memberof BaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 *
 * @export
 * @interface BaseUserRoleAdminVo
 */
export interface BaseUserRoleAdminVo {
    /**
     *
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof BaseUserRoleAdminVo
     */
    'orgCode'?: string;
    /**
     *
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'roleId': number;
}
/**
 *
 * @export
 * @interface BenefitAdminVo
 */
export interface BenefitAdminVo {
    /**
     *
     * @type {number}
     * @memberof BenefitAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof BenefitAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof BenefitAdminVo
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof BenefitAdminVo
     */
    'icon': string;
    /**
     *
     * @type {number}
     * @memberof BenefitAdminVo
     */
    'minLevel': number;
    /**
     *
     * @type {number}
     * @memberof BenefitAdminVo
     */
    'couponTypeId'?: number;
    /**
     *
     * @type {CouponTypeAdminVo}
     * @memberof BenefitAdminVo
     */
    'couponType'?: CouponTypeAdminVo;
    /**
     *
     * @type {number}
     * @memberof BenefitAdminVo
     */
    'periodDays': number;
    /**
     *
     * @type {string}
     * @memberof BenefitAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface BillAdminVo
 */
export interface BillAdminVo {
    /**
     *
     * @type {number}
     * @memberof BillAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'name': string;
    /**
     *
     * @type {BILLSTATUSE}
     * @memberof BillAdminVo
     */
    'status'?: BILLSTATUSE;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'price': string;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'pointsPrice'?: string;
    /**
     *
     * @type {BILLPAYTYPEE}
     * @memberof BillAdminVo
     */
    'payType'?: BILLPAYTYPEE;
    /**
     *
     * @type {BILLTYPEE}
     * @memberof BillAdminVo
     */
    'billType'?: BILLTYPEE;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'remark'?: string;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'seatInfo'?: string;
    /**
     *
     * @type {PartialBillAdminVoGoods}
     * @memberof BillAdminVo
     */
    'goods'?: PartialBillAdminVoGoods;
    /**
     *
     * @type {number}
     * @memberof BillAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof BillAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof BillAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}


/**
 *
 * @export
 * @interface CategoryAdminVo
 */
export interface CategoryAdminVo {
    /**
     *
     * @type {number}
     * @memberof CategoryAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof CategoryAdminVo
     */
    'name': string;
    /**
     *
     * @type {boolean}
     * @memberof CategoryAdminVo
     */
    'isShow'?: boolean;
    /**
     *
     * @type {number}
     * @memberof CategoryAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof CategoryAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface CoinsRecordAdminVo
 */
export interface CoinsRecordAdminVo {
    /**
     *
     * @type {number}
     * @memberof CoinsRecordAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof CoinsRecordAdminVo
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof CoinsRecordAdminVo
     */
    'amount': string;
    /**
     *
     * @type {string}
     * @memberof CoinsRecordAdminVo
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof CoinsRecordAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof CoinsRecordAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface ConfigAdminVo
 */
export interface ConfigAdminVo {
    /**
     *
     * @type {number}
     * @memberof ConfigAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof ConfigAdminVo
     */
    'configKey': string;
    /**
     *
     * @type {any}
     * @memberof ConfigAdminVo
     */
    'configValue': any;
    /**
     *
     * @type {string}
     * @memberof ConfigAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface CouponAdminVo
 */
export interface CouponAdminVo {
    /**
     *
     * @type {number}
     * @memberof CouponAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof CouponAdminVo
     */
    'name': string;
    /**
     *
     * @type {any}
     * @memberof CouponAdminVo
     */
    'goods'?: any;
    /**
     *
     * @type {number}
     * @memberof CouponAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof CouponAdminVo
     */
    'mark'?: string;
    /**
     *
     * @type {string}
     * @memberof CouponAdminVo
     */
    'verifyTime'?: string;
    /**
     *
     * @type {string}
     * @memberof CouponAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {boolean}
     * @memberof CouponAdminVo
     */
    'isVerified'?: boolean;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof CouponAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface CouponTypeAdminVo
 */
export interface CouponTypeAdminVo {
    /**
     *
     * @type {number}
     * @memberof CouponTypeAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof CouponTypeAdminVo
     */
    'name': string;
    /**
     *
     * @type {number}
     * @memberof CouponTypeAdminVo
     */
    'goodsId'?: number;
    /**
     *
     * @type {string}
     * @memberof CouponTypeAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DESKTOPTYPEE = {
    Reservation: 'reservation',
    OrderDesk: 'order_desk'
} as const;

export type DESKTOPTYPEE = typeof DESKTOPTYPEE[keyof typeof DESKTOPTYPEE];


/**
 *
 * @export
 * @interface DesktopAdminVo
 */
export interface DesktopAdminVo {
    /**
     *
     * @type {number}
     * @memberof DesktopAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof DesktopAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof DesktopAdminVo
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof DesktopAdminVo
     */
    'basePoints': string;
    /**
     *
     * @type {Array<SeatSpe>}
     * @memberof DesktopAdminVo
     */
    'seats'?: Array<SeatSpe>;
    /**
     *
     * @type {Array<DESKTOPTYPEE>}
     * @memberof DesktopAdminVo
     */
    'desktopType'?: Array<DESKTOPTYPEE>;
    /**
     *
     * @type {string}
     * @memberof DesktopAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface GoodsAdminVo
 */
export interface GoodsAdminVo {
    /**
     *
     * @type {number}
     * @memberof GoodsAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof GoodsAdminVo
     */
    'categoryId'?: number;
    /**
     *
     * @type {string}
     * @memberof GoodsAdminVo
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof GoodsAdminVo
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof GoodsAdminVo
     */
    'image'?: string;
    /**
     *
     * @type {string}
     * @memberof GoodsAdminVo
     */
    'price': string;
    /**
     *
     * @type {number}
     * @memberof GoodsAdminVo
     */
    'giftPoints'?: number;
    /**
     *
     * @type {number}
     * @memberof GoodsAdminVo
     */
    'stock'?: number;
    /**
     *
     * @type {boolean}
     * @memberof GoodsAdminVo
     */
    'isOnSale'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof GoodsAdminVo
     */
    'isPointsExchange'?: boolean;
    /**
     *
     * @type {Array<GoodsSpecSpe>}
     * @memberof GoodsAdminVo
     */
    'specs'?: Array<GoodsSpecSpe>;
    /**
     *
     * @type {number}
     * @memberof GoodsAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof GoodsAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface GoodsSpecSpe
 */
export interface GoodsSpecSpe {
    /**
     *
     * @type {string}
     * @memberof GoodsSpecSpe
     */
    'name': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GoodsSpecSpe
     */
    'options': Array<string>;
}
/**
 *
 * @export
 * @interface InviteRuleSpe
 */
export interface InviteRuleSpe {
    /**
     *
     * @type {string}
     * @memberof InviteRuleSpe
     */
    'points': string;
}
/**
 *
 * @export
 * @interface OrderDesktopAdminVo
 */
export interface OrderDesktopAdminVo {
    /**
     *
     * @type {number}
     * @memberof OrderDesktopAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof OrderDesktopAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {number}
     * @memberof OrderDesktopAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof OrderDesktopAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface OrderGoodsSnapshotSpe
 */
export interface OrderGoodsSnapshotSpe {
    /**
     *
     * @type {number}
     * @memberof OrderGoodsSnapshotSpe
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'price': string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'pointsPrice'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'image'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'description'?: string;
    /**
     *
     * @type {boolean}
     * @memberof OrderGoodsSnapshotSpe
     */
    'isPointsExchange'?: boolean;
    /**
     *
     * @type {Array<SelectedGoodsSpecSpe>}
     * @memberof OrderGoodsSnapshotSpe
     */
    'selectedSpecs'?: Array<SelectedGoodsSpecSpe>;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'specText'?: string;
    /**
     *
     * @type {number}
     * @memberof OrderGoodsSnapshotSpe
     */
    'count': number;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'total': string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'totalPoints'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'giftPoints'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'totalGiftPoints'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'discount'?: string;
    /**
     *
     * @type {string}
     * @memberof OrderGoodsSnapshotSpe
     */
    'discountPrice'?: string;
}
/**
 *
 * @export
 * @interface OrderItemVo
 */
export interface OrderItemVo {
    /**
     *
     * @type {number}
     * @memberof OrderItemVo
     */
    'id': number;
    /**
     *
     * @type {number}
     * @memberof OrderItemVo
     */
    'count': number;
    /**
     *
     * @type {Array<SelectedGoodsSpecSpe>}
     * @memberof OrderItemVo
     */
    'selectedSpecs'?: Array<SelectedGoodsSpecSpe>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const POINTSAPPLYSTATUSE = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type POINTSAPPLYSTATUSE = typeof POINTSAPPLYSTATUSE[keyof typeof POINTSAPPLYSTATUSE];


/**
 *
 * @export
 * @enum {string}
 */

export const POINTSAPPLYTYPEE = {
    Deposit: 'deposit',
    Withdraw: 'withdraw'
} as const;

export type POINTSAPPLYTYPEE = typeof POINTSAPPLYTYPEE[keyof typeof POINTSAPPLYTYPEE];


/**
 *
 * @export
 * @enum {string}
 */

export const POINTSCONVERTTYPEE = {
    Points: 'points',
    Coins: 'coins'
} as const;

export type POINTSCONVERTTYPEE = typeof POINTSCONVERTTYPEE[keyof typeof POINTSCONVERTTYPEE];


/**
 *
 * @export
 * @interface PageQueryVo
 */
export interface PageQueryVo {
    /**
     *
     * @type {number}
     * @memberof PageQueryVo
     */
    'page': number;
    /**
     *
     * @type {number}
     * @memberof PageQueryVo
     */
    'pageSize': number;
}
/**
 *
 * @export
 * @interface PartialBaseApiAdminVo
 */
export interface PartialBaseApiAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseApiAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'path'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'method'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'tagName'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'summary'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'allowAll'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'enable'?: boolean;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseDictionaryAdminVo
 */
export interface PartialBaseDictionaryAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'key'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'value'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseLogAdminVo
 */
export interface PartialBaseLogAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'level'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'message'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'category'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'start'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'end'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'startId'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'endId'?: number;
}
/**
 *
 * @export
 * @interface PartialBaseMenuAdminVo
 */
export interface PartialBaseMenuAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'url'?: string;
    /**
     *
     * @type {BASEMENUTYPEE}
     * @memberof PartialBaseMenuAdminVo
     */
    'type'?: BASEMENUTYPEE;
    /**
     *
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'icon'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseMenuAdminVo
     */
    'enable'?: boolean;
    /**
     *
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 *
 * @export
 * @interface PartialBaseOperateAdminVo
 */
export interface PartialBaseOperateAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseOperateAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'key'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseOperateAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseOrganizationAdminVo
 */
export interface PartialBaseOrganizationAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseRoleAdminVo
 */
export interface PartialBaseRoleAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'key'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'level'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseRouteAdminVo
 */
export interface PartialBaseRouteAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {BASEROUTETYPEE}
     * @memberof PartialBaseRouteAdminVo
     */
    'type'?: BASEROUTETYPEE;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'allowAll'?: boolean;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'path'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'componentName'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isNest'?: boolean;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'enable'?: boolean;
    /**
     *
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 *
 * @export
 * @interface PartialBaseScheduleAdminVo
 */
export interface PartialBaseScheduleAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleDate'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleInterval'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCount'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCurrent'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleNextTime'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseTenantAdminVo
 */
export interface PartialBaseTenantAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseTenantAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {any}
     * @memberof PartialBaseTenantAdminVo
     */
    'meta'?: any;
    /**
     *
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBaseUserAdminVo
 */
export interface PartialBaseUserAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'phone'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {any}
     * @memberof PartialBaseUserAdminVo
     */
    'meta'?: any;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {Array<string>}
     * @memberof PartialBaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 *
 * @export
 * @interface PartialBenefitAdminVo
 */
export interface PartialBenefitAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBenefitAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBenefitAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBenefitAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBenefitAdminVo
     */
    'icon'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialBenefitAdminVo
     */
    'minLevel'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialBenefitAdminVo
     */
    'couponTypeId'?: number;
    /**
     *
     * @type {CouponTypeAdminVo}
     * @memberof PartialBenefitAdminVo
     */
    'couponType'?: CouponTypeAdminVo;
    /**
     *
     * @type {number}
     * @memberof PartialBenefitAdminVo
     */
    'periodDays'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBenefitAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialBillAdminVo
 */
export interface PartialBillAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialBillAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {BILLSTATUSE}
     * @memberof PartialBillAdminVo
     */
    'status'?: BILLSTATUSE;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'price'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'pointsPrice'?: string;
    /**
     *
     * @type {BILLPAYTYPEE}
     * @memberof PartialBillAdminVo
     */
    'payType'?: BILLPAYTYPEE;
    /**
     *
     * @type {BILLTYPEE}
     * @memberof PartialBillAdminVo
     */
    'billType'?: BILLTYPEE;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'remark'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'seatInfo'?: string;
    /**
     *
     * @type {PartialBillAdminVoGoods}
     * @memberof PartialBillAdminVo
     */
    'goods'?: PartialBillAdminVoGoods;
    /**
     *
     * @type {number}
     * @memberof PartialBillAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialBillAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialBillAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}


/**
 * @type PartialBillAdminVoGoods
 * @export
 */
export type PartialBillAdminVoGoods = Array<OrderGoodsSnapshotSpe> | RechargeBillGoodsSnapshotSpe;

/**
 *
 * @export
 * @interface PartialCategoryAdminVo
 */
export interface PartialCategoryAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialCategoryAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCategoryAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PartialCategoryAdminVo
     */
    'isShow'?: boolean;
    /**
     *
     * @type {number}
     * @memberof PartialCategoryAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCategoryAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialCoinsRecordAdminVo
 */
export interface PartialCoinsRecordAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialCoinsRecordAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialCoinsRecordAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCoinsRecordAdminVo
     */
    'amount'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialCoinsRecordAdminVo
     */
    'reason'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialCoinsRecordAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialCoinsRecordAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface PartialConfigAdminVo
 */
export interface PartialConfigAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialConfigAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialConfigAdminVo
     */
    'configKey'?: string;
    /**
     *
     * @type {any}
     * @memberof PartialConfigAdminVo
     */
    'configValue'?: any;
    /**
     *
     * @type {string}
     * @memberof PartialConfigAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialCouponAdminVo
 */
export interface PartialCouponAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialCouponAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCouponAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {any}
     * @memberof PartialCouponAdminVo
     */
    'goods'?: any;
    /**
     *
     * @type {number}
     * @memberof PartialCouponAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCouponAdminVo
     */
    'mark'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialCouponAdminVo
     */
    'verifyTime'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialCouponAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PartialCouponAdminVo
     */
    'isVerified'?: boolean;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialCouponAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface PartialCouponTypeAdminVo
 */
export interface PartialCouponTypeAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialCouponTypeAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCouponTypeAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialCouponTypeAdminVo
     */
    'goodsId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialCouponTypeAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialDesktopAdminVo
 */
export interface PartialDesktopAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialDesktopAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialDesktopAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialDesktopAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialDesktopAdminVo
     */
    'basePoints'?: string;
    /**
     *
     * @type {Array<SeatSpe>}
     * @memberof PartialDesktopAdminVo
     */
    'seats'?: Array<SeatSpe>;
    /**
     *
     * @type {Array<DESKTOPTYPEE>}
     * @memberof PartialDesktopAdminVo
     */
    'desktopType'?: Array<DESKTOPTYPEE>;
    /**
     *
     * @type {string}
     * @memberof PartialDesktopAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialGoodsAdminVo
 */
export interface PartialGoodsAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialGoodsAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialGoodsAdminVo
     */
    'categoryId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialGoodsAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialGoodsAdminVo
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialGoodsAdminVo
     */
    'image'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialGoodsAdminVo
     */
    'price'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialGoodsAdminVo
     */
    'giftPoints'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialGoodsAdminVo
     */
    'stock'?: number;
    /**
     *
     * @type {boolean}
     * @memberof PartialGoodsAdminVo
     */
    'isOnSale'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PartialGoodsAdminVo
     */
    'isPointsExchange'?: boolean;
    /**
     *
     * @type {Array<GoodsSpecSpe>}
     * @memberof PartialGoodsAdminVo
     */
    'specs'?: Array<GoodsSpecSpe>;
    /**
     *
     * @type {number}
     * @memberof PartialGoodsAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialGoodsAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialInviteRuleSpe
 */
export interface PartialInviteRuleSpe {
    /**
     *
     * @type {string}
     * @memberof PartialInviteRuleSpe
     */
    'points'?: string;
}
/**
 *
 * @export
 * @interface PartialOrderDesktopAdminVo
 */
export interface PartialOrderDesktopAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialOrderDesktopAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialOrderDesktopAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialOrderDesktopAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialOrderDesktopAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialPointsApplyAdminVo
 */
export interface PartialPointsApplyAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialPointsApplyAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialPointsApplyAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {POINTSAPPLYTYPEE}
     * @memberof PartialPointsApplyAdminVo
     */
    'type'?: POINTSAPPLYTYPEE;
    /**
     *
     * @type {string}
     * @memberof PartialPointsApplyAdminVo
     */
    'points'?: string;
    /**
     *
     * @type {POINTSAPPLYSTATUSE}
     * @memberof PartialPointsApplyAdminVo
     */
    'status'?: POINTSAPPLYSTATUSE;
    /**
     *
     * @type {string}
     * @memberof PartialPointsApplyAdminVo
     */
    'statusTime'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialPointsApplyAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialPointsApplyAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}


/**
 *
 * @export
 * @interface PartialPointsRecordAdminVo
 */
export interface PartialPointsRecordAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialPointsRecordAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialPointsRecordAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialPointsRecordAdminVo
     */
    'amount'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialPointsRecordAdminVo
     */
    'reason'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialPointsRecordAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialPointsRecordAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface PartialPointsRuleSpe
 */
export interface PartialPointsRuleSpe {
    /**
     *
     * @type {string}
     * @memberof PartialPointsRuleSpe
     */
    'localToPoints'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialPointsRuleSpe
     */
    'localToCoins'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialPointsRuleSpe
     */
    'limitPoints'?: string;
}
/**
 *
 * @export
 * @interface PartialRechargeAdminVo
 */
export interface PartialRechargeAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialRechargeAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialRechargeAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialRechargeAdminVo
     */
    'price'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialRechargeAdminVo
     */
    'coins'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialRechargeAdminVo
     */
    'giftPoints'?: string;
    /**
     *
     * @type {number}
     * @memberof PartialRechargeAdminVo
     */
    'giftCouponTypeId'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialRechargeAdminVo
     */
    'giftCouponCount'?: number;
    /**
     *
     * @type {CouponTypeAdminVo}
     * @memberof PartialRechargeAdminVo
     */
    'giftCouponType'?: CouponTypeAdminVo;
    /**
     *
     * @type {boolean}
     * @memberof PartialRechargeAdminVo
     */
    'visible'?: boolean;
    /**
     *
     * @type {string}
     * @memberof PartialRechargeAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialSignRuleSpe
 */
export interface PartialSignRuleSpe {
    /**
     *
     * @type {string}
     * @memberof PartialSignRuleSpe
     */
    'points'?: string;
}
/**
 *
 * @export
 * @interface PartialStoreNoticeSpe
 */
export interface PartialStoreNoticeSpe {
    /**
     *
     * @type {string}
     * @memberof PartialStoreNoticeSpe
     */
    'store'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialStoreNoticeSpe
     */
    'rule'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialStoreNoticeSpe
     */
    'todayActivity'?: string;
}
/**
 *
 * @export
 * @interface PartialTestAdminVo
 */
export interface PartialTestAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialTestAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialTestAdminVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialTestAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialTestAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialUserAdminVo
 */
export interface PartialUserAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialUserAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialUserAdminVo
     */
    'phone'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialUserAdminVo
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialUserAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {UserMetaSpe}
     * @memberof PartialUserAdminVo
     */
    'meta'?: UserMetaSpe;
    /**
     *
     * @type {Array<string>}
     * @memberof PartialUserAdminVo
     */
    'roleKeys'?: Array<string>;
    /**
     *
     * @type {Array<number>}
     * @memberof PartialUserAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof PartialUserAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface PartialUserLevelRuleSpe
 */
export interface PartialUserLevelRuleSpe {
    /**
     *
     * @type {string}
     * @memberof PartialUserLevelRuleSpe
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialUserLevelRuleSpe
     */
    'color'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialUserLevelRuleSpe
     */
    'growthValue'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialUserLevelRuleSpe
     */
    'discount'?: string;
}
/**
 *
 * @export
 * @interface PartialWaitingDeskAdminVo
 */
export interface PartialWaitingDeskAdminVo {
    /**
     *
     * @type {number}
     * @memberof PartialWaitingDeskAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PartialWaitingDeskAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {string}
     * @memberof PartialWaitingDeskAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PartialWaitingDeskAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface PartialWifiSpe
 */
export interface PartialWifiSpe {
    /**
     *
     * @type {string}
     * @memberof PartialWifiSpe
     */
    'ssid'?: string;
    /**
     *
     * @type {string}
     * @memberof PartialWifiSpe
     */
    'password'?: string;
}
/**
 *
 * @export
 * @interface PlaceOrderVo
 */
export interface PlaceOrderVo {
    /**
     *
     * @type {Array<OrderItemVo>}
     * @memberof PlaceOrderVo
     */
    'items': Array<OrderItemVo>;
    /**
     *
     * @type {BILLPAYTYPEE}
     * @memberof PlaceOrderVo
     */
    'payType': BILLPAYTYPEE;
    /**
     *
     * @type {number}
     * @memberof PlaceOrderVo
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof PlaceOrderVo
     */
    'seatNumber': number;
}


/**
 *
 * @export
 * @interface PointsApplyAdminVo
 */
export interface PointsApplyAdminVo {
    /**
     *
     * @type {number}
     * @memberof PointsApplyAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PointsApplyAdminVo
     */
    'userId'?: number;
    /**
     *
     * @type {POINTSAPPLYTYPEE}
     * @memberof PointsApplyAdminVo
     */
    'type': POINTSAPPLYTYPEE;
    /**
     *
     * @type {string}
     * @memberof PointsApplyAdminVo
     */
    'points': string;
    /**
     *
     * @type {POINTSAPPLYSTATUSE}
     * @memberof PointsApplyAdminVo
     */
    'status'?: POINTSAPPLYSTATUSE;
    /**
     *
     * @type {string}
     * @memberof PointsApplyAdminVo
     */
    'statusTime'?: string;
    /**
     *
     * @type {string}
     * @memberof PointsApplyAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PointsApplyAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}


/**
 *
 * @export
 * @interface PointsRecordAdminVo
 */
export interface PointsRecordAdminVo {
    /**
     *
     * @type {number}
     * @memberof PointsRecordAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof PointsRecordAdminVo
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof PointsRecordAdminVo
     */
    'amount': string;
    /**
     *
     * @type {string}
     * @memberof PointsRecordAdminVo
     */
    'reason': string;
    /**
     *
     * @type {string}
     * @memberof PointsRecordAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof PointsRecordAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface PointsRuleSpe
 */
export interface PointsRuleSpe {
    /**
     *
     * @type {string}
     * @memberof PointsRuleSpe
     */
    'localToPoints': string;
    /**
     *
     * @type {string}
     * @memberof PointsRuleSpe
     */
    'localToCoins': string;
    /**
     *
     * @type {string}
     * @memberof PointsRuleSpe
     */
    'limitPoints': string;
}
/**
 *
 * @export
 * @interface RechargeAdminVo
 */
export interface RechargeAdminVo {
    /**
     *
     * @type {number}
     * @memberof RechargeAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof RechargeAdminVo
     */
    'sequence'?: number;
    /**
     *
     * @type {string}
     * @memberof RechargeAdminVo
     */
    'price': string;
    /**
     *
     * @type {string}
     * @memberof RechargeAdminVo
     */
    'coins': string;
    /**
     *
     * @type {string}
     * @memberof RechargeAdminVo
     */
    'giftPoints'?: string;
    /**
     *
     * @type {number}
     * @memberof RechargeAdminVo
     */
    'giftCouponTypeId'?: number;
    /**
     *
     * @type {number}
     * @memberof RechargeAdminVo
     */
    'giftCouponCount'?: number;
    /**
     *
     * @type {CouponTypeAdminVo}
     * @memberof RechargeAdminVo
     */
    'giftCouponType'?: CouponTypeAdminVo;
    /**
     *
     * @type {boolean}
     * @memberof RechargeAdminVo
     */
    'visible'?: boolean;
    /**
     *
     * @type {string}
     * @memberof RechargeAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface RechargeBillGoodsSnapshotSpe
 */
export interface RechargeBillGoodsSnapshotSpe {
    /**
     *
     * @type {number}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'rechargeId': number;
    /**
     *
     * @type {string}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'price': string;
    /**
     *
     * @type {string}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'coins': string;
    /**
     *
     * @type {string}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'giftPoints'?: string;
    /**
     *
     * @type {number}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'giftCouponTypeId'?: number;
    /**
     *
     * @type {number}
     * @memberof RechargeBillGoodsSnapshotSpe
     */
    'giftCouponCount'?: number;
}
/**
 *
 * @export
 * @interface ResultVo
 */
export interface ResultVo {
    /**
     *
     * @type {boolean}
     * @memberof ResultVo
     */
    'success': boolean;
    /**
     *
     * @type {string}
     * @memberof ResultVo
     */
    'msg'?: string;
    /**
     *
     * @type {any}
     * @memberof ResultVo
     */
    'data'?: any;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SEATSTATUSE = {
    Idle: 'idle',
    Reserved: 'reserved',
    Playing: 'playing'
} as const;

export type SEATSTATUSE = typeof SEATSTATUSE[keyof typeof SEATSTATUSE];


/**
 *
 * @export
 * @interface SeatSpe
 */
export interface SeatSpe {
    /**
     *
     * @type {number}
     * @memberof SeatSpe
     */
    'seatNumber': number;
    /**
     *
     * @type {number}
     * @memberof SeatSpe
     */
    'userId'?: number;
    /**
     *
     * @type {SEATSTATUSE}
     * @memberof SeatSpe
     */
    'status': SEATSTATUSE;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof SeatSpe
     */
    'userInfo'?: SeatUserInfoSpe;
}


/**
 *
 * @export
 * @interface SeatUserInfoSpe
 */
export interface SeatUserInfoSpe {
    /**
     *
     * @type {string}
     * @memberof SeatUserInfoSpe
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof SeatUserInfoSpe
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof SeatUserInfoSpe
     */
    'phone'?: string;
}
/**
 *
 * @export
 * @interface SelectedGoodsSpecSpe
 */
export interface SelectedGoodsSpecSpe {
    /**
     *
     * @type {string}
     * @memberof SelectedGoodsSpecSpe
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof SelectedGoodsSpecSpe
     */
    'value': string;
}
/**
 *
 * @export
 * @interface SignRuleSpe
 */
export interface SignRuleSpe {
    /**
     *
     * @type {string}
     * @memberof SignRuleSpe
     */
    'points': string;
}
/**
 *
 * @export
 * @interface StoreNoticeSpe
 */
export interface StoreNoticeSpe {
    /**
     *
     * @type {string}
     * @memberof StoreNoticeSpe
     */
    'store'?: string;
    /**
     *
     * @type {string}
     * @memberof StoreNoticeSpe
     */
    'rule'?: string;
    /**
     *
     * @type {string}
     * @memberof StoreNoticeSpe
     */
    'todayActivity'?: string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject1
 */
export interface SystemGenerateObject1 {
    /**
     *
     * @type {PartialBaseApiAdminVo}
     * @memberof SystemGenerateObject1
     */
    'conditions': PartialBaseApiAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject10
 */
export interface SystemGenerateObject10 {
    /**
     *
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject10
     */
    'conditions': PartialBaseRoleAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject100
 */
export interface SystemGenerateObject100 {
    /**
     *
     * @type {PartialCoinsRecordAdminVo}
     * @memberof SystemGenerateObject100
     */
    'recordAdminVo': PartialCoinsRecordAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject101
 */
export interface SystemGenerateObject101 {
    /**
     *
     * @type {UserLevelRuleSpe}
     * @memberof SystemGenerateObject101
     */
    'rule': UserLevelRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject102
 */
export interface SystemGenerateObject102 {
    /**
     *
     * @type {PartialUserLevelRuleSpe}
     * @memberof SystemGenerateObject102
     */
    'rule': PartialUserLevelRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject103
 */
export interface SystemGenerateObject103 {
    /**
     *
     * @type {Array<UserLevelRuleSpe>}
     * @memberof SystemGenerateObject103
     */
    'rules': Array<UserLevelRuleSpe>;
}
/**
 *
 * @export
 * @interface SystemGenerateObject104
 */
export interface SystemGenerateObject104 {
    /**
     *
     * @type {PointsRuleSpe}
     * @memberof SystemGenerateObject104
     */
    'rule': PointsRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject105
 */
export interface SystemGenerateObject105 {
    /**
     *
     * @type {PartialPointsRuleSpe}
     * @memberof SystemGenerateObject105
     */
    'rule': PartialPointsRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject106
 */
export interface SystemGenerateObject106 {
    /**
     *
     * @type {InviteRuleSpe}
     * @memberof SystemGenerateObject106
     */
    'rule': InviteRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject107
 */
export interface SystemGenerateObject107 {
    /**
     *
     * @type {PartialInviteRuleSpe}
     * @memberof SystemGenerateObject107
     */
    'rule': PartialInviteRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject108
 */
export interface SystemGenerateObject108 {
    /**
     *
     * @type {SignRuleSpe}
     * @memberof SystemGenerateObject108
     */
    'rule': SignRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject109
 */
export interface SystemGenerateObject109 {
    /**
     *
     * @type {PartialSignRuleSpe}
     * @memberof SystemGenerateObject109
     */
    'rule': PartialSignRuleSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject11
 */
export interface SystemGenerateObject11 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject11
     */
    'userId': number;
    /**
     *
     * @type {Array<BaseUserRoleAdminVo>}
     * @memberof SystemGenerateObject11
     */
    'userRoleVos': Array<BaseUserRoleAdminVo>;
}
/**
 *
 * @export
 * @interface SystemGenerateObject110
 */
export interface SystemGenerateObject110 {
    /**
     *
     * @type {WifiSpe}
     * @memberof SystemGenerateObject110
     */
    'wifi': WifiSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject111
 */
export interface SystemGenerateObject111 {
    /**
     *
     * @type {PartialWifiSpe}
     * @memberof SystemGenerateObject111
     */
    'wifi': PartialWifiSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject112
 */
export interface SystemGenerateObject112 {
    /**
     *
     * @type {PartialRechargeAdminVo}
     * @memberof SystemGenerateObject112
     */
    'conditions': PartialRechargeAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject112
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject113
 */
export interface SystemGenerateObject113 {
    /**
     *
     * @type {PartialRechargeAdminVo}
     * @memberof SystemGenerateObject113
     */
    'conditions': PartialRechargeAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject113
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject113
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject114
 */
export interface SystemGenerateObject114 {
    /**
     *
     * @type {RechargeAdminVo}
     * @memberof SystemGenerateObject114
     */
    'rechargeAdminVo': RechargeAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject115
 */
export interface SystemGenerateObject115 {
    /**
     *
     * @type {PartialRechargeAdminVo}
     * @memberof SystemGenerateObject115
     */
    'rechargeAdminVo': PartialRechargeAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject116
 */
export interface SystemGenerateObject116 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject116
     */
    'rechargeId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject117
 */
export interface SystemGenerateObject117 {
    /**
     *
     * @type {PartialPointsApplyAdminVo}
     * @memberof SystemGenerateObject117
     */
    'conditions': PartialPointsApplyAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject117
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject118
 */
export interface SystemGenerateObject118 {
    /**
     *
     * @type {PartialPointsApplyAdminVo}
     * @memberof SystemGenerateObject118
     */
    'conditions': PartialPointsApplyAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject118
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject118
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject119
 */
export interface SystemGenerateObject119 {
    /**
     *
     * @type {PartialPointsApplyAdminVo}
     * @memberof SystemGenerateObject119
     */
    'conditions': PartialPointsApplyAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject119
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject119
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject12
 */
export interface SystemGenerateObject12 {
    /**
     *
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject12
     */
    'conditions': PartialBaseRoleAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject120
 */
export interface SystemGenerateObject120 {
    /**
     *
     * @type {PointsApplyAdminVo}
     * @memberof SystemGenerateObject120
     */
    'applyAdminVo': PointsApplyAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject121
 */
export interface SystemGenerateObject121 {
    /**
     *
     * @type {PartialPointsApplyAdminVo}
     * @memberof SystemGenerateObject121
     */
    'applyAdminVo': PartialPointsApplyAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject122
 */
export interface SystemGenerateObject122 {
    /**
     *
     * @type {POINTSAPPLYSTATUSE}
     * @memberof SystemGenerateObject122
     */
    'status': POINTSAPPLYSTATUSE;
    /**
     *
     * @type {POINTSCONVERTTYPEE}
     * @memberof SystemGenerateObject122
     */
    'convertType'?: POINTSCONVERTTYPEE;
}


/**
 *
 * @export
 * @interface SystemGenerateObject123
 */
export interface SystemGenerateObject123 {
    /**
     *
     * @type {StoreNoticeSpe}
     * @memberof SystemGenerateObject123
     */
    'storeNotice': StoreNoticeSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject124
 */
export interface SystemGenerateObject124 {
    /**
     *
     * @type {PartialStoreNoticeSpe}
     * @memberof SystemGenerateObject124
     */
    'storeNotice': PartialStoreNoticeSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject125
 */
export interface SystemGenerateObject125 {
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject125
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject125
     */
    'endDate': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject126
 */
export interface SystemGenerateObject126 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject126
     */
    'year': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject127
 */
export interface SystemGenerateObject127 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject127
     */
    'year': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject128
 */
export interface SystemGenerateObject128 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject128
     */
    'startYear': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject128
     */
    'endYear': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject129
 */
export interface SystemGenerateObject129 {
    /**
     *
     * @type {PartialOrderDesktopAdminVo}
     * @memberof SystemGenerateObject129
     */
    'conditions': PartialOrderDesktopAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject13
 */
export interface SystemGenerateObject13 {
    /**
     *
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject13
     */
    'conditions': PartialBaseRoleAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject13
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject130
 */
export interface SystemGenerateObject130 {
    /**
     *
     * @type {PartialOrderDesktopAdminVo}
     * @memberof SystemGenerateObject130
     */
    'conditions': PartialOrderDesktopAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject130
     */
    'pageQuery': PageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject131
 */
export interface SystemGenerateObject131 {
    /**
     *
     * @type {OrderDesktopAdminVo}
     * @memberof SystemGenerateObject131
     */
    'adminVo': OrderDesktopAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject132
 */
export interface SystemGenerateObject132 {
    /**
     *
     * @type {PartialOrderDesktopAdminVo}
     * @memberof SystemGenerateObject132
     */
    'adminVo': PartialOrderDesktopAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject14
 */
export interface SystemGenerateObject14 {
    /**
     *
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject14
     */
    'conditions': PartialBaseUserAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject15
 */
export interface SystemGenerateObject15 {
    /**
     *
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject15
     */
    'conditions': PartialBaseUserAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject15
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject16
 */
export interface SystemGenerateObject16 {
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject16
     */
    'oldPw': string;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject16
     */
    'newPw': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject17
 */
export interface SystemGenerateObject17 {
    /**
     *
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject17
     */
    'conditions': PartialBaseOrganizationAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject18
 */
export interface SystemGenerateObject18 {
    /**
     *
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject18
     */
    'conditions': PartialBaseOrganizationAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject18
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject19
 */
export interface SystemGenerateObject19 {
    /**
     *
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject19
     */
    'conditions': PartialBaseLogAdminVo;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject19
     */
    'id': number;
    /**
     *
     * @type {boolean}
     * @memberof SystemGenerateObject19
     */
    'isGreater': boolean;
}
/**
 *
 * @export
 * @interface SystemGenerateObject2
 */
export interface SystemGenerateObject2 {
    /**
     *
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject2
     */
    'conditions': PartialBaseMenuAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject20
 */
export interface SystemGenerateObject20 {
    /**
     *
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject20
     */
    'conditions': PartialBaseLogAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject21
 */
export interface SystemGenerateObject21 {
    /**
     *
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject21
     */
    'conditions': PartialBaseLogAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject21
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject22
 */
export interface SystemGenerateObject22 {
    /**
     *
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject22
     */
    'conditions': PartialBaseDictionaryAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject23
 */
export interface SystemGenerateObject23 {
    /**
     *
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject23
     */
    'conditions': PartialBaseDictionaryAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject23
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject24
 */
export interface SystemGenerateObject24 {
    /**
     *
     * @type {PartialBaseTenantAdminVo}
     * @memberof SystemGenerateObject24
     */
    'conditions': PartialBaseTenantAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject24
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject25
 */
export interface SystemGenerateObject25 {
    /**
     *
     * @type {PartialTestAdminVo}
     * @memberof SystemGenerateObject25
     */
    'conditions': PartialTestAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject25
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject26
 */
export interface SystemGenerateObject26 {
    /**
     *
     * @type {PartialTestAdminVo}
     * @memberof SystemGenerateObject26
     */
    'conditions': PartialTestAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject26
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject26
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject27
 */
export interface SystemGenerateObject27 {
    /**
     *
     * @type {TestAdminVo}
     * @memberof SystemGenerateObject27
     */
    'testAdminVo': TestAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject28
 */
export interface SystemGenerateObject28 {
    /**
     *
     * @type {PartialTestAdminVo}
     * @memberof SystemGenerateObject28
     */
    'testAdminVo': PartialTestAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject3
 */
export interface SystemGenerateObject3 {
    /**
     *
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject3
     */
    'conditions': PartialBaseMenuAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject3
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject30
 */
export interface SystemGenerateObject30 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject30
     */
    'conditions': PartialBillAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject31
 */
export interface SystemGenerateObject31 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject31
     */
    'conditions': PartialBillAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject31
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject32
 */
export interface SystemGenerateObject32 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject32
     */
    'conditions': PartialBillAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject32
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject32
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject33
 */
export interface SystemGenerateObject33 {
    /**
     *
     * @type {BillAdminVo}
     * @memberof SystemGenerateObject33
     */
    'billAdminVo': BillAdminVo;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject33
     */
    'openid': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject34
 */
export interface SystemGenerateObject34 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject34
     */
    'billAdminVo': PartialBillAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject35
 */
export interface SystemGenerateObject35 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject35
     */
    'billId': number;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject35
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject36
 */
export interface SystemGenerateObject36 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject36
     */
    'conditions': PartialBillAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject37
 */
export interface SystemGenerateObject37 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject37
     */
    'conditions': PartialBillAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject37
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject38
 */
export interface SystemGenerateObject38 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject38
     */
    'conditions': PartialBillAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject38
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject38
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject39
 */
export interface SystemGenerateObject39 {
    /**
     *
     * @type {BillAdminVo}
     * @memberof SystemGenerateObject39
     */
    'billAdminVo': BillAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject4
 */
export interface SystemGenerateObject4 {
    /**
     *
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject4
     */
    'conditions': PartialBaseOperateAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject40
 */
export interface SystemGenerateObject40 {
    /**
     *
     * @type {PartialBillAdminVo}
     * @memberof SystemGenerateObject40
     */
    'billAdminVo': PartialBillAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject41
 */
export interface SystemGenerateObject41 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject41
     */
    'billId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject42
 */
export interface SystemGenerateObject42 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject42
     */
    'userId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject43
 */
export interface SystemGenerateObject43 {
    /**
     *
     * @type {PartialUserAdminVo}
     * @memberof SystemGenerateObject43
     */
    'conditions': PartialUserAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject43
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject44
 */
export interface SystemGenerateObject44 {
    /**
     *
     * @type {UserAdminVo}
     * @memberof SystemGenerateObject44
     */
    'userVo': UserAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject45
 */
export interface SystemGenerateObject45 {
    /**
     *
     * @type {UserAdminVo}
     * @memberof SystemGenerateObject45
     */
    'userVo': UserAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject46
 */
export interface SystemGenerateObject46 {
    /**
     *
     * @type {UpdateProfileVo}
     * @memberof SystemGenerateObject46
     */
    'updateProfileVo': UpdateProfileVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject47
 */
export interface SystemGenerateObject47 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject47
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'amount': string;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'reason': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject48
 */
export interface SystemGenerateObject48 {
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'loginCode': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject49
 */
export interface SystemGenerateObject49 {
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'loginCode': string;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'phoneCode': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject5
 */
export interface SystemGenerateObject5 {
    /**
     *
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject5
     */
    'conditions': PartialBaseOperateAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject5
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject50
 */
export interface SystemGenerateObject50 {
    /**
     *
     * @type {PartialCategoryAdminVo}
     * @memberof SystemGenerateObject50
     */
    'conditions': PartialCategoryAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject50
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject51
 */
export interface SystemGenerateObject51 {
    /**
     *
     * @type {PartialCategoryAdminVo}
     * @memberof SystemGenerateObject51
     */
    'conditions': PartialCategoryAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject51
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject51
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject52
 */
export interface SystemGenerateObject52 {
    /**
     *
     * @type {CategoryAdminVo}
     * @memberof SystemGenerateObject52
     */
    'categoryAdminVo': CategoryAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject53
 */
export interface SystemGenerateObject53 {
    /**
     *
     * @type {PartialCategoryAdminVo}
     * @memberof SystemGenerateObject53
     */
    'categoryAdminVo': PartialCategoryAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject54
 */
export interface SystemGenerateObject54 {
    /**
     *
     * @type {PartialGoodsAdminVo}
     * @memberof SystemGenerateObject54
     */
    'conditions': PartialGoodsAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject54
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject55
 */
export interface SystemGenerateObject55 {
    /**
     *
     * @type {PartialGoodsAdminVo}
     * @memberof SystemGenerateObject55
     */
    'conditions': PartialGoodsAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject55
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject55
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject56
 */
export interface SystemGenerateObject56 {
    /**
     *
     * @type {GoodsAdminVo}
     * @memberof SystemGenerateObject56
     */
    'goodsAdminVo': GoodsAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject57
 */
export interface SystemGenerateObject57 {
    /**
     *
     * @type {PartialGoodsAdminVo}
     * @memberof SystemGenerateObject57
     */
    'goodsAdminVo': PartialGoodsAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject58
 */
export interface SystemGenerateObject58 {
    /**
     *
     * @type {PlaceOrderVo}
     * @memberof SystemGenerateObject58
     */
    'placeOrderVo': PlaceOrderVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject59
 */
export interface SystemGenerateObject59 {
    /**
     *
     * @type {PartialDesktopAdminVo}
     * @memberof SystemGenerateObject59
     */
    'conditions': PartialDesktopAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject59
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject6
 */
export interface SystemGenerateObject6 {
    /**
     *
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject6
     */
    'conditions': PartialBaseRouteAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject60
 */
export interface SystemGenerateObject60 {
    /**
     *
     * @type {PartialDesktopAdminVo}
     * @memberof SystemGenerateObject60
     */
    'conditions': PartialDesktopAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject60
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject60
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject61
 */
export interface SystemGenerateObject61 {
    /**
     *
     * @type {DesktopAdminVo}
     * @memberof SystemGenerateObject61
     */
    'desktopAdminVo': DesktopAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject62
 */
export interface SystemGenerateObject62 {
    /**
     *
     * @type {PartialDesktopAdminVo}
     * @memberof SystemGenerateObject62
     */
    'desktopAdminVo': PartialDesktopAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject63
 */
export interface SystemGenerateObject63 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject63
     */
    'desktopId': number;
    /**
     *
     * @type {SeatSpe}
     * @memberof SystemGenerateObject63
     */
    'seat': SeatSpe;
}
/**
 *
 * @export
 * @interface SystemGenerateObject64
 */
export interface SystemGenerateObject64 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject64
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject64
     */
    'seatNumber': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject65
 */
export interface SystemGenerateObject65 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject65
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject65
     */
    'seatNumber': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject66
 */
export interface SystemGenerateObject66 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject66
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject66
     */
    'seatNumber': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject66
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof SystemGenerateObject66
     */
    'points': string;
}
/**
 *
 * @export
 * @interface SystemGenerateObject67
 */
export interface SystemGenerateObject67 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject67
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject67
     */
    'seatNumber': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject67
     */
    'userId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject68
 */
export interface SystemGenerateObject68 {
    /**
     *
     * @type {PartialCouponTypeAdminVo}
     * @memberof SystemGenerateObject68
     */
    'conditions': PartialCouponTypeAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject68
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject69
 */
export interface SystemGenerateObject69 {
    /**
     *
     * @type {PartialCouponTypeAdminVo}
     * @memberof SystemGenerateObject69
     */
    'conditions': PartialCouponTypeAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject69
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject69
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject7
 */
export interface SystemGenerateObject7 {
    /**
     *
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject7
     */
    'conditions': PartialBaseRouteAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject7
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject70
 */
export interface SystemGenerateObject70 {
    /**
     *
     * @type {CouponTypeAdminVo}
     * @memberof SystemGenerateObject70
     */
    'couponTypeAdminVo': CouponTypeAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject71
 */
export interface SystemGenerateObject71 {
    /**
     *
     * @type {PartialCouponTypeAdminVo}
     * @memberof SystemGenerateObject71
     */
    'couponTypeAdminVo': PartialCouponTypeAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject72
 */
export interface SystemGenerateObject72 {
    /**
     *
     * @type {PartialCouponAdminVo}
     * @memberof SystemGenerateObject72
     */
    'conditions': PartialCouponAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject72
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject73
 */
export interface SystemGenerateObject73 {
    /**
     *
     * @type {PartialCouponAdminVo}
     * @memberof SystemGenerateObject73
     */
    'conditions': PartialCouponAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject73
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject73
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject74
 */
export interface SystemGenerateObject74 {
    /**
     *
     * @type {CouponAdminVo}
     * @memberof SystemGenerateObject74
     */
    'couponAdminVo': CouponAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject75
 */
export interface SystemGenerateObject75 {
    /**
     *
     * @type {PartialCouponAdminVo}
     * @memberof SystemGenerateObject75
     */
    'couponAdminVo': PartialCouponAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject76
 */
export interface SystemGenerateObject76 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject76
     */
    'couponId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject77
 */
export interface SystemGenerateObject77 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject77
     */
    'couponId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject77
     */
    'desktopId'?: number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject77
     */
    'seatNumber'?: number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject78
 */
export interface SystemGenerateObject78 {
    /**
     *
     * @type {PartialCouponAdminVo}
     * @memberof SystemGenerateObject78
     */
    'conditions': PartialCouponAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject78
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject79
 */
export interface SystemGenerateObject79 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject79
     */
    'couponId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject79
     */
    'desktopId': number;
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject79
     */
    'seatNumber': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject8
 */
export interface SystemGenerateObject8 {
    /**
     *
     * @type {PartialBaseScheduleAdminVo}
     * @memberof SystemGenerateObject8
     */
    'conditions': PartialBaseScheduleAdminVo;
    /**
     *
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject8
     */
    'pageQuery': BasePageQueryVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject80
 */
export interface SystemGenerateObject80 {
    /**
     *
     * @type {PartialWaitingDeskAdminVo}
     * @memberof SystemGenerateObject80
     */
    'conditions': PartialWaitingDeskAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject80
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject81
 */
export interface SystemGenerateObject81 {
    /**
     *
     * @type {PartialWaitingDeskAdminVo}
     * @memberof SystemGenerateObject81
     */
    'conditions': PartialWaitingDeskAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject81
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject81
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject82
 */
export interface SystemGenerateObject82 {
    /**
     *
     * @type {WaitingDeskAdminVo}
     * @memberof SystemGenerateObject82
     */
    'waitingDeskAdminVo': WaitingDeskAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject83
 */
export interface SystemGenerateObject83 {
    /**
     *
     * @type {PartialWaitingDeskAdminVo}
     * @memberof SystemGenerateObject83
     */
    'waitingDeskAdminVo': PartialWaitingDeskAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject84
 */
export interface SystemGenerateObject84 {
    /**
     *
     * @type {PartialConfigAdminVo}
     * @memberof SystemGenerateObject84
     */
    'conditions': PartialConfigAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject84
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject85
 */
export interface SystemGenerateObject85 {
    /**
     *
     * @type {PartialConfigAdminVo}
     * @memberof SystemGenerateObject85
     */
    'conditions': PartialConfigAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject85
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject85
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject86
 */
export interface SystemGenerateObject86 {
    /**
     *
     * @type {ConfigAdminVo}
     * @memberof SystemGenerateObject86
     */
    'configAdminVo': ConfigAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject87
 */
export interface SystemGenerateObject87 {
    /**
     *
     * @type {PartialConfigAdminVo}
     * @memberof SystemGenerateObject87
     */
    'configAdminVo': PartialConfigAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject88
 */
export interface SystemGenerateObject88 {
    /**
     *
     * @type {PartialBenefitAdminVo}
     * @memberof SystemGenerateObject88
     */
    'conditions': PartialBenefitAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject88
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject89
 */
export interface SystemGenerateObject89 {
    /**
     *
     * @type {PartialBenefitAdminVo}
     * @memberof SystemGenerateObject89
     */
    'conditions': PartialBenefitAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject89
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject89
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject90
 */
export interface SystemGenerateObject90 {
    /**
     *
     * @type {BenefitAdminVo}
     * @memberof SystemGenerateObject90
     */
    'benefitAdminVo': BenefitAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject91
 */
export interface SystemGenerateObject91 {
    /**
     *
     * @type {PartialBenefitAdminVo}
     * @memberof SystemGenerateObject91
     */
    'benefitAdminVo': PartialBenefitAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject92
 */
export interface SystemGenerateObject92 {
    /**
     *
     * @type {number}
     * @memberof SystemGenerateObject92
     */
    'benefitId': number;
}
/**
 *
 * @export
 * @interface SystemGenerateObject93
 */
export interface SystemGenerateObject93 {
    /**
     *
     * @type {PartialPointsRecordAdminVo}
     * @memberof SystemGenerateObject93
     */
    'conditions': PartialPointsRecordAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject93
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject94
 */
export interface SystemGenerateObject94 {
    /**
     *
     * @type {PartialPointsRecordAdminVo}
     * @memberof SystemGenerateObject94
     */
    'conditions': PartialPointsRecordAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject94
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject94
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject95
 */
export interface SystemGenerateObject95 {
    /**
     *
     * @type {PointsRecordAdminVo}
     * @memberof SystemGenerateObject95
     */
    'recordAdminVo': PointsRecordAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject96
 */
export interface SystemGenerateObject96 {
    /**
     *
     * @type {PartialPointsRecordAdminVo}
     * @memberof SystemGenerateObject96
     */
    'recordAdminVo': PartialPointsRecordAdminVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject97
 */
export interface SystemGenerateObject97 {
    /**
     *
     * @type {PartialCoinsRecordAdminVo}
     * @memberof SystemGenerateObject97
     */
    'conditions': PartialCoinsRecordAdminVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject97
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject98
 */
export interface SystemGenerateObject98 {
    /**
     *
     * @type {PartialCoinsRecordAdminVo}
     * @memberof SystemGenerateObject98
     */
    'conditions': PartialCoinsRecordAdminVo;
    /**
     *
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject98
     */
    'pageQuery': PageQueryVo;
    /**
     *
     * @type {TimeRangeVo}
     * @memberof SystemGenerateObject98
     */
    'timeRange'?: TimeRangeVo;
}
/**
 *
 * @export
 * @interface SystemGenerateObject99
 */
export interface SystemGenerateObject99 {
    /**
     *
     * @type {CoinsRecordAdminVo}
     * @memberof SystemGenerateObject99
     */
    'recordAdminVo': CoinsRecordAdminVo;
}
/**
 *
 * @export
 * @interface TestAdminVo
 */
export interface TestAdminVo {
    /**
     *
     * @type {number}
     * @memberof TestAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof TestAdminVo
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof TestAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {string}
     * @memberof TestAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface TimeRangeVo
 */
export interface TimeRangeVo {
    /**
     *
     * @type {string}
     * @memberof TimeRangeVo
     */
    'start'?: string;
    /**
     *
     * @type {string}
     * @memberof TimeRangeVo
     */
    'end'?: string;
    /**
     *
     * @type {string}
     * @memberof TimeRangeVo
     */
    'field'?: string;
}
/**
 *
 * @export
 * @interface UpdateProfileVo
 */
export interface UpdateProfileVo {
    /**
     *
     * @type {string}
     * @memberof UpdateProfileVo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileVo
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileVo
     */
    'inviteCode'?: string;
}
/**
 *
 * @export
 * @interface UserAdminVo
 */
export interface UserAdminVo {
    /**
     *
     * @type {number}
     * @memberof UserAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof UserAdminVo
     */
    'phone'?: number;
    /**
     *
     * @type {string}
     * @memberof UserAdminVo
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof UserAdminVo
     */
    'password'?: string;
    /**
     *
     * @type {UserMetaSpe}
     * @memberof UserAdminVo
     */
    'meta'?: UserMetaSpe;
    /**
     *
     * @type {Array<string>}
     * @memberof UserAdminVo
     */
    'roleKeys': Array<string>;
    /**
     *
     * @type {Array<number>}
     * @memberof UserAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof UserAdminVo
     */
    'createTime'?: string;
}
/**
 *
 * @export
 * @interface UserLevelRuleSpe
 */
export interface UserLevelRuleSpe {
    /**
     *
     * @type {string}
     * @memberof UserLevelRuleSpe
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof UserLevelRuleSpe
     */
    'color': string;
    /**
     *
     * @type {string}
     * @memberof UserLevelRuleSpe
     */
    'growthValue': string;
    /**
     *
     * @type {string}
     * @memberof UserLevelRuleSpe
     */
    'discount'?: string;
}
/**
 *
 * @export
 * @interface UserMetaSpe
 */
export interface UserMetaSpe {
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'avatar'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'phone'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'coins'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'points'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'growthValue'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'couponCount'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'inviteCode'?: string;
    /**
     *
     * @type {string}
     * @memberof UserMetaSpe
     */
    'profitPoints'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UserMetaSpe
     */
    'firstChargeEligible'?: boolean;
}
/**
 *
 * @export
 * @interface WaitingDeskAdminVo
 */
export interface WaitingDeskAdminVo {
    /**
     *
     * @type {number}
     * @memberof WaitingDeskAdminVo
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof WaitingDeskAdminVo
     */
    'userId': number;
    /**
     *
     * @type {string}
     * @memberof WaitingDeskAdminVo
     */
    'createTime'?: string;
    /**
     *
     * @type {SeatUserInfoSpe}
     * @memberof WaitingDeskAdminVo
     */
    'userInfo'?: SeatUserInfoSpe;
}
/**
 *
 * @export
 * @interface WifiSpe
 */
export interface WifiSpe {
    /**
     *
     * @type {string}
     * @memberof WifiSpe
     */
    'ssid': string;
    /**
     *
     * @type {string}
     * @memberof WifiSpe
     */
    'password': string;
}

/**
 * BaseApiApi - axios parameter creator
 * @export
 */
export const BaseApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi: async (systemGenerateObject1: SystemGenerateObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject1' is not null or undefined
            assertParamExists('listApisBaseApi', 'systemGenerateObject1', systemGenerateObject1)
            const localVarPath = `/__base/api/listApis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi: async (baseApiAdminVo: BaseApiAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseApiAdminVo' is not null or undefined
            assertParamExists('updateApiBaseApi', 'baseApiAdminVo', baseApiAdminVo)
            const localVarPath = `/__base/api/updateApi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseApiAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseApiApi - functional programming interface
 * @export
 */
export const BaseApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseApiApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApisBaseApi(systemGenerateObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiBaseApi(baseApiAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseApiApi - factory interface
 * @export
 */
export const BaseApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseApiApiFp(configuration)
    return {
        /**
         *
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: any): AxiosPromise<any> {
            return localVarFp.listApisBaseApi(systemGenerateObject1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateApiBaseApi(baseApiAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseApiApi - object-oriented interface
 * @export
 * @class BaseApiApi
 * @extends {BaseAPI}
 */
export class BaseApiApi extends BaseAPI {
    /**
     *
     * @summary 获取接口列表
     * @param {SystemGenerateObject1} systemGenerateObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).listApisBaseApi(systemGenerateObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改接口
     * @param {BaseApiAdminVo} baseApiAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).updateApiBaseApi(baseApiAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseConfigApi - axios parameter creator
 * @export
 */
export const BaseConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/config/getConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getValueBaseConfig', 'key', key)
            const localVarPath = `/__base/config/getValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig: async (body: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setValueBaseConfig', 'body', body)
            const localVarPath = `/__base/config/setValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseConfigApi - functional programming interface
 * @export
 */
export const BaseConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigBaseConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigBaseConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValueBaseConfig(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValueBaseConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setValueBaseConfig(body: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setValueBaseConfig(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseConfigApi - factory interface
 * @export
 */
export const BaseConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseConfigApiFp(configuration)
    return {
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig(options?: any): AxiosPromise<any> {
            return localVarFp.getConfigBaseConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getValueBaseConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig(body: any, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.setValueBaseConfig(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseConfigApi - object-oriented interface
 * @export
 * @class BaseConfigApi
 * @extends {BaseAPI}
 */
export class BaseConfigApi extends BaseAPI {
    /**
     * 获取系统完整配置信息
     * @summary 获取完整配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getConfigBaseConfig(options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getConfigBaseConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key获取单个配置项的值
     * @summary 获取配置项
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getValueBaseConfig(key: string, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getValueBaseConfig(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key设置单个配置项的值
     * @summary 设置配置项
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public setValueBaseConfig(body: any, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).setValueBaseConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseDictionaryApi - axios parameter creator
 * @export
 */
export const BaseDictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('addDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/addDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除字典
         * @param {number} dictionaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary: async (dictionaryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('delDictionaryBaseDictionary', 'dictionaryId', dictionaryId)
            const localVarPath = `/__base/dictionary/delDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dictionaryId !== undefined) {
                localVarQueryParameter['dictionaryId'] = dictionaryId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取单个字典
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getDictionaryBaseDictionary', 'key', key)
            const localVarPath = `/__base/dictionary/getDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取字典列表
         * @param {SystemGenerateObject22} systemGenerateObject22
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary: async (systemGenerateObject22: SystemGenerateObject22, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject22' is not null or undefined
            assertParamExists('listDictionaryBaseDictionary', 'systemGenerateObject22', systemGenerateObject22)
            const localVarPath = `/__base/dictionary/listDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject22, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject23} systemGenerateObject23
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary: async (systemGenerateObject23: SystemGenerateObject23, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject23' is not null or undefined
            assertParamExists('pageDictionaryBaseDictionary', 'systemGenerateObject23', systemGenerateObject23)
            const localVarPath = `/__base/dictionary/pageDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject23, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('updateDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/updateDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseDictionaryApi - functional programming interface
 * @export
 */
export const BaseDictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseDictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除字典
         * @param {number} dictionaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDictionaryBaseDictionary(dictionaryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取单个字典
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryBaseDictionary(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取字典列表
         * @param {SystemGenerateObject22} systemGenerateObject22
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDictionaryBaseDictionary(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDictionaryBaseDictionary(systemGenerateObject22, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject23} systemGenerateObject23
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDictionaryBaseDictionary(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDictionaryBaseDictionary(systemGenerateObject23, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseDictionaryApi - factory interface
 * @export
 */
export const BaseDictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseDictionaryApiFp(configuration)
    return {
        /**
         *
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除字典
         * @param {number} dictionaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary(dictionaryId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取单个字典
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDictionaryBaseDictionary(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取字典列表
         * @param {SystemGenerateObject22} systemGenerateObject22
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary(systemGenerateObject22: SystemGenerateObject22, options?: any): AxiosPromise<any> {
            return localVarFp.listDictionaryBaseDictionary(systemGenerateObject22, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject23} systemGenerateObject23
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary(systemGenerateObject23: SystemGenerateObject23, options?: any): AxiosPromise<any> {
            return localVarFp.pageDictionaryBaseDictionary(systemGenerateObject23, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseDictionaryApi - object-oriented interface
 * @export
 * @class BaseDictionaryApi
 * @extends {BaseAPI}
 */
export class BaseDictionaryApi extends BaseAPI {
    /**
     *
     * @summary 添加字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除字典
     * @param {number} dictionaryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取单个字典
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).getDictionaryBaseDictionary(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取字典列表
     * @param {SystemGenerateObject22} systemGenerateObject22
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public listDictionaryBaseDictionary(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).listDictionaryBaseDictionary(systemGenerateObject22, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取字典列表(分页)
     * @param {SystemGenerateObject23} systemGenerateObject23
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public pageDictionaryBaseDictionary(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).pageDictionaryBaseDictionary(systemGenerateObject23, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseLogApi - axios parameter creator
 * @export
 */
export const BaseLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取某个id的位置
         * @param {SystemGenerateObject19} systemGenerateObject19
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog: async (systemGenerateObject19: SystemGenerateObject19, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject19' is not null or undefined
            assertParamExists('getCountBaseLog', 'systemGenerateObject19', systemGenerateObject19)
            const localVarPath = `/__base/log/getCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject19, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject20} systemGenerateObject20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog: async (systemGenerateObject20: SystemGenerateObject20, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject20' is not null or undefined
            assertParamExists('listLogBaseLog', 'systemGenerateObject20', systemGenerateObject20)
            const localVarPath = `/__base/log/listLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject20, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject21} systemGenerateObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog: async (systemGenerateObject21: SystemGenerateObject21, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject21' is not null or undefined
            assertParamExists('pageLogBaseLog', 'systemGenerateObject21', systemGenerateObject21)
            const localVarPath = `/__base/log/pageLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject21, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseLogAdminVo} baseLogAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogBaseLog: async (baseLogAdminVo: BaseLogAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseLogAdminVo' is not null or undefined
            assertParamExists('updateLogBaseLog', 'baseLogAdminVo', baseLogAdminVo)
            const localVarPath = `/__base/log/updateLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseLogAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseLogApi - functional programming interface
 * @export
 */
export const BaseLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseLogApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取某个id的位置
         * @param {SystemGenerateObject19} systemGenerateObject19
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountBaseLog(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountBaseLog(systemGenerateObject19, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject20} systemGenerateObject20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLogBaseLog(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLogBaseLog(systemGenerateObject20, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject21} systemGenerateObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageLogBaseLog(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageLogBaseLog(systemGenerateObject21, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseLogAdminVo} baseLogAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLogBaseLog(baseLogAdminVo: BaseLogAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogBaseLog(baseLogAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseLogApi - factory interface
 * @export
 */
export const BaseLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseLogApiFp(configuration)
    return {
        /**
         *
         * @summary 获取某个id的位置
         * @param {SystemGenerateObject19} systemGenerateObject19
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog(systemGenerateObject19: SystemGenerateObject19, options?: any): AxiosPromise<any> {
            return localVarFp.getCountBaseLog(systemGenerateObject19, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject20} systemGenerateObject20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog(systemGenerateObject20: SystemGenerateObject20, options?: any): AxiosPromise<any> {
            return localVarFp.listLogBaseLog(systemGenerateObject20, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject21} systemGenerateObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog(systemGenerateObject21: SystemGenerateObject21, options?: any): AxiosPromise<any> {
            return localVarFp.pageLogBaseLog(systemGenerateObject21, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseLogAdminVo} baseLogAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogBaseLog(baseLogAdminVo: BaseLogAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateLogBaseLog(baseLogAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseLogApi - object-oriented interface
 * @export
 * @class BaseLogApi
 * @extends {BaseAPI}
 */
export class BaseLogApi extends BaseAPI {
    /**
     *
     * @summary 获取某个id的位置
     * @param {SystemGenerateObject19} systemGenerateObject19
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public getCountBaseLog(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).getCountBaseLog(systemGenerateObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取操作列表
     * @param {SystemGenerateObject20} systemGenerateObject20
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public listLogBaseLog(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).listLogBaseLog(systemGenerateObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject21} systemGenerateObject21
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public pageLogBaseLog(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).pageLogBaseLog(systemGenerateObject21, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改操作
     * @param {BaseLogAdminVo} baseLogAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public updateLogBaseLog(baseLogAdminVo: BaseLogAdminVo, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).updateLogBaseLog(baseLogAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseMenuApi - axios parameter creator
 * @export
 */
export const BaseMenuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('addMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/addMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除菜单
         * @param {number} menuId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu: async (menuId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('delMenuBaseMenu', 'menuId', menuId)
            const localVarPath = `/__base/menu/delMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/menu/gets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu: async (systemGenerateObject2: SystemGenerateObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject2' is not null or undefined
            assertParamExists('listMenusBaseMenu', 'systemGenerateObject2', systemGenerateObject2)
            const localVarPath = `/__base/menu/listMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu: async (systemGenerateObject3: SystemGenerateObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject3' is not null or undefined
            assertParamExists('pageMenusBaseMenu', 'systemGenerateObject3', systemGenerateObject3)
            const localVarPath = `/__base/menu/pageMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('updateMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/updateMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseMenuApi - functional programming interface
 * @export
 */
export const BaseMenuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseMenuApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除菜单
         * @param {number} menuId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMenuBaseMenu(menuId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getsBaseMenu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getsBaseMenu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenusBaseMenu(systemGenerateObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMenusBaseMenu(systemGenerateObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseMenuApi - factory interface
 * @export
 */
export const BaseMenuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseMenuApiFp(configuration)
    return {
        /**
         *
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除菜单
         * @param {number} menuId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu(menuId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMenuBaseMenu(menuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu(options?: any): AxiosPromise<any> {
            return localVarFp.getsBaseMenu(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: any): AxiosPromise<any> {
            return localVarFp.listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: any): AxiosPromise<any> {
            return localVarFp.pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseMenuApi - object-oriented interface
 * @export
 * @class BaseMenuApi
 * @extends {BaseAPI}
 */
export class BaseMenuApi extends BaseAPI {
    /**
     *
     * @summary 添加菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除菜单
     * @param {number} menuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).delMenuBaseMenu(menuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态菜单
     * @summary 获取动态菜单
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public getsBaseMenu(options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).getsBaseMenu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取菜单列表
     * @param {SystemGenerateObject2} systemGenerateObject2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取菜单列表(分页)
     * @param {SystemGenerateObject3} systemGenerateObject3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOperateApi - axios parameter creator
 * @export
 */
export const BaseOperateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('addOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/addOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除操作
         * @param {number} operateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate: async (operateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operateId' is not null or undefined
            assertParamExists('delOperateBaseOperate', 'operateId', operateId)
            const localVarPath = `/__base/operate/delOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operateId !== undefined) {
                localVarQueryParameter['operateId'] = operateId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/operate/getOperates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate: async (systemGenerateObject4: SystemGenerateObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject4' is not null or undefined
            assertParamExists('listOperateBaseOperate', 'systemGenerateObject4', systemGenerateObject4)
            const localVarPath = `/__base/operate/listOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate: async (systemGenerateObject5: SystemGenerateObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject5' is not null or undefined
            assertParamExists('pageOperateBaseOperate', 'systemGenerateObject5', systemGenerateObject5)
            const localVarPath = `/__base/operate/pageOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('updateOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/updateOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOperateApi - functional programming interface
 * @export
 */
export const BaseOperateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOperateApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除操作
         * @param {number} operateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOperateBaseOperate(operateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatesBaseOperate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatesBaseOperate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperateBaseOperate(systemGenerateObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOperateBaseOperate(systemGenerateObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOperateApi - factory interface
 * @export
 */
export const BaseOperateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOperateApiFp(configuration)
    return {
        /**
         *
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除操作
         * @param {number} operateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate(operateId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOperateBaseOperate(operateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate(options?: any): AxiosPromise<any> {
            return localVarFp.getOperatesBaseOperate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: any): AxiosPromise<any> {
            return localVarFp.listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: any): AxiosPromise<any> {
            return localVarFp.pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOperateApi - object-oriented interface
 * @export
 * @class BaseOperateApi
 * @extends {BaseAPI}
 */
export class BaseOperateApi extends BaseAPI {
    /**
     *
     * @summary 添加操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除操作
     * @param {number} operateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).delOperateBaseOperate(operateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取用户的操作列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public getOperatesBaseOperate(options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).getOperatesBaseOperate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取操作列表
     * @param {SystemGenerateObject4} systemGenerateObject4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject5} systemGenerateObject5
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOrganizationApi - axios parameter creator
 * @export
 */
export const BaseOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('addOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/addOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除组织
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('delOrganizationBaseOrganization', 'organizationId', organizationId)
            const localVarPath = `/__base/organization/delOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取组织列表
         * @param {SystemGenerateObject17} systemGenerateObject17
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization: async (systemGenerateObject17: SystemGenerateObject17, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject17' is not null or undefined
            assertParamExists('listOrganizationsBaseOrganization', 'systemGenerateObject17', systemGenerateObject17)
            const localVarPath = `/__base/organization/listOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject17, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject18} systemGenerateObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization: async (systemGenerateObject18: SystemGenerateObject18, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject18' is not null or undefined
            assertParamExists('pageOrganizationsBaseOrganization', 'systemGenerateObject18', systemGenerateObject18)
            const localVarPath = `/__base/organization/pageOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject18, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('udpateOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/udpateOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOrganizationApi - functional programming interface
 * @export
 */
export const BaseOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除组织
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOrganizationBaseOrganization(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOrganizationBaseOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取组织列表
         * @param {SystemGenerateObject17} systemGenerateObject17
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationsBaseOrganization(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationsBaseOrganization(systemGenerateObject17, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject18} systemGenerateObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganizationsBaseOrganization(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganizationsBaseOrganization(systemGenerateObject18, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOrganizationApi - factory interface
 * @export
 */
export const BaseOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOrganizationApiFp(configuration)
    return {
        /**
         *
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除组织
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization(organizationId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOrganizationBaseOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取组织列表
         * @param {SystemGenerateObject17} systemGenerateObject17
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization(systemGenerateObject17: SystemGenerateObject17, options?: any): AxiosPromise<any> {
            return localVarFp.listOrganizationsBaseOrganization(systemGenerateObject17, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject18} systemGenerateObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization(systemGenerateObject18: SystemGenerateObject18, options?: any): AxiosPromise<any> {
            return localVarFp.pageOrganizationsBaseOrganization(systemGenerateObject18, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOrganizationApi - object-oriented interface
 * @export
 * @class BaseOrganizationApi
 * @extends {BaseAPI}
 */
export class BaseOrganizationApi extends BaseAPI {
    /**
     *
     * @summary 添加组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除组织
     * @param {number} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public delOrganizationBaseOrganization(organizationId: number, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).delOrganizationBaseOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取组织列表
     * @param {SystemGenerateObject17} systemGenerateObject17
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public listOrganizationsBaseOrganization(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).listOrganizationsBaseOrganization(systemGenerateObject17, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取组织列表(分页)
     * @param {SystemGenerateObject18} systemGenerateObject18
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public pageOrganizationsBaseOrganization(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).pageOrganizationsBaseOrganization(systemGenerateObject18, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseRouteApi - axios parameter creator
 * @export
 */
export const BaseRouteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('addRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/addRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除路由
         * @param {number} routeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute: async (routeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            assertParamExists('deleteRoteBaseRoute', 'routeId', routeId)
            const localVarPath = `/__base/route/deleteRote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (routeId !== undefined) {
                localVarQueryParameter['routeId'] = routeId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getNoPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute: async (systemGenerateObject6: SystemGenerateObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject6' is not null or undefined
            assertParamExists('listRoutesBaseRoute', 'systemGenerateObject6', systemGenerateObject6)
            const localVarPath = `/__base/route/listRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute: async (systemGenerateObject7: SystemGenerateObject7, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject7' is not null or undefined
            assertParamExists('pageRoutesBaseRoute', 'systemGenerateObject7', systemGenerateObject7)
            const localVarPath = `/__base/route/pageRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject7, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('updateRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/updateRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseRouteApi - functional programming interface
 * @export
 */
export const BaseRouteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseRouteApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除路由
         * @param {number} routeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoteBaseRoute(routeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoutesBaseRoute(systemGenerateObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRoutesBaseRoute(systemGenerateObject7, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseRouteApi - factory interface
 * @export
 */
export const BaseRouteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseRouteApiFp(configuration)
    return {
        /**
         *
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除路由
         * @param {number} routeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute(routeId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteRoteBaseRoute(routeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getNoPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: any): AxiosPromise<any> {
            return localVarFp.listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: any): AxiosPromise<any> {
            return localVarFp.pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseRouteApi - object-oriented interface
 * @export
 * @class BaseRouteApi
 * @extends {BaseAPI}
 */
export class BaseRouteApi extends BaseAPI {
    /**
     *
     * @summary 添加路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除路由
     * @param {number} routeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).deleteRoteBaseRoute(routeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取无需授权的动态路由
     * @summary 获取无需授权的动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getNoPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态路由
     * @summary 获取动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取路由列表
     * @param {SystemGenerateObject6} systemGenerateObject6
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取路由列表(分页)
     * @param {SystemGenerateObject7} systemGenerateObject7
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseScheduleApi - axios parameter creator
 * @export
 */
export const BaseScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 删除任务
         * @param {string} scheduleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule: async (scheduleName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleName' is not null or undefined
            assertParamExists('deleteScheduleBaseSchedule', 'scheduleName', scheduleName)
            const localVarPath = `/__base/schedule/deleteSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scheduleName !== undefined) {
                localVarQueryParameter['scheduleName'] = scheduleName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule: async (systemGenerateObject8: SystemGenerateObject8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject8' is not null or undefined
            assertParamExists('pageSchedulesBaseSchedule', 'systemGenerateObject8', systemGenerateObject8)
            const localVarPath = `/__base/schedule/pageSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseScheduleApi - functional programming interface
 * @export
 */
export const BaseScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 删除任务
         * @param {string} scheduleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduleBaseSchedule(scheduleName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduleBaseSchedule(scheduleName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSchedulesBaseSchedule(systemGenerateObject8, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseScheduleApi - factory interface
 * @export
 */
export const BaseScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseScheduleApiFp(configuration)
    return {
        /**
         *
         * @summary 删除任务
         * @param {string} scheduleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule(scheduleName: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteScheduleBaseSchedule(scheduleName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: any): AxiosPromise<any> {
            return localVarFp.pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseScheduleApi - object-oriented interface
 * @export
 * @class BaseScheduleApi
 * @extends {BaseAPI}
 */
export class BaseScheduleApi extends BaseAPI {
    /**
     *
     * @summary 删除任务
     * @param {string} scheduleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public deleteScheduleBaseSchedule(scheduleName: string, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).deleteScheduleBaseSchedule(scheduleName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取任务列表(分页)
     * @param {SystemGenerateObject8} systemGenerateObject8
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseTenantApi - axios parameter creator
 * @export
 */
export const BaseTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('addBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/addBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除租户
         * @param {number} baseTenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant: async (baseTenantId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantId' is not null or undefined
            assertParamExists('delBaseTenantBaseTenant', 'baseTenantId', baseTenantId)
            const localVarPath = `/__base/tenant/delBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (baseTenantId !== undefined) {
                localVarQueryParameter['baseTenantId'] = baseTenantId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取租户信息（公共）
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTenantPublicBaseTenant', 'id', id)
            const localVarPath = `/__base/tenant/getTenantPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取租户列表
         * @param {PartialBaseTenantAdminVo} partialBaseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant: async (partialBaseTenantAdminVo: PartialBaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialBaseTenantAdminVo' is not null or undefined
            assertParamExists('listBaseTenantBaseTenant', 'partialBaseTenantAdminVo', partialBaseTenantAdminVo)
            const localVarPath = `/__base/tenant/listBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialBaseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject24} systemGenerateObject24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant: async (systemGenerateObject24: SystemGenerateObject24, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject24' is not null or undefined
            assertParamExists('pageBaseTenantBaseTenant', 'systemGenerateObject24', systemGenerateObject24)
            const localVarPath = `/__base/tenant/pageBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject24, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('updateBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/updateBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseTenantApi - functional programming interface
 * @export
 */
export const BaseTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseTenantApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除租户
         * @param {number} baseTenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBaseTenantBaseTenant(baseTenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取租户信息（公共）
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantPublicBaseTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取租户列表
         * @param {PartialBaseTenantAdminVo} partialBaseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBaseTenantBaseTenant(partialBaseTenantAdminVo: PartialBaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBaseTenantBaseTenant(partialBaseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject24} systemGenerateObject24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBaseTenantBaseTenant(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBaseTenantBaseTenant(systemGenerateObject24, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseTenantApi - factory interface
 * @export
 */
export const BaseTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseTenantApiFp(configuration)
    return {
        /**
         *
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除租户
         * @param {number} baseTenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant(baseTenantId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取租户信息（公共）
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant(id: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.getTenantPublicBaseTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取租户列表
         * @param {PartialBaseTenantAdminVo} partialBaseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant(partialBaseTenantAdminVo: PartialBaseTenantAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listBaseTenantBaseTenant(partialBaseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject24} systemGenerateObject24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant(systemGenerateObject24: SystemGenerateObject24, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.pageBaseTenantBaseTenant(systemGenerateObject24, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseTenantApi - object-oriented interface
 * @export
 * @class BaseTenantApi
 * @extends {BaseAPI}
 */
export class BaseTenantApi extends BaseAPI {
    /**
     *
     * @summary 添加租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除租户
     * @param {number} baseTenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取租户信息（公共）
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).getTenantPublicBaseTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取租户列表
     * @param {PartialBaseTenantAdminVo} partialBaseTenantAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public listBaseTenantBaseTenant(partialBaseTenantAdminVo: PartialBaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).listBaseTenantBaseTenant(partialBaseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取租户列表(分页)
     * @param {SystemGenerateObject24} systemGenerateObject24
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public pageBaseTenantBaseTenant(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).pageBaseTenantBaseTenant(systemGenerateObject24, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUserApi - axios parameter creator
 * @export
 */
export const BaseUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('addRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/addRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('addUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/addUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除角色
         * @param {number} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('delRoleBaseUser', 'roleId', roleId)
            const localVarPath = `/__base/user/delRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/getUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser: async (orgCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgCode' is not null or undefined
            assertParamExists('listOrgRolesBaseUser', 'orgCode', orgCode)
            const localVarPath = `/__base/user/listOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgCode !== undefined) {
                localVarQueryParameter['orgCode'] = orgCode;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取角色列表
         * @param {SystemGenerateObject12} systemGenerateObject12
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser: async (systemGenerateObject12: SystemGenerateObject12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject12' is not null or undefined
            assertParamExists('listRolesBaseUser', 'systemGenerateObject12', systemGenerateObject12)
            const localVarPath = `/__base/user/listRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject10} systemGenerateObject10
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser: async (systemGenerateObject10: SystemGenerateObject10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject10' is not null or undefined
            assertParamExists('listSystemRolesBaseUser', 'systemGenerateObject10', systemGenerateObject10)
            const localVarPath = `/__base/user/listSystemRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 查询用户的组织角色列表
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserOrgRolesBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/listUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取用户列表
         * @param {SystemGenerateObject14} systemGenerateObject14
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser: async (systemGenerateObject14: SystemGenerateObject14, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject14' is not null or undefined
            assertParamExists('listUsersBaseUser', 'systemGenerateObject14', systemGenerateObject14)
            const localVarPath = `/__base/user/listUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject14, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登录
         * @summary 登录
         * @param {string} userNameOrPhone
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser: async (userNameOrPhone: string, password: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userNameOrPhone' is not null or undefined
            assertParamExists('loginBaseUser', 'userNameOrPhone', userNameOrPhone)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('loginBaseUser', 'password', password)
            const localVarPath = `/__base/user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (userNameOrPhone !== undefined) {
                localVarFormParams.set('userNameOrPhone', userNameOrPhone as any);
            }

            if (password !== undefined) {
                localVarFormParams.set('password', password as any);
            }


            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject13} systemGenerateObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser: async (systemGenerateObject13: SystemGenerateObject13, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject13' is not null or undefined
            assertParamExists('pageRolesBaseUser', 'systemGenerateObject13', systemGenerateObject13)
            const localVarPath = `/__base/user/pageRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject13, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject15} systemGenerateObject15
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser: async (systemGenerateObject15: SystemGenerateObject15, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject15' is not null or undefined
            assertParamExists('pageUsersBaseUser', 'systemGenerateObject15', systemGenerateObject15)
            const localVarPath = `/__base/user/pageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject15, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('udpateRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/udpateRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('updateUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/updateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject11} systemGenerateObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser: async (systemGenerateObject11: SystemGenerateObject11, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject11' is not null or undefined
            assertParamExists('updateUserOrgRolesBaseUser', 'systemGenerateObject11', systemGenerateObject11)
            const localVarPath = `/__base/user/updateUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject11, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 修改用户密码
         * @param {SystemGenerateObject16} systemGenerateObject16
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser: async (systemGenerateObject16: SystemGenerateObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject16' is not null or undefined
            assertParamExists('updateUserPWBaseUser', 'systemGenerateObject16', systemGenerateObject16)
            const localVarPath = `/__base/user/updateUserPW`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject16, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUserApi - functional programming interface
 * @export
 */
export const BaseUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUserApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoleBaseUser(baseRoleAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除角色
         * @param {number} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRoleBaseUser(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRoleBaseUser(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserBaseUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserBaseUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfoBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfoBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrgRolesBaseUser(orgCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取角色列表
         * @param {SystemGenerateObject12} systemGenerateObject12
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRolesBaseUser(systemGenerateObject12: SystemGenerateObject12, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRolesBaseUser(systemGenerateObject12, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject10} systemGenerateObject10
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSystemRolesBaseUser(systemGenerateObject10: SystemGenerateObject10, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSystemRolesBaseUser(systemGenerateObject10, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 查询用户的组织角色列表
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserOrgRolesBaseUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取用户列表
         * @param {SystemGenerateObject14} systemGenerateObject14
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersBaseUser(systemGenerateObject14: SystemGenerateObject14, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersBaseUser(systemGenerateObject14, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登录
         * @summary 登录
         * @param {string} userNameOrPhone
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaseUser(userNameOrPhone: string, password: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaseUser(userNameOrPhone, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject13} systemGenerateObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRolesBaseUser(systemGenerateObject13: SystemGenerateObject13, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRolesBaseUser(systemGenerateObject13, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject15} systemGenerateObject15
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUsersBaseUser(systemGenerateObject15: SystemGenerateObject15, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUsersBaseUser(systemGenerateObject15, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateRoleBaseUser(baseRoleAdminVo, force, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject11} systemGenerateObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrgRolesBaseUser(systemGenerateObject11: SystemGenerateObject11, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrgRolesBaseUser(systemGenerateObject11, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 修改用户密码
         * @param {SystemGenerateObject16} systemGenerateObject16
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPWBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPWBaseUser(systemGenerateObject16, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUserApi - factory interface
 * @export
 */
export const BaseUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUserApiFp(configuration)
    return {
        /**
         *
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除角色
         * @param {number} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser(roleId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delRoleBaseUser(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser(userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteUserBaseUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser(options?: any): AxiosPromise<any> {
            return localVarFp.getUserInfoBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser(orgCode: string, options?: any): AxiosPromise<any> {
            return localVarFp.listOrgRolesBaseUser(orgCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取角色列表
         * @param {SystemGenerateObject12} systemGenerateObject12
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser(systemGenerateObject12: SystemGenerateObject12, options?: any): AxiosPromise<any> {
            return localVarFp.listRolesBaseUser(systemGenerateObject12, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject10} systemGenerateObject10
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser(systemGenerateObject10: SystemGenerateObject10, options?: any): AxiosPromise<any> {
            return localVarFp.listSystemRolesBaseUser(systemGenerateObject10, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 查询用户的组织角色列表
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser(userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.listUserOrgRolesBaseUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取用户列表
         * @param {SystemGenerateObject14} systemGenerateObject14
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser(systemGenerateObject14: SystemGenerateObject14, options?: any): AxiosPromise<any> {
            return localVarFp.listUsersBaseUser(systemGenerateObject14, options).then((request) => request(axios, basePath));
        },
        /**
         * 登录
         * @summary 登录
         * @param {string} userNameOrPhone
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser(userNameOrPhone: string, password: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginBaseUser(userNameOrPhone, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser(options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.logoutBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject13} systemGenerateObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser(systemGenerateObject13: SystemGenerateObject13, options?: any): AxiosPromise<any> {
            return localVarFp.pageRolesBaseUser(systemGenerateObject13, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject15} systemGenerateObject15
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser(systemGenerateObject15: SystemGenerateObject15, options?: any): AxiosPromise<any> {
            return localVarFp.pageUsersBaseUser(systemGenerateObject15, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject11} systemGenerateObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser(systemGenerateObject11: SystemGenerateObject11, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserOrgRolesBaseUser(systemGenerateObject11, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 修改用户密码
         * @param {SystemGenerateObject16} systemGenerateObject16
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserPWBaseUser(systemGenerateObject16, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUserApi - object-oriented interface
 * @export
 * @class BaseUserApi
 * @extends {BaseAPI}
 */
export class BaseUserApi extends BaseAPI {
    /**
     *
     * @summary 添加角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 添加用户
     * @param {BaseUserAdminVo} baseUserAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除角色
     * @param {number} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public delRoleBaseUser(roleId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).delRoleBaseUser(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除用户
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public deleteUserBaseUser(userId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).deleteUserBaseUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取用户信息
     * @summary 获取用户信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public getUserInfoBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).getUserInfoBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取组织机构下角色列表
     * @param {string} orgCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listOrgRolesBaseUser(orgCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取角色列表
     * @param {SystemGenerateObject12} systemGenerateObject12
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listRolesBaseUser(systemGenerateObject12: SystemGenerateObject12, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listRolesBaseUser(systemGenerateObject12, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取系统角色列表
     * @param {SystemGenerateObject10} systemGenerateObject10
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listSystemRolesBaseUser(systemGenerateObject10: SystemGenerateObject10, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listSystemRolesBaseUser(systemGenerateObject10, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 查询用户的组织角色列表
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUserOrgRolesBaseUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取用户列表
     * @param {SystemGenerateObject14} systemGenerateObject14
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUsersBaseUser(systemGenerateObject14: SystemGenerateObject14, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUsersBaseUser(systemGenerateObject14, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登录
     * @summary 登录
     * @param {string} userNameOrPhone
     * @param {string} password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginBaseUser(userNameOrPhone: string, password: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginBaseUser(userNameOrPhone, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登出
     * @summary 登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public logoutBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).logoutBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取角色列表(分页)
     * @param {SystemGenerateObject13} systemGenerateObject13
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageRolesBaseUser(systemGenerateObject13: SystemGenerateObject13, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageRolesBaseUser(systemGenerateObject13, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取用户列表(分页)
     * @param {SystemGenerateObject15} systemGenerateObject15
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageUsersBaseUser(systemGenerateObject15: SystemGenerateObject15, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageUsersBaseUser(systemGenerateObject15, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改用户
     * @param {BaseUserAdminVo} baseUserAdminVo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新用户的组织角色列表
     * @param {SystemGenerateObject11} systemGenerateObject11
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserOrgRolesBaseUser(systemGenerateObject11: SystemGenerateObject11, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserOrgRolesBaseUser(systemGenerateObject11, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 修改用户密码
     * @param {SystemGenerateObject16} systemGenerateObject16
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserPWBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserPWBaseUser(systemGenerateObject16, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUtilApi - axios parameter creator
 * @export
 */
export const BaseUtilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil: async (count: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'count' is not null or undefined
            assertParamExists('getIdsBaseUtil', 'count', count)
            const localVarPath = `/__base/util/getIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getUUID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUtilApi - functional programming interface
 * @export
 */
export const BaseUtilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUtilApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdsBaseUtil(count: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdsBaseUtil(count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUUIDBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUUIDBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUtilApi - factory interface
 * @export
 */
export const BaseUtilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUtilApiFp(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil(options?: any): AxiosPromise<number> {
            return localVarFp.getIdBaseUtil(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil(count: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getIdsBaseUtil(count, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil(options?: any): AxiosPromise<string> {
            return localVarFp.getUUIDBaseUtil(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUtilApi - object-oriented interface
 * @export
 * @class BaseUtilApi
 * @extends {BaseAPI}
 */
export class BaseUtilApi extends BaseAPI {
    /**
     * 获取id
     * @summary 获取id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取id
     * @summary 获取ids
     * @param {number} count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdsBaseUtil(count: number, options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdsBaseUtil(count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取uuid
     * @summary 获取uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getUUIDBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getUUIDBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BenefitApi - axios parameter creator
 * @export
 */
export const BenefitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加权益
         * @param {SystemGenerateObject90} systemGenerateObject90
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBenefitbenefit: async (systemGenerateObject90: SystemGenerateObject90, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject90' is not null or undefined
            assertParamExists('addBenefitbenefit', 'systemGenerateObject90', systemGenerateObject90)
            const localVarPath = `/benefit/addBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject90, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 用户领取权益
         * @summary 领取权益
         * @param {SystemGenerateObject92} systemGenerateObject92
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimBenefitbenefit: async (systemGenerateObject92: SystemGenerateObject92, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject92' is not null or undefined
            assertParamExists('claimBenefitbenefit', 'systemGenerateObject92', systemGenerateObject92)
            const localVarPath = `/benefit/claimBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject92, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除权益
         * @param {number} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBenefitbenefit: async (benefitId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'benefitId' is not null or undefined
            assertParamExists('delBenefitbenefit', 'benefitId', benefitId)
            const localVarPath = `/benefit/delBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (benefitId !== undefined) {
                localVarQueryParameter['benefitId'] = benefitId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取权益列表
         * @param {SystemGenerateObject88} systemGenerateObject88
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenefitbenefit: async (systemGenerateObject88: SystemGenerateObject88, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject88' is not null or undefined
            assertParamExists('listBenefitbenefit', 'systemGenerateObject88', systemGenerateObject88)
            const localVarPath = `/benefit/listBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject88, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取权益列表(分页)
         * @param {SystemGenerateObject89} systemGenerateObject89
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBenefitbenefit: async (systemGenerateObject89: SystemGenerateObject89, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject89' is not null or undefined
            assertParamExists('pageBenefitbenefit', 'systemGenerateObject89', systemGenerateObject89)
            const localVarPath = `/benefit/pageBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject89, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新权益
         * @param {SystemGenerateObject91} systemGenerateObject91
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBenefitbenefit: async (systemGenerateObject91: SystemGenerateObject91, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject91' is not null or undefined
            assertParamExists('updateBenefitbenefit', 'systemGenerateObject91', systemGenerateObject91)
            const localVarPath = `/benefit/updateBenefit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject91, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BenefitApi - functional programming interface
 * @export
 */
export const BenefitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BenefitApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加权益
         * @param {SystemGenerateObject90} systemGenerateObject90
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBenefitbenefit(systemGenerateObject90: SystemGenerateObject90, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBenefitbenefit(systemGenerateObject90, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 用户领取权益
         * @summary 领取权益
         * @param {SystemGenerateObject92} systemGenerateObject92
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimBenefitbenefit(systemGenerateObject92: SystemGenerateObject92, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimBenefitbenefit(systemGenerateObject92, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除权益
         * @param {number} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBenefitbenefit(benefitId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBenefitbenefit(benefitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取权益列表
         * @param {SystemGenerateObject88} systemGenerateObject88
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBenefitbenefit(systemGenerateObject88: SystemGenerateObject88, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBenefitbenefit(systemGenerateObject88, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取权益列表(分页)
         * @param {SystemGenerateObject89} systemGenerateObject89
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBenefitbenefit(systemGenerateObject89: SystemGenerateObject89, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBenefitbenefit(systemGenerateObject89, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新权益
         * @param {SystemGenerateObject91} systemGenerateObject91
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBenefitbenefit(systemGenerateObject91: SystemGenerateObject91, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBenefitbenefit(systemGenerateObject91, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BenefitApi - factory interface
 * @export
 */
export const BenefitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BenefitApiFp(configuration)
    return {
        /**
         *
         * @summary 添加权益
         * @param {SystemGenerateObject90} systemGenerateObject90
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBenefitbenefit(systemGenerateObject90: SystemGenerateObject90, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addBenefitbenefit(systemGenerateObject90, options).then((request) => request(axios, basePath));
        },
        /**
         * 用户领取权益
         * @summary 领取权益
         * @param {SystemGenerateObject92} systemGenerateObject92
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimBenefitbenefit(systemGenerateObject92: SystemGenerateObject92, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.claimBenefitbenefit(systemGenerateObject92, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除权益
         * @param {number} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBenefitbenefit(benefitId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delBenefitbenefit(benefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取权益列表
         * @param {SystemGenerateObject88} systemGenerateObject88
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenefitbenefit(systemGenerateObject88: SystemGenerateObject88, options?: any): AxiosPromise<any> {
            return localVarFp.listBenefitbenefit(systemGenerateObject88, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取权益列表(分页)
         * @param {SystemGenerateObject89} systemGenerateObject89
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBenefitbenefit(systemGenerateObject89: SystemGenerateObject89, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageBenefitbenefit(systemGenerateObject89, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新权益
         * @param {SystemGenerateObject91} systemGenerateObject91
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBenefitbenefit(systemGenerateObject91: SystemGenerateObject91, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateBenefitbenefit(systemGenerateObject91, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BenefitApi - object-oriented interface
 * @export
 * @class BenefitApi
 * @extends {BaseAPI}
 */
export class BenefitApi extends BaseAPI {
    /**
     *
     * @summary 添加权益
     * @param {SystemGenerateObject90} systemGenerateObject90
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public addBenefitbenefit(systemGenerateObject90: SystemGenerateObject90, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).addBenefitbenefit(systemGenerateObject90, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 用户领取权益
     * @summary 领取权益
     * @param {SystemGenerateObject92} systemGenerateObject92
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public claimBenefitbenefit(systemGenerateObject92: SystemGenerateObject92, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).claimBenefitbenefit(systemGenerateObject92, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除权益
     * @param {number} benefitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public delBenefitbenefit(benefitId: number, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).delBenefitbenefit(benefitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取权益列表
     * @param {SystemGenerateObject88} systemGenerateObject88
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public listBenefitbenefit(systemGenerateObject88: SystemGenerateObject88, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).listBenefitbenefit(systemGenerateObject88, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取权益列表(分页)
     * @param {SystemGenerateObject89} systemGenerateObject89
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public pageBenefitbenefit(systemGenerateObject89: SystemGenerateObject89, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).pageBenefitbenefit(systemGenerateObject89, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新权益
     * @param {SystemGenerateObject91} systemGenerateObject91
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitApi
     */
    public updateBenefitbenefit(systemGenerateObject91: SystemGenerateObject91, options?: AxiosRequestConfig) {
        return BenefitApiFp(this.configuration).updateBenefitbenefit(systemGenerateObject91, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillApi - axios parameter creator
 * @export
 */
export const BillApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加账单
         * @param {SystemGenerateObject33} systemGenerateObject33
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillbill: async (systemGenerateObject33: SystemGenerateObject33, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject33' is not null or undefined
            assertParamExists('addBillbill', 'systemGenerateObject33', systemGenerateObject33)
            const localVarPath = `/bill/addBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject33, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 添加我的账单
         * @param {SystemGenerateObject39} systemGenerateObject39
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMyBillbill: async (systemGenerateObject39: SystemGenerateObject39, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject39' is not null or undefined
            assertParamExists('addMyBillbill', 'systemGenerateObject39', systemGenerateObject39)
            const localVarPath = `/bill/my/addMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject39, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 取消账单并退款
         * @summary 取消账单
         * @param {SystemGenerateObject35} systemGenerateObject35
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBillbill: async (systemGenerateObject35: SystemGenerateObject35, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject35' is not null or undefined
            assertParamExists('cancelBillbill', 'systemGenerateObject35', systemGenerateObject35)
            const localVarPath = `/bill/cancelBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject35, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 完成点餐订单
         * @param {SystemGenerateObject41} systemGenerateObject41
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOrderbill: async (systemGenerateObject41: SystemGenerateObject41, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject41' is not null or undefined
            assertParamExists('completeOrderbill', 'systemGenerateObject41', systemGenerateObject41)
            const localVarPath = `/bill/completeOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject41, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBillbill: async (billId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('delBillbill', 'billId', billId)
            const localVarPath = `/bill/delBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除我的账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyBillbill: async (billId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('delMyBillbill', 'billId', billId)
            const localVarPath = `/bill/my/delMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取单个账单信息
         * @param {SystemGenerateObject30} systemGenerateObject30
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBillbill: async (systemGenerateObject30: SystemGenerateObject30, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject30' is not null or undefined
            assertParamExists('findBillbill', 'systemGenerateObject30', systemGenerateObject30)
            const localVarPath = `/bill/findBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject30, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取我的单个账单信息
         * @param {SystemGenerateObject36} systemGenerateObject36
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyBillbill: async (systemGenerateObject36: SystemGenerateObject36, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject36' is not null or undefined
            assertParamExists('findMyBillbill', 'systemGenerateObject36', systemGenerateObject36)
            const localVarPath = `/bill/my/findMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject36, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取账单列表
         * @param {SystemGenerateObject31} systemGenerateObject31
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillbill: async (systemGenerateObject31: SystemGenerateObject31, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject31' is not null or undefined
            assertParamExists('listBillbill', 'systemGenerateObject31', systemGenerateObject31)
            const localVarPath = `/bill/listBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject31, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取我的账单列表
         * @param {SystemGenerateObject37} systemGenerateObject37
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBillbill: async (systemGenerateObject37: SystemGenerateObject37, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject37' is not null or undefined
            assertParamExists('listMyBillbill', 'systemGenerateObject37', systemGenerateObject37)
            const localVarPath = `/bill/my/listMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject37, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取待出餐账单列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaitingBillbill: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bill/listWaitingBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取账单列表(分页)
         * @param {SystemGenerateObject32} systemGenerateObject32
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillbill: async (systemGenerateObject32: SystemGenerateObject32, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject32' is not null or undefined
            assertParamExists('pageBillbill', 'systemGenerateObject32', systemGenerateObject32)
            const localVarPath = `/bill/pageBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject32, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分页获取我的账单列表
         * @param {SystemGenerateObject38} systemGenerateObject38
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyBillbill: async (systemGenerateObject38: SystemGenerateObject38, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject38' is not null or undefined
            assertParamExists('pageMyBillbill', 'systemGenerateObject38', systemGenerateObject38)
            const localVarPath = `/bill/my/pageMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject38, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新账单
         * @param {SystemGenerateObject34} systemGenerateObject34
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillbill: async (systemGenerateObject34: SystemGenerateObject34, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject34' is not null or undefined
            assertParamExists('updateBillbill', 'systemGenerateObject34', systemGenerateObject34)
            const localVarPath = `/bill/updateBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject34, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新我的账单
         * @param {SystemGenerateObject40} systemGenerateObject40
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBillbill: async (systemGenerateObject40: SystemGenerateObject40, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject40' is not null or undefined
            assertParamExists('updateMyBillbill', 'systemGenerateObject40', systemGenerateObject40)
            const localVarPath = `/bill/my/updateMyBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject40, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillApi - functional programming interface
 * @export
 */
export const BillApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加账单
         * @param {SystemGenerateObject33} systemGenerateObject33
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBillbill(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBillbill(systemGenerateObject33, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 添加我的账单
         * @param {SystemGenerateObject39} systemGenerateObject39
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMyBillbill(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMyBillbill(systemGenerateObject39, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 取消账单并退款
         * @summary 取消账单
         * @param {SystemGenerateObject35} systemGenerateObject35
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBillbill(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBillbill(systemGenerateObject35, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 完成点餐订单
         * @param {SystemGenerateObject41} systemGenerateObject41
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeOrderbill(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeOrderbill(systemGenerateObject41, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBillbill(billId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBillbill(billId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除我的账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMyBillbill(billId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMyBillbill(billId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取单个账单信息
         * @param {SystemGenerateObject30} systemGenerateObject30
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBillbill(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBillbill(systemGenerateObject30, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取我的单个账单信息
         * @param {SystemGenerateObject36} systemGenerateObject36
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyBillbill(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyBillbill(systemGenerateObject36, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取账单列表
         * @param {SystemGenerateObject31} systemGenerateObject31
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillbill(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillbill(systemGenerateObject31, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取我的账单列表
         * @param {SystemGenerateObject37} systemGenerateObject37
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyBillbill(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyBillbill(systemGenerateObject37, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取待出餐账单列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaitingBillbill(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaitingBillbill(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取账单列表(分页)
         * @param {SystemGenerateObject32} systemGenerateObject32
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBillbill(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBillbill(systemGenerateObject32, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 分页获取我的账单列表
         * @param {SystemGenerateObject38} systemGenerateObject38
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMyBillbill(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMyBillbill(systemGenerateObject38, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新账单
         * @param {SystemGenerateObject34} systemGenerateObject34
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBillbill(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBillbill(systemGenerateObject34, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新我的账单
         * @param {SystemGenerateObject40} systemGenerateObject40
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyBillbill(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyBillbill(systemGenerateObject40, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BillApi - factory interface
 * @export
 */
export const BillApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillApiFp(configuration)
    return {
        /**
         *
         * @summary 添加账单
         * @param {SystemGenerateObject33} systemGenerateObject33
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillbill(systemGenerateObject33: SystemGenerateObject33, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addBillbill(systemGenerateObject33, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 添加我的账单
         * @param {SystemGenerateObject39} systemGenerateObject39
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMyBillbill(systemGenerateObject39: SystemGenerateObject39, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addMyBillbill(systemGenerateObject39, options).then((request) => request(axios, basePath));
        },
        /**
         * 取消账单并退款
         * @summary 取消账单
         * @param {SystemGenerateObject35} systemGenerateObject35
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBillbill(systemGenerateObject35: SystemGenerateObject35, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.cancelBillbill(systemGenerateObject35, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 完成点餐订单
         * @param {SystemGenerateObject41} systemGenerateObject41
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOrderbill(systemGenerateObject41: SystemGenerateObject41, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.completeOrderbill(systemGenerateObject41, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBillbill(billId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delBillbill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除我的账单
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyBillbill(billId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delMyBillbill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取单个账单信息
         * @param {SystemGenerateObject30} systemGenerateObject30
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBillbill(systemGenerateObject30: SystemGenerateObject30, options?: any): AxiosPromise<any> {
            return localVarFp.findBillbill(systemGenerateObject30, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取我的单个账单信息
         * @param {SystemGenerateObject36} systemGenerateObject36
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyBillbill(systemGenerateObject36: SystemGenerateObject36, options?: any): AxiosPromise<any> {
            return localVarFp.findMyBillbill(systemGenerateObject36, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取账单列表
         * @param {SystemGenerateObject31} systemGenerateObject31
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillbill(systemGenerateObject31: SystemGenerateObject31, options?: any): AxiosPromise<any> {
            return localVarFp.listBillbill(systemGenerateObject31, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取我的账单列表
         * @param {SystemGenerateObject37} systemGenerateObject37
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBillbill(systemGenerateObject37: SystemGenerateObject37, options?: any): AxiosPromise<any> {
            return localVarFp.listMyBillbill(systemGenerateObject37, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取待出餐账单列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaitingBillbill(options?: any): AxiosPromise<any> {
            return localVarFp.listWaitingBillbill(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取账单列表(分页)
         * @param {SystemGenerateObject32} systemGenerateObject32
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillbill(systemGenerateObject32: SystemGenerateObject32, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageBillbill(systemGenerateObject32, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 分页获取我的账单列表
         * @param {SystemGenerateObject38} systemGenerateObject38
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyBillbill(systemGenerateObject38: SystemGenerateObject38, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageMyBillbill(systemGenerateObject38, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新账单
         * @param {SystemGenerateObject34} systemGenerateObject34
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillbill(systemGenerateObject34: SystemGenerateObject34, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateBillbill(systemGenerateObject34, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新我的账单
         * @param {SystemGenerateObject40} systemGenerateObject40
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBillbill(systemGenerateObject40: SystemGenerateObject40, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateMyBillbill(systemGenerateObject40, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillApi - object-oriented interface
 * @export
 * @class BillApi
 * @extends {BaseAPI}
 */
export class BillApi extends BaseAPI {
    /**
     *
     * @summary 添加账单
     * @param {SystemGenerateObject33} systemGenerateObject33
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public addBillbill(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).addBillbill(systemGenerateObject33, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 添加我的账单
     * @param {SystemGenerateObject39} systemGenerateObject39
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public addMyBillbill(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).addMyBillbill(systemGenerateObject39, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 取消账单并退款
     * @summary 取消账单
     * @param {SystemGenerateObject35} systemGenerateObject35
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public cancelBillbill(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).cancelBillbill(systemGenerateObject35, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 完成点餐订单
     * @param {SystemGenerateObject41} systemGenerateObject41
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public completeOrderbill(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).completeOrderbill(systemGenerateObject41, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除账单
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public delBillbill(billId: number, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).delBillbill(billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除我的账单
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public delMyBillbill(billId: number, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).delMyBillbill(billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取单个账单信息
     * @param {SystemGenerateObject30} systemGenerateObject30
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public findBillbill(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).findBillbill(systemGenerateObject30, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取我的单个账单信息
     * @param {SystemGenerateObject36} systemGenerateObject36
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public findMyBillbill(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).findMyBillbill(systemGenerateObject36, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取账单列表
     * @param {SystemGenerateObject31} systemGenerateObject31
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public listBillbill(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).listBillbill(systemGenerateObject31, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取我的账单列表
     * @param {SystemGenerateObject37} systemGenerateObject37
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public listMyBillbill(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).listMyBillbill(systemGenerateObject37, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取待出餐账单列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public listWaitingBillbill(options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).listWaitingBillbill(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取账单列表(分页)
     * @param {SystemGenerateObject32} systemGenerateObject32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public pageBillbill(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).pageBillbill(systemGenerateObject32, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 分页获取我的账单列表
     * @param {SystemGenerateObject38} systemGenerateObject38
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public pageMyBillbill(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).pageMyBillbill(systemGenerateObject38, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新账单
     * @param {SystemGenerateObject34} systemGenerateObject34
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public updateBillbill(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).updateBillbill(systemGenerateObject34, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新我的账单
     * @param {SystemGenerateObject40} systemGenerateObject40
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillApi
     */
    public updateMyBillbill(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig) {
        return BillApiFp(this.configuration).updateMyBillbill(systemGenerateObject40, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加分类
         * @param {SystemGenerateObject52} systemGenerateObject52
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategorycategory: async (systemGenerateObject52: SystemGenerateObject52, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject52' is not null or undefined
            assertParamExists('addCategorycategory', 'systemGenerateObject52', systemGenerateObject52)
            const localVarPath = `/category/addCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject52, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除分类
         * @param {number} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCategorycategory: async (categoryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('delCategorycategory', 'categoryId', categoryId)
            const localVarPath = `/category/delCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取分类列表
         * @param {SystemGenerateObject50} systemGenerateObject50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategorycategory: async (systemGenerateObject50: SystemGenerateObject50, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject50' is not null or undefined
            assertParamExists('listCategorycategory', 'systemGenerateObject50', systemGenerateObject50)
            const localVarPath = `/category/listCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject50, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取分类列表(分页)
         * @param {SystemGenerateObject51} systemGenerateObject51
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCategorycategory: async (systemGenerateObject51: SystemGenerateObject51, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject51' is not null or undefined
            assertParamExists('pageCategorycategory', 'systemGenerateObject51', systemGenerateObject51)
            const localVarPath = `/category/pageCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject51, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新分类
         * @param {SystemGenerateObject53} systemGenerateObject53
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategorycategory: async (systemGenerateObject53: SystemGenerateObject53, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject53' is not null or undefined
            assertParamExists('updateCategorycategory', 'systemGenerateObject53', systemGenerateObject53)
            const localVarPath = `/category/updateCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject53, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加分类
         * @param {SystemGenerateObject52} systemGenerateObject52
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCategorycategory(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCategorycategory(systemGenerateObject52, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除分类
         * @param {number} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delCategorycategory(categoryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delCategorycategory(categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取分类列表
         * @param {SystemGenerateObject50} systemGenerateObject50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCategorycategory(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCategorycategory(systemGenerateObject50, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取分类列表(分页)
         * @param {SystemGenerateObject51} systemGenerateObject51
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCategorycategory(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCategorycategory(systemGenerateObject51, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新分类
         * @param {SystemGenerateObject53} systemGenerateObject53
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategorycategory(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategorycategory(systemGenerateObject53, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)
    return {
        /**
         *
         * @summary 添加分类
         * @param {SystemGenerateObject52} systemGenerateObject52
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategorycategory(systemGenerateObject52: SystemGenerateObject52, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addCategorycategory(systemGenerateObject52, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除分类
         * @param {number} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCategorycategory(categoryId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delCategorycategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取分类列表
         * @param {SystemGenerateObject50} systemGenerateObject50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategorycategory(systemGenerateObject50: SystemGenerateObject50, options?: any): AxiosPromise<any> {
            return localVarFp.listCategorycategory(systemGenerateObject50, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取分类列表(分页)
         * @param {SystemGenerateObject51} systemGenerateObject51
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCategorycategory(systemGenerateObject51: SystemGenerateObject51, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageCategorycategory(systemGenerateObject51, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新分类
         * @param {SystemGenerateObject53} systemGenerateObject53
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategorycategory(systemGenerateObject53: SystemGenerateObject53, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateCategorycategory(systemGenerateObject53, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI {
    /**
     *
     * @summary 添加分类
     * @param {SystemGenerateObject52} systemGenerateObject52
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public addCategorycategory(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).addCategorycategory(systemGenerateObject52, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除分类
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public delCategorycategory(categoryId: number, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).delCategorycategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取分类列表
     * @param {SystemGenerateObject50} systemGenerateObject50
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public listCategorycategory(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).listCategorycategory(systemGenerateObject50, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取分类列表(分页)
     * @param {SystemGenerateObject51} systemGenerateObject51
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public pageCategorycategory(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).pageCategorycategory(systemGenerateObject51, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新分类
     * @param {SystemGenerateObject53} systemGenerateObject53
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public updateCategorycategory(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).updateCategorycategory(systemGenerateObject53, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CoinsRecordApi - axios parameter creator
 * @export
 */
export const CoinsRecordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加金币记录
         * @param {SystemGenerateObject99} systemGenerateObject99
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoinsRecordcoinsRecord: async (systemGenerateObject99: SystemGenerateObject99, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject99' is not null or undefined
            assertParamExists('addCoinsRecordcoinsRecord', 'systemGenerateObject99', systemGenerateObject99)
            const localVarPath = `/coinsRecord/addCoinsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject99, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除金币记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCoinsRecordcoinsRecord: async (recordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('delCoinsRecordcoinsRecord', 'recordId', recordId)
            const localVarPath = `/coinsRecord/delCoinsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取金币记录列表
         * @param {SystemGenerateObject97} systemGenerateObject97
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoinsRecordcoinsRecord: async (systemGenerateObject97: SystemGenerateObject97, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject97' is not null or undefined
            assertParamExists('listCoinsRecordcoinsRecord', 'systemGenerateObject97', systemGenerateObject97)
            const localVarPath = `/coinsRecord/listCoinsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject97, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取金币记录列表(分页)
         * @param {SystemGenerateObject98} systemGenerateObject98
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCoinsRecordcoinsRecord: async (systemGenerateObject98: SystemGenerateObject98, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject98' is not null or undefined
            assertParamExists('pageCoinsRecordcoinsRecord', 'systemGenerateObject98', systemGenerateObject98)
            const localVarPath = `/coinsRecord/pageCoinsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject98, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新金币记录
         * @param {SystemGenerateObject100} systemGenerateObject100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoinsRecordcoinsRecord: async (systemGenerateObject100: SystemGenerateObject100, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject100' is not null or undefined
            assertParamExists('updateCoinsRecordcoinsRecord', 'systemGenerateObject100', systemGenerateObject100)
            const localVarPath = `/coinsRecord/updateCoinsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject100, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoinsRecordApi - functional programming interface
 * @export
 */
export const CoinsRecordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoinsRecordApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加金币记录
         * @param {SystemGenerateObject99} systemGenerateObject99
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCoinsRecordcoinsRecord(systemGenerateObject99: SystemGenerateObject99, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCoinsRecordcoinsRecord(systemGenerateObject99, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除金币记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delCoinsRecordcoinsRecord(recordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delCoinsRecordcoinsRecord(recordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取金币记录列表
         * @param {SystemGenerateObject97} systemGenerateObject97
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCoinsRecordcoinsRecord(systemGenerateObject97: SystemGenerateObject97, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCoinsRecordcoinsRecord(systemGenerateObject97, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取金币记录列表(分页)
         * @param {SystemGenerateObject98} systemGenerateObject98
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCoinsRecordcoinsRecord(systemGenerateObject98: SystemGenerateObject98, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCoinsRecordcoinsRecord(systemGenerateObject98, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新金币记录
         * @param {SystemGenerateObject100} systemGenerateObject100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCoinsRecordcoinsRecord(systemGenerateObject100: SystemGenerateObject100, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCoinsRecordcoinsRecord(systemGenerateObject100, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CoinsRecordApi - factory interface
 * @export
 */
export const CoinsRecordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoinsRecordApiFp(configuration)
    return {
        /**
         *
         * @summary 添加金币记录
         * @param {SystemGenerateObject99} systemGenerateObject99
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoinsRecordcoinsRecord(systemGenerateObject99: SystemGenerateObject99, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addCoinsRecordcoinsRecord(systemGenerateObject99, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除金币记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCoinsRecordcoinsRecord(recordId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delCoinsRecordcoinsRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取金币记录列表
         * @param {SystemGenerateObject97} systemGenerateObject97
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoinsRecordcoinsRecord(systemGenerateObject97: SystemGenerateObject97, options?: any): AxiosPromise<any> {
            return localVarFp.listCoinsRecordcoinsRecord(systemGenerateObject97, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取金币记录列表(分页)
         * @param {SystemGenerateObject98} systemGenerateObject98
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCoinsRecordcoinsRecord(systemGenerateObject98: SystemGenerateObject98, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageCoinsRecordcoinsRecord(systemGenerateObject98, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新金币记录
         * @param {SystemGenerateObject100} systemGenerateObject100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoinsRecordcoinsRecord(systemGenerateObject100: SystemGenerateObject100, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateCoinsRecordcoinsRecord(systemGenerateObject100, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoinsRecordApi - object-oriented interface
 * @export
 * @class CoinsRecordApi
 * @extends {BaseAPI}
 */
export class CoinsRecordApi extends BaseAPI {
    /**
     *
     * @summary 添加金币记录
     * @param {SystemGenerateObject99} systemGenerateObject99
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoinsRecordApi
     */
    public addCoinsRecordcoinsRecord(systemGenerateObject99: SystemGenerateObject99, options?: AxiosRequestConfig) {
        return CoinsRecordApiFp(this.configuration).addCoinsRecordcoinsRecord(systemGenerateObject99, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除金币记录
     * @param {number} recordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoinsRecordApi
     */
    public delCoinsRecordcoinsRecord(recordId: number, options?: AxiosRequestConfig) {
        return CoinsRecordApiFp(this.configuration).delCoinsRecordcoinsRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取金币记录列表
     * @param {SystemGenerateObject97} systemGenerateObject97
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoinsRecordApi
     */
    public listCoinsRecordcoinsRecord(systemGenerateObject97: SystemGenerateObject97, options?: AxiosRequestConfig) {
        return CoinsRecordApiFp(this.configuration).listCoinsRecordcoinsRecord(systemGenerateObject97, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取金币记录列表(分页)
     * @param {SystemGenerateObject98} systemGenerateObject98
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoinsRecordApi
     */
    public pageCoinsRecordcoinsRecord(systemGenerateObject98: SystemGenerateObject98, options?: AxiosRequestConfig) {
        return CoinsRecordApiFp(this.configuration).pageCoinsRecordcoinsRecord(systemGenerateObject98, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新金币记录
     * @param {SystemGenerateObject100} systemGenerateObject100
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoinsRecordApi
     */
    public updateCoinsRecordcoinsRecord(systemGenerateObject100: SystemGenerateObject100, options?: AxiosRequestConfig) {
        return CoinsRecordApiFp(this.configuration).updateCoinsRecordcoinsRecord(systemGenerateObject100, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加配置
         * @param {SystemGenerateObject86} systemGenerateObject86
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfigconfig: async (systemGenerateObject86: SystemGenerateObject86, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject86' is not null or undefined
            assertParamExists('addConfigconfig', 'systemGenerateObject86', systemGenerateObject86)
            const localVarPath = `/config/addConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject86, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除配置
         * @param {number} configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delConfigconfig: async (configId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configId' is not null or undefined
            assertParamExists('delConfigconfig', 'configId', configId)
            const localVarPath = `/config/delConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (configId !== undefined) {
                localVarQueryParameter['configId'] = configId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取配置列表
         * @param {SystemGenerateObject84} systemGenerateObject84
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConfigconfig: async (systemGenerateObject84: SystemGenerateObject84, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject84' is not null or undefined
            assertParamExists('listConfigconfig', 'systemGenerateObject84', systemGenerateObject84)
            const localVarPath = `/config/listConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject84, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取配置列表(分页)
         * @param {SystemGenerateObject85} systemGenerateObject85
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageConfigconfig: async (systemGenerateObject85: SystemGenerateObject85, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject85' is not null or undefined
            assertParamExists('pageConfigconfig', 'systemGenerateObject85', systemGenerateObject85)
            const localVarPath = `/config/pageConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject85, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新配置
         * @param {SystemGenerateObject87} systemGenerateObject87
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigconfig: async (systemGenerateObject87: SystemGenerateObject87, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject87' is not null or undefined
            assertParamExists('updateConfigconfig', 'systemGenerateObject87', systemGenerateObject87)
            const localVarPath = `/config/updateConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject87, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加配置
         * @param {SystemGenerateObject86} systemGenerateObject86
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConfigconfig(systemGenerateObject86: SystemGenerateObject86, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfigconfig(systemGenerateObject86, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除配置
         * @param {number} configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delConfigconfig(configId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delConfigconfig(configId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取配置列表
         * @param {SystemGenerateObject84} systemGenerateObject84
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConfigconfig(systemGenerateObject84: SystemGenerateObject84, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConfigconfig(systemGenerateObject84, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取配置列表(分页)
         * @param {SystemGenerateObject85} systemGenerateObject85
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageConfigconfig(systemGenerateObject85: SystemGenerateObject85, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageConfigconfig(systemGenerateObject85, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新配置
         * @param {SystemGenerateObject87} systemGenerateObject87
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfigconfig(systemGenerateObject87: SystemGenerateObject87, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfigconfig(systemGenerateObject87, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         *
         * @summary 添加配置
         * @param {SystemGenerateObject86} systemGenerateObject86
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfigconfig(systemGenerateObject86: SystemGenerateObject86, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addConfigconfig(systemGenerateObject86, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除配置
         * @param {number} configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delConfigconfig(configId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delConfigconfig(configId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取配置列表
         * @param {SystemGenerateObject84} systemGenerateObject84
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConfigconfig(systemGenerateObject84: SystemGenerateObject84, options?: any): AxiosPromise<any> {
            return localVarFp.listConfigconfig(systemGenerateObject84, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取配置列表(分页)
         * @param {SystemGenerateObject85} systemGenerateObject85
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageConfigconfig(systemGenerateObject85: SystemGenerateObject85, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageConfigconfig(systemGenerateObject85, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新配置
         * @param {SystemGenerateObject87} systemGenerateObject87
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigconfig(systemGenerateObject87: SystemGenerateObject87, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateConfigconfig(systemGenerateObject87, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     *
     * @summary 添加配置
     * @param {SystemGenerateObject86} systemGenerateObject86
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public addConfigconfig(systemGenerateObject86: SystemGenerateObject86, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).addConfigconfig(systemGenerateObject86, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除配置
     * @param {number} configId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public delConfigconfig(configId: number, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).delConfigconfig(configId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取配置列表
     * @param {SystemGenerateObject84} systemGenerateObject84
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public listConfigconfig(systemGenerateObject84: SystemGenerateObject84, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).listConfigconfig(systemGenerateObject84, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取配置列表(分页)
     * @param {SystemGenerateObject85} systemGenerateObject85
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public pageConfigconfig(systemGenerateObject85: SystemGenerateObject85, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).pageConfigconfig(systemGenerateObject85, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新配置
     * @param {SystemGenerateObject87} systemGenerateObject87
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public updateConfigconfig(systemGenerateObject87: SystemGenerateObject87, options?: AxiosRequestConfig) {
        return ConfigApiFp(this.configuration).updateConfigconfig(systemGenerateObject87, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CouponApi - axios parameter creator
 * @export
 */
export const CouponApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加券
         * @param {SystemGenerateObject74} systemGenerateObject74
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponcoupon: async (systemGenerateObject74: SystemGenerateObject74, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject74' is not null or undefined
            assertParamExists('addCouponcoupon', 'systemGenerateObject74', systemGenerateObject74)
            const localVarPath = `/coupon/addCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject74, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除券
         * @param {number} couponId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCouponcoupon: async (couponId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('delCouponcoupon', 'couponId', couponId)
            const localVarPath = `/coupon/delCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (couponId !== undefined) {
                localVarQueryParameter['couponId'] = couponId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 通过ID查询单个券
         * @param {SystemGenerateObject76} systemGenerateObject76
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCouponByIdcoupon: async (systemGenerateObject76: SystemGenerateObject76, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject76' is not null or undefined
            assertParamExists('findCouponByIdcoupon', 'systemGenerateObject76', systemGenerateObject76)
            const localVarPath = `/coupon/findCouponById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject76, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取券列表
         * @param {SystemGenerateObject72} systemGenerateObject72
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponcoupon: async (systemGenerateObject72: SystemGenerateObject72, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject72' is not null or undefined
            assertParamExists('listCouponcoupon', 'systemGenerateObject72', systemGenerateObject72)
            const localVarPath = `/coupon/listCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject72, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取我的券列表
         * @param {SystemGenerateObject78} systemGenerateObject78
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyCouponcoupon: async (systemGenerateObject78: SystemGenerateObject78, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject78' is not null or undefined
            assertParamExists('listMyCouponcoupon', 'systemGenerateObject78', systemGenerateObject78)
            const localVarPath = `/coupon/my/listMyCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject78, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取券列表(分页)
         * @param {SystemGenerateObject73} systemGenerateObject73
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCouponcoupon: async (systemGenerateObject73: SystemGenerateObject73, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject73' is not null or undefined
            assertParamExists('pageCouponcoupon', 'systemGenerateObject73', systemGenerateObject73)
            const localVarPath = `/coupon/pageCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject73, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 用户兑换券
         * @param {SystemGenerateObject79} systemGenerateObject79
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCouponcoupon: async (systemGenerateObject79: SystemGenerateObject79, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject79' is not null or undefined
            assertParamExists('redeemCouponcoupon', 'systemGenerateObject79', systemGenerateObject79)
            const localVarPath = `/coupon/my/redeemCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject79, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新券
         * @param {SystemGenerateObject75} systemGenerateObject75
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponcoupon: async (systemGenerateObject75: SystemGenerateObject75, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject75' is not null or undefined
            assertParamExists('updateCouponcoupon', 'systemGenerateObject75', systemGenerateObject75)
            const localVarPath = `/coupon/updateCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject75, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 如果券有商品信息则需要传入桌id和座位编号创建订单
         * @summary 管理员核销券
         * @param {SystemGenerateObject77} systemGenerateObject77
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCouponcoupon: async (systemGenerateObject77: SystemGenerateObject77, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject77' is not null or undefined
            assertParamExists('verifyCouponcoupon', 'systemGenerateObject77', systemGenerateObject77)
            const localVarPath = `/coupon/verifyCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject77, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponApi - functional programming interface
 * @export
 */
export const CouponApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加券
         * @param {SystemGenerateObject74} systemGenerateObject74
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCouponcoupon(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCouponcoupon(systemGenerateObject74, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除券
         * @param {number} couponId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delCouponcoupon(couponId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delCouponcoupon(couponId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 通过ID查询单个券
         * @param {SystemGenerateObject76} systemGenerateObject76
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCouponByIdcoupon(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCouponByIdcoupon(systemGenerateObject76, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取券列表
         * @param {SystemGenerateObject72} systemGenerateObject72
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCouponcoupon(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCouponcoupon(systemGenerateObject72, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取我的券列表
         * @param {SystemGenerateObject78} systemGenerateObject78
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyCouponcoupon(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyCouponcoupon(systemGenerateObject78, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取券列表(分页)
         * @param {SystemGenerateObject73} systemGenerateObject73
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCouponcoupon(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCouponcoupon(systemGenerateObject73, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 用户兑换券
         * @param {SystemGenerateObject79} systemGenerateObject79
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemCouponcoupon(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemCouponcoupon(systemGenerateObject79, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新券
         * @param {SystemGenerateObject75} systemGenerateObject75
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponcoupon(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponcoupon(systemGenerateObject75, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 如果券有商品信息则需要传入桌id和座位编号创建订单
         * @summary 管理员核销券
         * @param {SystemGenerateObject77} systemGenerateObject77
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCouponcoupon(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCouponcoupon(systemGenerateObject77, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CouponApi - factory interface
 * @export
 */
export const CouponApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponApiFp(configuration)
    return {
        /**
         *
         * @summary 添加券
         * @param {SystemGenerateObject74} systemGenerateObject74
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponcoupon(systemGenerateObject74: SystemGenerateObject74, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addCouponcoupon(systemGenerateObject74, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除券
         * @param {number} couponId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCouponcoupon(couponId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delCouponcoupon(couponId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 通过ID查询单个券
         * @param {SystemGenerateObject76} systemGenerateObject76
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCouponByIdcoupon(systemGenerateObject76: SystemGenerateObject76, options?: any): AxiosPromise<any> {
            return localVarFp.findCouponByIdcoupon(systemGenerateObject76, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取券列表
         * @param {SystemGenerateObject72} systemGenerateObject72
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponcoupon(systemGenerateObject72: SystemGenerateObject72, options?: any): AxiosPromise<any> {
            return localVarFp.listCouponcoupon(systemGenerateObject72, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取我的券列表
         * @param {SystemGenerateObject78} systemGenerateObject78
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyCouponcoupon(systemGenerateObject78: SystemGenerateObject78, options?: any): AxiosPromise<any> {
            return localVarFp.listMyCouponcoupon(systemGenerateObject78, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取券列表(分页)
         * @param {SystemGenerateObject73} systemGenerateObject73
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCouponcoupon(systemGenerateObject73: SystemGenerateObject73, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageCouponcoupon(systemGenerateObject73, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 用户兑换券
         * @param {SystemGenerateObject79} systemGenerateObject79
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCouponcoupon(systemGenerateObject79: SystemGenerateObject79, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.redeemCouponcoupon(systemGenerateObject79, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新券
         * @param {SystemGenerateObject75} systemGenerateObject75
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponcoupon(systemGenerateObject75: SystemGenerateObject75, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateCouponcoupon(systemGenerateObject75, options).then((request) => request(axios, basePath));
        },
        /**
         * 如果券有商品信息则需要传入桌id和座位编号创建订单
         * @summary 管理员核销券
         * @param {SystemGenerateObject77} systemGenerateObject77
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCouponcoupon(systemGenerateObject77: SystemGenerateObject77, options?: any): AxiosPromise<any> {
            return localVarFp.verifyCouponcoupon(systemGenerateObject77, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponApi - object-oriented interface
 * @export
 * @class CouponApi
 * @extends {BaseAPI}
 */
export class CouponApi extends BaseAPI {
    /**
     *
     * @summary 添加券
     * @param {SystemGenerateObject74} systemGenerateObject74
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public addCouponcoupon(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).addCouponcoupon(systemGenerateObject74, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除券
     * @param {number} couponId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public delCouponcoupon(couponId: number, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).delCouponcoupon(couponId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 通过ID查询单个券
     * @param {SystemGenerateObject76} systemGenerateObject76
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public findCouponByIdcoupon(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).findCouponByIdcoupon(systemGenerateObject76, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取券列表
     * @param {SystemGenerateObject72} systemGenerateObject72
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public listCouponcoupon(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).listCouponcoupon(systemGenerateObject72, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取我的券列表
     * @param {SystemGenerateObject78} systemGenerateObject78
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public listMyCouponcoupon(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).listMyCouponcoupon(systemGenerateObject78, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取券列表(分页)
     * @param {SystemGenerateObject73} systemGenerateObject73
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public pageCouponcoupon(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).pageCouponcoupon(systemGenerateObject73, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 用户兑换券
     * @param {SystemGenerateObject79} systemGenerateObject79
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public redeemCouponcoupon(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).redeemCouponcoupon(systemGenerateObject79, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新券
     * @param {SystemGenerateObject75} systemGenerateObject75
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public updateCouponcoupon(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).updateCouponcoupon(systemGenerateObject75, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 如果券有商品信息则需要传入桌id和座位编号创建订单
     * @summary 管理员核销券
     * @param {SystemGenerateObject77} systemGenerateObject77
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public verifyCouponcoupon(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).verifyCouponcoupon(systemGenerateObject77, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CouponTypeApi - axios parameter creator
 * @export
 */
export const CouponTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加券类型
         * @param {SystemGenerateObject70} systemGenerateObject70
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponTypecouponType: async (systemGenerateObject70: SystemGenerateObject70, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject70' is not null or undefined
            assertParamExists('addCouponTypecouponType', 'systemGenerateObject70', systemGenerateObject70)
            const localVarPath = `/couponType/addCouponType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject70, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除券类型
         * @param {number} couponTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCouponTypecouponType: async (couponTypeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponTypeId' is not null or undefined
            assertParamExists('delCouponTypecouponType', 'couponTypeId', couponTypeId)
            const localVarPath = `/couponType/delCouponType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (couponTypeId !== undefined) {
                localVarQueryParameter['couponTypeId'] = couponTypeId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取券类型列表
         * @param {SystemGenerateObject68} systemGenerateObject68
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponTypecouponType: async (systemGenerateObject68: SystemGenerateObject68, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject68' is not null or undefined
            assertParamExists('listCouponTypecouponType', 'systemGenerateObject68', systemGenerateObject68)
            const localVarPath = `/couponType/listCouponType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject68, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取券类型列表(分页)
         * @param {SystemGenerateObject69} systemGenerateObject69
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCouponTypecouponType: async (systemGenerateObject69: SystemGenerateObject69, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject69' is not null or undefined
            assertParamExists('pageCouponTypecouponType', 'systemGenerateObject69', systemGenerateObject69)
            const localVarPath = `/couponType/pageCouponType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject69, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新券类型
         * @param {SystemGenerateObject71} systemGenerateObject71
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponTypecouponType: async (systemGenerateObject71: SystemGenerateObject71, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject71' is not null or undefined
            assertParamExists('updateCouponTypecouponType', 'systemGenerateObject71', systemGenerateObject71)
            const localVarPath = `/couponType/updateCouponType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject71, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponTypeApi - functional programming interface
 * @export
 */
export const CouponTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponTypeApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加券类型
         * @param {SystemGenerateObject70} systemGenerateObject70
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCouponTypecouponType(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCouponTypecouponType(systemGenerateObject70, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除券类型
         * @param {number} couponTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delCouponTypecouponType(couponTypeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delCouponTypecouponType(couponTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取券类型列表
         * @param {SystemGenerateObject68} systemGenerateObject68
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCouponTypecouponType(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCouponTypecouponType(systemGenerateObject68, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取券类型列表(分页)
         * @param {SystemGenerateObject69} systemGenerateObject69
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCouponTypecouponType(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCouponTypecouponType(systemGenerateObject69, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新券类型
         * @param {SystemGenerateObject71} systemGenerateObject71
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponTypecouponType(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponTypecouponType(systemGenerateObject71, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CouponTypeApi - factory interface
 * @export
 */
export const CouponTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponTypeApiFp(configuration)
    return {
        /**
         *
         * @summary 添加券类型
         * @param {SystemGenerateObject70} systemGenerateObject70
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponTypecouponType(systemGenerateObject70: SystemGenerateObject70, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addCouponTypecouponType(systemGenerateObject70, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除券类型
         * @param {number} couponTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delCouponTypecouponType(couponTypeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delCouponTypecouponType(couponTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取券类型列表
         * @param {SystemGenerateObject68} systemGenerateObject68
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponTypecouponType(systemGenerateObject68: SystemGenerateObject68, options?: any): AxiosPromise<any> {
            return localVarFp.listCouponTypecouponType(systemGenerateObject68, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取券类型列表(分页)
         * @param {SystemGenerateObject69} systemGenerateObject69
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCouponTypecouponType(systemGenerateObject69: SystemGenerateObject69, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageCouponTypecouponType(systemGenerateObject69, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新券类型
         * @param {SystemGenerateObject71} systemGenerateObject71
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponTypecouponType(systemGenerateObject71: SystemGenerateObject71, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateCouponTypecouponType(systemGenerateObject71, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponTypeApi - object-oriented interface
 * @export
 * @class CouponTypeApi
 * @extends {BaseAPI}
 */
export class CouponTypeApi extends BaseAPI {
    /**
     *
     * @summary 添加券类型
     * @param {SystemGenerateObject70} systemGenerateObject70
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponTypeApi
     */
    public addCouponTypecouponType(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig) {
        return CouponTypeApiFp(this.configuration).addCouponTypecouponType(systemGenerateObject70, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除券类型
     * @param {number} couponTypeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponTypeApi
     */
    public delCouponTypecouponType(couponTypeId: number, options?: AxiosRequestConfig) {
        return CouponTypeApiFp(this.configuration).delCouponTypecouponType(couponTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取券类型列表
     * @param {SystemGenerateObject68} systemGenerateObject68
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponTypeApi
     */
    public listCouponTypecouponType(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig) {
        return CouponTypeApiFp(this.configuration).listCouponTypecouponType(systemGenerateObject68, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取券类型列表(分页)
     * @param {SystemGenerateObject69} systemGenerateObject69
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponTypeApi
     */
    public pageCouponTypecouponType(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig) {
        return CouponTypeApiFp(this.configuration).pageCouponTypecouponType(systemGenerateObject69, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新券类型
     * @param {SystemGenerateObject71} systemGenerateObject71
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponTypeApi
     */
    public updateCouponTypecouponType(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig) {
        return CouponTypeApiFp(this.configuration).updateCouponTypecouponType(systemGenerateObject71, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DesktopApi - axios parameter creator
 * @export
 */
export const DesktopApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加桌面
         * @param {SystemGenerateObject61} systemGenerateObject61
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesktopdesktop: async (systemGenerateObject61: SystemGenerateObject61, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject61' is not null or undefined
            assertParamExists('addDesktopdesktop', 'systemGenerateObject61', systemGenerateObject61)
            const localVarPath = `/desktop/addDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject61, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除桌面
         * @param {number} desktopId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDesktopdesktop: async (desktopId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'desktopId' is not null or undefined
            assertParamExists('delDesktopdesktop', 'desktopId', desktopId)
            const localVarPath = `/desktop/delDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (desktopId !== undefined) {
                localVarQueryParameter['desktopId'] = desktopId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 离开座位
         * @param {SystemGenerateObject65} systemGenerateObject65
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveSeatdesktop: async (systemGenerateObject65: SystemGenerateObject65, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject65' is not null or undefined
            assertParamExists('leaveSeatdesktop', 'systemGenerateObject65', systemGenerateObject65)
            const localVarPath = `/desktop/leaveSeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject65, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取桌面列表
         * @param {SystemGenerateObject59} systemGenerateObject59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDesktopdesktop: async (systemGenerateObject59: SystemGenerateObject59, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject59' is not null or undefined
            assertParamExists('listDesktopdesktop', 'systemGenerateObject59', systemGenerateObject59)
            const localVarPath = `/desktop/listDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject59, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取桌面列表(分页)
         * @param {SystemGenerateObject60} systemGenerateObject60
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDesktopdesktop: async (systemGenerateObject60: SystemGenerateObject60, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject60' is not null or undefined
            assertParamExists('pageDesktopdesktop', 'systemGenerateObject60', systemGenerateObject60)
            const localVarPath = `/desktop/pageDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject60, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 预约桌位
         * @param {SystemGenerateObject64} systemGenerateObject64
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveSeatdesktop: async (systemGenerateObject64: SystemGenerateObject64, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject64' is not null or undefined
            assertParamExists('reserveSeatdesktop', 'systemGenerateObject64', systemGenerateObject64)
            const localVarPath = `/desktop/reserveSeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject64, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置桌面座位
         * @param {SystemGenerateObject63} systemGenerateObject63
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeatdesktop: async (systemGenerateObject63: SystemGenerateObject63, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject63' is not null or undefined
            assertParamExists('setSeatdesktop', 'systemGenerateObject63', systemGenerateObject63)
            const localVarPath = `/desktop/setSeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject63, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 将用户设置为游戏中状态，用户需在此位置预约或在侯桌列表中
         * @summary 管理员上桌
         * @param {SystemGenerateObject66} systemGenerateObject66
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sitDowndesktop: async (systemGenerateObject66: SystemGenerateObject66, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject66' is not null or undefined
            assertParamExists('sitDowndesktop', 'systemGenerateObject66', systemGenerateObject66)
            const localVarPath = `/desktop/sitDown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject66, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 删除对应位置的用户信息
         * @summary 管理员下桌
         * @param {SystemGenerateObject67} systemGenerateObject67
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standUpdesktop: async (systemGenerateObject67: SystemGenerateObject67, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject67' is not null or undefined
            assertParamExists('standUpdesktop', 'systemGenerateObject67', systemGenerateObject67)
            const localVarPath = `/desktop/standUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject67, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新桌面
         * @param {SystemGenerateObject62} systemGenerateObject62
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDesktopdesktop: async (systemGenerateObject62: SystemGenerateObject62, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject62' is not null or undefined
            assertParamExists('updateDesktopdesktop', 'systemGenerateObject62', systemGenerateObject62)
            const localVarPath = `/desktop/updateDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject62, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesktopApi - functional programming interface
 * @export
 */
export const DesktopApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesktopApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加桌面
         * @param {SystemGenerateObject61} systemGenerateObject61
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDesktopdesktop(systemGenerateObject61: SystemGenerateObject61, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDesktopdesktop(systemGenerateObject61, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除桌面
         * @param {number} desktopId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDesktopdesktop(desktopId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDesktopdesktop(desktopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 离开座位
         * @param {SystemGenerateObject65} systemGenerateObject65
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveSeatdesktop(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveSeatdesktop(systemGenerateObject65, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取桌面列表
         * @param {SystemGenerateObject59} systemGenerateObject59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDesktopdesktop(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDesktopdesktop(systemGenerateObject59, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取桌面列表(分页)
         * @param {SystemGenerateObject60} systemGenerateObject60
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDesktopdesktop(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDesktopdesktop(systemGenerateObject60, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 预约桌位
         * @param {SystemGenerateObject64} systemGenerateObject64
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reserveSeatdesktop(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reserveSeatdesktop(systemGenerateObject64, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置桌面座位
         * @param {SystemGenerateObject63} systemGenerateObject63
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSeatdesktop(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSeatdesktop(systemGenerateObject63, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 将用户设置为游戏中状态，用户需在此位置预约或在侯桌列表中
         * @summary 管理员上桌
         * @param {SystemGenerateObject66} systemGenerateObject66
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sitDowndesktop(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sitDowndesktop(systemGenerateObject66, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 删除对应位置的用户信息
         * @summary 管理员下桌
         * @param {SystemGenerateObject67} systemGenerateObject67
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async standUpdesktop(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.standUpdesktop(systemGenerateObject67, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新桌面
         * @param {SystemGenerateObject62} systemGenerateObject62
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDesktopdesktop(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDesktopdesktop(systemGenerateObject62, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesktopApi - factory interface
 * @export
 */
export const DesktopApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesktopApiFp(configuration)
    return {
        /**
         *
         * @summary 添加桌面
         * @param {SystemGenerateObject61} systemGenerateObject61
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesktopdesktop(systemGenerateObject61: SystemGenerateObject61, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addDesktopdesktop(systemGenerateObject61, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除桌面
         * @param {number} desktopId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDesktopdesktop(desktopId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delDesktopdesktop(desktopId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 离开座位
         * @param {SystemGenerateObject65} systemGenerateObject65
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveSeatdesktop(systemGenerateObject65: SystemGenerateObject65, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.leaveSeatdesktop(systemGenerateObject65, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取桌面列表
         * @param {SystemGenerateObject59} systemGenerateObject59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDesktopdesktop(systemGenerateObject59: SystemGenerateObject59, options?: any): AxiosPromise<any> {
            return localVarFp.listDesktopdesktop(systemGenerateObject59, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取桌面列表(分页)
         * @param {SystemGenerateObject60} systemGenerateObject60
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDesktopdesktop(systemGenerateObject60: SystemGenerateObject60, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageDesktopdesktop(systemGenerateObject60, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 预约桌位
         * @param {SystemGenerateObject64} systemGenerateObject64
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveSeatdesktop(systemGenerateObject64: SystemGenerateObject64, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.reserveSeatdesktop(systemGenerateObject64, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置桌面座位
         * @param {SystemGenerateObject63} systemGenerateObject63
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeatdesktop(systemGenerateObject63: SystemGenerateObject63, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setSeatdesktop(systemGenerateObject63, options).then((request) => request(axios, basePath));
        },
        /**
         * 将用户设置为游戏中状态，用户需在此位置预约或在侯桌列表中
         * @summary 管理员上桌
         * @param {SystemGenerateObject66} systemGenerateObject66
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sitDowndesktop(systemGenerateObject66: SystemGenerateObject66, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.sitDowndesktop(systemGenerateObject66, options).then((request) => request(axios, basePath));
        },
        /**
         * 删除对应位置的用户信息
         * @summary 管理员下桌
         * @param {SystemGenerateObject67} systemGenerateObject67
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standUpdesktop(systemGenerateObject67: SystemGenerateObject67, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.standUpdesktop(systemGenerateObject67, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新桌面
         * @param {SystemGenerateObject62} systemGenerateObject62
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDesktopdesktop(systemGenerateObject62: SystemGenerateObject62, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateDesktopdesktop(systemGenerateObject62, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesktopApi - object-oriented interface
 * @export
 * @class DesktopApi
 * @extends {BaseAPI}
 */
export class DesktopApi extends BaseAPI {
    /**
     *
     * @summary 添加桌面
     * @param {SystemGenerateObject61} systemGenerateObject61
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public addDesktopdesktop(systemGenerateObject61: SystemGenerateObject61, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).addDesktopdesktop(systemGenerateObject61, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除桌面
     * @param {number} desktopId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public delDesktopdesktop(desktopId: number, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).delDesktopdesktop(desktopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 离开座位
     * @param {SystemGenerateObject65} systemGenerateObject65
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public leaveSeatdesktop(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).leaveSeatdesktop(systemGenerateObject65, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取桌面列表
     * @param {SystemGenerateObject59} systemGenerateObject59
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public listDesktopdesktop(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).listDesktopdesktop(systemGenerateObject59, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取桌面列表(分页)
     * @param {SystemGenerateObject60} systemGenerateObject60
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public pageDesktopdesktop(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).pageDesktopdesktop(systemGenerateObject60, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 预约桌位
     * @param {SystemGenerateObject64} systemGenerateObject64
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public reserveSeatdesktop(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).reserveSeatdesktop(systemGenerateObject64, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置桌面座位
     * @param {SystemGenerateObject63} systemGenerateObject63
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public setSeatdesktop(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).setSeatdesktop(systemGenerateObject63, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 将用户设置为游戏中状态，用户需在此位置预约或在侯桌列表中
     * @summary 管理员上桌
     * @param {SystemGenerateObject66} systemGenerateObject66
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public sitDowndesktop(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).sitDowndesktop(systemGenerateObject66, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 删除对应位置的用户信息
     * @summary 管理员下桌
     * @param {SystemGenerateObject67} systemGenerateObject67
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public standUpdesktop(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).standUpdesktop(systemGenerateObject67, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新桌面
     * @param {SystemGenerateObject62} systemGenerateObject62
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApi
     */
    public updateDesktopdesktop(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig) {
        return DesktopApiFp(this.configuration).updateDesktopdesktop(systemGenerateObject62, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoodsApi - axios parameter creator
 * @export
 */
export const GoodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加商品
         * @param {SystemGenerateObject56} systemGenerateObject56
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGoodsgoods: async (systemGenerateObject56: SystemGenerateObject56, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject56' is not null or undefined
            assertParamExists('addGoodsgoods', 'systemGenerateObject56', systemGenerateObject56)
            const localVarPath = `/goods/addGoods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject56, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除商品
         * @param {number} goodsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delGoodsgoods: async (goodsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goodsId' is not null or undefined
            assertParamExists('delGoodsgoods', 'goodsId', goodsId)
            const localVarPath = `/goods/delGoods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (goodsId !== undefined) {
                localVarQueryParameter['goodsId'] = goodsId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取商品列表
         * @param {SystemGenerateObject54} systemGenerateObject54
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoodsgoods: async (systemGenerateObject54: SystemGenerateObject54, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject54' is not null or undefined
            assertParamExists('listGoodsgoods', 'systemGenerateObject54', systemGenerateObject54)
            const localVarPath = `/goods/listGoods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject54, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取商品列表(分页)
         * @param {SystemGenerateObject55} systemGenerateObject55
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageGoodsgoods: async (systemGenerateObject55: SystemGenerateObject55, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject55' is not null or undefined
            assertParamExists('pageGoodsgoods', 'systemGenerateObject55', systemGenerateObject55)
            const localVarPath = `/goods/pageGoods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject55, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 用户下单
         * @param {SystemGenerateObject58} systemGenerateObject58
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrdergoods: async (systemGenerateObject58: SystemGenerateObject58, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject58' is not null or undefined
            assertParamExists('placeOrdergoods', 'systemGenerateObject58', systemGenerateObject58)
            const localVarPath = `/goods/placeOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject58, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新商品
         * @param {SystemGenerateObject57} systemGenerateObject57
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGoodsgoods: async (systemGenerateObject57: SystemGenerateObject57, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject57' is not null or undefined
            assertParamExists('updateGoodsgoods', 'systemGenerateObject57', systemGenerateObject57)
            const localVarPath = `/goods/updateGoods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject57, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoodsApi - functional programming interface
 * @export
 */
export const GoodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoodsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加商品
         * @param {SystemGenerateObject56} systemGenerateObject56
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGoodsgoods(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGoodsgoods(systemGenerateObject56, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除商品
         * @param {number} goodsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delGoodsgoods(goodsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delGoodsgoods(goodsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取商品列表
         * @param {SystemGenerateObject54} systemGenerateObject54
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGoodsgoods(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGoodsgoods(systemGenerateObject54, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取商品列表(分页)
         * @param {SystemGenerateObject55} systemGenerateObject55
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageGoodsgoods(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageGoodsgoods(systemGenerateObject55, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 用户下单
         * @param {SystemGenerateObject58} systemGenerateObject58
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeOrdergoods(systemGenerateObject58: SystemGenerateObject58, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeOrdergoods(systemGenerateObject58, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新商品
         * @param {SystemGenerateObject57} systemGenerateObject57
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGoodsgoods(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGoodsgoods(systemGenerateObject57, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GoodsApi - factory interface
 * @export
 */
export const GoodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoodsApiFp(configuration)
    return {
        /**
         *
         * @summary 添加商品
         * @param {SystemGenerateObject56} systemGenerateObject56
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGoodsgoods(systemGenerateObject56: SystemGenerateObject56, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addGoodsgoods(systemGenerateObject56, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除商品
         * @param {number} goodsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delGoodsgoods(goodsId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delGoodsgoods(goodsId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取商品列表
         * @param {SystemGenerateObject54} systemGenerateObject54
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoodsgoods(systemGenerateObject54: SystemGenerateObject54, options?: any): AxiosPromise<any> {
            return localVarFp.listGoodsgoods(systemGenerateObject54, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取商品列表(分页)
         * @param {SystemGenerateObject55} systemGenerateObject55
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageGoodsgoods(systemGenerateObject55: SystemGenerateObject55, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageGoodsgoods(systemGenerateObject55, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 用户下单
         * @param {SystemGenerateObject58} systemGenerateObject58
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrdergoods(systemGenerateObject58: SystemGenerateObject58, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.placeOrdergoods(systemGenerateObject58, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新商品
         * @param {SystemGenerateObject57} systemGenerateObject57
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGoodsgoods(systemGenerateObject57: SystemGenerateObject57, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateGoodsgoods(systemGenerateObject57, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoodsApi - object-oriented interface
 * @export
 * @class GoodsApi
 * @extends {BaseAPI}
 */
export class GoodsApi extends BaseAPI {
    /**
     *
     * @summary 添加商品
     * @param {SystemGenerateObject56} systemGenerateObject56
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public addGoodsgoods(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).addGoodsgoods(systemGenerateObject56, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除商品
     * @param {number} goodsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public delGoodsgoods(goodsId: number, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).delGoodsgoods(goodsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取商品列表
     * @param {SystemGenerateObject54} systemGenerateObject54
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public listGoodsgoods(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).listGoodsgoods(systemGenerateObject54, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取商品列表(分页)
     * @param {SystemGenerateObject55} systemGenerateObject55
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public pageGoodsgoods(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).pageGoodsgoods(systemGenerateObject55, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 用户下单
     * @param {SystemGenerateObject58} systemGenerateObject58
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public placeOrdergoods(systemGenerateObject58: SystemGenerateObject58, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).placeOrdergoods(systemGenerateObject58, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新商品
     * @param {SystemGenerateObject57} systemGenerateObject57
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodsApi
     */
    public updateGoodsgoods(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig) {
        return GoodsApiFp(this.configuration).updateGoodsgoods(systemGenerateObject57, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InviteRuleApi - axios parameter creator
 * @export
 */
export const InviteRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取邀请规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteRuleinviteRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inviteRule/getInviteRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 重置邀请规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetInviteRuleinviteRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inviteRule/resetInviteRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置邀请规则
         * @param {SystemGenerateObject106} systemGenerateObject106
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInviteRuleinviteRule: async (systemGenerateObject106: SystemGenerateObject106, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject106' is not null or undefined
            assertParamExists('setInviteRuleinviteRule', 'systemGenerateObject106', systemGenerateObject106)
            const localVarPath = `/inviteRule/setInviteRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject106, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新邀请规则
         * @param {SystemGenerateObject107} systemGenerateObject107
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInviteRuleinviteRule: async (systemGenerateObject107: SystemGenerateObject107, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject107' is not null or undefined
            assertParamExists('updateInviteRuleinviteRule', 'systemGenerateObject107', systemGenerateObject107)
            const localVarPath = `/inviteRule/updateInviteRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject107, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InviteRuleApi - functional programming interface
 * @export
 */
export const InviteRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InviteRuleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取邀请规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInviteRuleinviteRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInviteRuleinviteRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 重置邀请规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetInviteRuleinviteRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetInviteRuleinviteRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置邀请规则
         * @param {SystemGenerateObject106} systemGenerateObject106
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setInviteRuleinviteRule(systemGenerateObject106: SystemGenerateObject106, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setInviteRuleinviteRule(systemGenerateObject106, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新邀请规则
         * @param {SystemGenerateObject107} systemGenerateObject107
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInviteRuleinviteRule(systemGenerateObject107: SystemGenerateObject107, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInviteRuleinviteRule(systemGenerateObject107, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InviteRuleApi - factory interface
 * @export
 */
export const InviteRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InviteRuleApiFp(configuration)
    return {
        /**
         *
         * @summary 获取邀请规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteRuleinviteRule(options?: any): AxiosPromise<any> {
            return localVarFp.getInviteRuleinviteRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 重置邀请规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetInviteRuleinviteRule(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.resetInviteRuleinviteRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置邀请规则
         * @param {SystemGenerateObject106} systemGenerateObject106
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInviteRuleinviteRule(systemGenerateObject106: SystemGenerateObject106, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setInviteRuleinviteRule(systemGenerateObject106, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新邀请规则
         * @param {SystemGenerateObject107} systemGenerateObject107
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInviteRuleinviteRule(systemGenerateObject107: SystemGenerateObject107, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateInviteRuleinviteRule(systemGenerateObject107, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InviteRuleApi - object-oriented interface
 * @export
 * @class InviteRuleApi
 * @extends {BaseAPI}
 */
export class InviteRuleApi extends BaseAPI {
    /**
     *
     * @summary 获取邀请规则
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteRuleApi
     */
    public getInviteRuleinviteRule(options?: AxiosRequestConfig) {
        return InviteRuleApiFp(this.configuration).getInviteRuleinviteRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 重置邀请规则为默认值
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteRuleApi
     */
    public resetInviteRuleinviteRule(options?: AxiosRequestConfig) {
        return InviteRuleApiFp(this.configuration).resetInviteRuleinviteRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置邀请规则
     * @param {SystemGenerateObject106} systemGenerateObject106
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteRuleApi
     */
    public setInviteRuleinviteRule(systemGenerateObject106: SystemGenerateObject106, options?: AxiosRequestConfig) {
        return InviteRuleApiFp(this.configuration).setInviteRuleinviteRule(systemGenerateObject106, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新邀请规则
     * @param {SystemGenerateObject107} systemGenerateObject107
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteRuleApi
     */
    public updateInviteRuleinviteRule(systemGenerateObject107: SystemGenerateObject107, options?: AxiosRequestConfig) {
        return InviteRuleApiFp(this.configuration).updateInviteRuleinviteRule(systemGenerateObject107, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderDesktopApi - axios parameter creator
 * @export
 */
export const OrderDesktopApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加排桌
         * @param {SystemGenerateObject131} systemGenerateObject131
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderDesktoporderDesktop: async (systemGenerateObject131: SystemGenerateObject131, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject131' is not null or undefined
            assertParamExists('addOrderDesktoporderDesktop', 'systemGenerateObject131', systemGenerateObject131)
            const localVarPath = `/orderDesktop/addOrderDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject131, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除排桌
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrderDesktoporderDesktop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delOrderDesktoporderDesktop', 'id', id)
            const localVarPath = `/orderDesktop/delOrderDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取排桌列表
         * @param {SystemGenerateObject129} systemGenerateObject129
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderDesktoporderDesktop: async (systemGenerateObject129: SystemGenerateObject129, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject129' is not null or undefined
            assertParamExists('listOrderDesktoporderDesktop', 'systemGenerateObject129', systemGenerateObject129)
            const localVarPath = `/orderDesktop/listOrderDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject129, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取排桌列表(分页)
         * @param {SystemGenerateObject130} systemGenerateObject130
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrderDesktoporderDesktop: async (systemGenerateObject130: SystemGenerateObject130, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject130' is not null or undefined
            assertParamExists('pageOrderDesktoporderDesktop', 'systemGenerateObject130', systemGenerateObject130)
            const localVarPath = `/orderDesktop/pageOrderDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject130, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新排桌
         * @param {SystemGenerateObject132} systemGenerateObject132
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderDesktoporderDesktop: async (systemGenerateObject132: SystemGenerateObject132, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject132' is not null or undefined
            assertParamExists('updateOrderDesktoporderDesktop', 'systemGenerateObject132', systemGenerateObject132)
            const localVarPath = `/orderDesktop/updateOrderDesktop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject132, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDesktopApi - functional programming interface
 * @export
 */
export const OrderDesktopApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDesktopApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加排桌
         * @param {SystemGenerateObject131} systemGenerateObject131
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrderDesktoporderDesktop(systemGenerateObject131: SystemGenerateObject131, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrderDesktoporderDesktop(systemGenerateObject131, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除排桌
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOrderDesktoporderDesktop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOrderDesktoporderDesktop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取排桌列表
         * @param {SystemGenerateObject129} systemGenerateObject129
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrderDesktoporderDesktop(systemGenerateObject129: SystemGenerateObject129, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrderDesktoporderDesktop(systemGenerateObject129, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取排桌列表(分页)
         * @param {SystemGenerateObject130} systemGenerateObject130
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrderDesktoporderDesktop(systemGenerateObject130: SystemGenerateObject130, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrderDesktoporderDesktop(systemGenerateObject130, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新排桌
         * @param {SystemGenerateObject132} systemGenerateObject132
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderDesktoporderDesktop(systemGenerateObject132: SystemGenerateObject132, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderDesktoporderDesktop(systemGenerateObject132, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderDesktopApi - factory interface
 * @export
 */
export const OrderDesktopApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDesktopApiFp(configuration)
    return {
        /**
         *
         * @summary 添加排桌
         * @param {SystemGenerateObject131} systemGenerateObject131
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderDesktoporderDesktop(systemGenerateObject131: SystemGenerateObject131, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addOrderDesktoporderDesktop(systemGenerateObject131, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除排桌
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrderDesktoporderDesktop(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delOrderDesktoporderDesktop(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取排桌列表
         * @param {SystemGenerateObject129} systemGenerateObject129
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderDesktoporderDesktop(systemGenerateObject129: SystemGenerateObject129, options?: any): AxiosPromise<any> {
            return localVarFp.listOrderDesktoporderDesktop(systemGenerateObject129, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取排桌列表(分页)
         * @param {SystemGenerateObject130} systemGenerateObject130
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrderDesktoporderDesktop(systemGenerateObject130: SystemGenerateObject130, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageOrderDesktoporderDesktop(systemGenerateObject130, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新排桌
         * @param {SystemGenerateObject132} systemGenerateObject132
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderDesktoporderDesktop(systemGenerateObject132: SystemGenerateObject132, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateOrderDesktoporderDesktop(systemGenerateObject132, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDesktopApi - object-oriented interface
 * @export
 * @class OrderDesktopApi
 * @extends {BaseAPI}
 */
export class OrderDesktopApi extends BaseAPI {
    /**
     *
     * @summary 添加排桌
     * @param {SystemGenerateObject131} systemGenerateObject131
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesktopApi
     */
    public addOrderDesktoporderDesktop(systemGenerateObject131: SystemGenerateObject131, options?: AxiosRequestConfig) {
        return OrderDesktopApiFp(this.configuration).addOrderDesktoporderDesktop(systemGenerateObject131, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除排桌
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesktopApi
     */
    public delOrderDesktoporderDesktop(id: number, options?: AxiosRequestConfig) {
        return OrderDesktopApiFp(this.configuration).delOrderDesktoporderDesktop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取排桌列表
     * @param {SystemGenerateObject129} systemGenerateObject129
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesktopApi
     */
    public listOrderDesktoporderDesktop(systemGenerateObject129: SystemGenerateObject129, options?: AxiosRequestConfig) {
        return OrderDesktopApiFp(this.configuration).listOrderDesktoporderDesktop(systemGenerateObject129, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取排桌列表(分页)
     * @param {SystemGenerateObject130} systemGenerateObject130
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesktopApi
     */
    public pageOrderDesktoporderDesktop(systemGenerateObject130: SystemGenerateObject130, options?: AxiosRequestConfig) {
        return OrderDesktopApiFp(this.configuration).pageOrderDesktoporderDesktop(systemGenerateObject130, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新排桌
     * @param {SystemGenerateObject132} systemGenerateObject132
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesktopApi
     */
    public updateOrderDesktoporderDesktop(systemGenerateObject132: SystemGenerateObject132, options?: AxiosRequestConfig) {
        return OrderDesktopApiFp(this.configuration).updateOrderDesktoporderDesktop(systemGenerateObject132, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointsApplyApi - axios parameter creator
 * @export
 */
export const PointsApplyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加积分申请
         * @param {SystemGenerateObject120} systemGenerateObject120
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointsApplypointsApply: async (systemGenerateObject120: SystemGenerateObject120, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject120' is not null or undefined
            assertParamExists('addPointsApplypointsApply', 'systemGenerateObject120', systemGenerateObject120)
            const localVarPath = `/pointsApply/addPointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject120, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 存入超过限额时需要指定convertType（积分转换类型）
         * @summary 审批积分申请
         * @param {number} applyId
         * @param {SystemGenerateObject122} systemGenerateObject122
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePointsApplypointsApply: async (applyId: number, systemGenerateObject122: SystemGenerateObject122, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyId' is not null or undefined
            assertParamExists('approvePointsApplypointsApply', 'applyId', applyId)
            // verify required parameter 'systemGenerateObject122' is not null or undefined
            assertParamExists('approvePointsApplypointsApply', 'systemGenerateObject122', systemGenerateObject122)
            const localVarPath = `/pointsApply/approvePointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (applyId !== undefined) {
                localVarQueryParameter['applyId'] = applyId;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject122, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 一次性补录历史数据的收益积分字段，仅需执行一次
         * @summary 补录历史收益积分
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillProfitPointspointsApply: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pointsApply/backfillProfitPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除积分申请
         * @param {number} applyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPointsApplypointsApply: async (applyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyId' is not null or undefined
            assertParamExists('delPointsApplypointsApply', 'applyId', applyId)
            const localVarPath = `/pointsApply/delPointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (applyId !== undefined) {
                localVarQueryParameter['applyId'] = applyId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取积分申请列表
         * @param {SystemGenerateObject117} systemGenerateObject117
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsApplypointsApply: async (systemGenerateObject117: SystemGenerateObject117, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject117' is not null or undefined
            assertParamExists('listPointsApplypointsApply', 'systemGenerateObject117', systemGenerateObject117)
            const localVarPath = `/pointsApply/listPointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject117, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 分页获取我的积分申请列表
         * @param {SystemGenerateObject119} systemGenerateObject119
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyPointsApplypointsApply: async (systemGenerateObject119: SystemGenerateObject119, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject119' is not null or undefined
            assertParamExists('pageMyPointsApplypointsApply', 'systemGenerateObject119', systemGenerateObject119)
            const localVarPath = `/pointsApply/my/pageMyPointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject119, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取积分申请列表(分页)
         * @param {SystemGenerateObject118} systemGenerateObject118
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePointsApplypointsApply: async (systemGenerateObject118: SystemGenerateObject118, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject118' is not null or undefined
            assertParamExists('pagePointsApplypointsApply', 'systemGenerateObject118', systemGenerateObject118)
            const localVarPath = `/pointsApply/pagePointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject118, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新积分申请
         * @param {SystemGenerateObject121} systemGenerateObject121
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsApplypointsApply: async (systemGenerateObject121: SystemGenerateObject121, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject121' is not null or undefined
            assertParamExists('updatePointsApplypointsApply', 'systemGenerateObject121', systemGenerateObject121)
            const localVarPath = `/pointsApply/updatePointsApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject121, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointsApplyApi - functional programming interface
 * @export
 */
export const PointsApplyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointsApplyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加积分申请
         * @param {SystemGenerateObject120} systemGenerateObject120
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPointsApplypointsApply(systemGenerateObject120: SystemGenerateObject120, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPointsApplypointsApply(systemGenerateObject120, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 存入超过限额时需要指定convertType（积分转换类型）
         * @summary 审批积分申请
         * @param {number} applyId
         * @param {SystemGenerateObject122} systemGenerateObject122
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePointsApplypointsApply(applyId: number, systemGenerateObject122: SystemGenerateObject122, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePointsApplypointsApply(applyId, systemGenerateObject122, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 一次性补录历史数据的收益积分字段，仅需执行一次
         * @summary 补录历史收益积分
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backfillProfitPointspointsApply(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backfillProfitPointspointsApply(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除积分申请
         * @param {number} applyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delPointsApplypointsApply(applyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delPointsApplypointsApply(applyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取积分申请列表
         * @param {SystemGenerateObject117} systemGenerateObject117
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPointsApplypointsApply(systemGenerateObject117: SystemGenerateObject117, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPointsApplypointsApply(systemGenerateObject117, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 分页获取我的积分申请列表
         * @param {SystemGenerateObject119} systemGenerateObject119
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMyPointsApplypointsApply(systemGenerateObject119: SystemGenerateObject119, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMyPointsApplypointsApply(systemGenerateObject119, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取积分申请列表(分页)
         * @param {SystemGenerateObject118} systemGenerateObject118
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePointsApplypointsApply(systemGenerateObject118: SystemGenerateObject118, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePointsApplypointsApply(systemGenerateObject118, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新积分申请
         * @param {SystemGenerateObject121} systemGenerateObject121
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePointsApplypointsApply(systemGenerateObject121: SystemGenerateObject121, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePointsApplypointsApply(systemGenerateObject121, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointsApplyApi - factory interface
 * @export
 */
export const PointsApplyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointsApplyApiFp(configuration)
    return {
        /**
         *
         * @summary 添加积分申请
         * @param {SystemGenerateObject120} systemGenerateObject120
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointsApplypointsApply(systemGenerateObject120: SystemGenerateObject120, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addPointsApplypointsApply(systemGenerateObject120, options).then((request) => request(axios, basePath));
        },
        /**
         * 存入超过限额时需要指定convertType（积分转换类型）
         * @summary 审批积分申请
         * @param {number} applyId
         * @param {SystemGenerateObject122} systemGenerateObject122
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePointsApplypointsApply(applyId: number, systemGenerateObject122: SystemGenerateObject122, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.approvePointsApplypointsApply(applyId, systemGenerateObject122, options).then((request) => request(axios, basePath));
        },
        /**
         * 一次性补录历史数据的收益积分字段，仅需执行一次
         * @summary 补录历史收益积分
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillProfitPointspointsApply(options?: any): AxiosPromise<any> {
            return localVarFp.backfillProfitPointspointsApply(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除积分申请
         * @param {number} applyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPointsApplypointsApply(applyId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delPointsApplypointsApply(applyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取积分申请列表
         * @param {SystemGenerateObject117} systemGenerateObject117
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsApplypointsApply(systemGenerateObject117: SystemGenerateObject117, options?: any): AxiosPromise<any> {
            return localVarFp.listPointsApplypointsApply(systemGenerateObject117, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 分页获取我的积分申请列表
         * @param {SystemGenerateObject119} systemGenerateObject119
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyPointsApplypointsApply(systemGenerateObject119: SystemGenerateObject119, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageMyPointsApplypointsApply(systemGenerateObject119, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取积分申请列表(分页)
         * @param {SystemGenerateObject118} systemGenerateObject118
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePointsApplypointsApply(systemGenerateObject118: SystemGenerateObject118, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pagePointsApplypointsApply(systemGenerateObject118, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新积分申请
         * @param {SystemGenerateObject121} systemGenerateObject121
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsApplypointsApply(systemGenerateObject121: SystemGenerateObject121, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updatePointsApplypointsApply(systemGenerateObject121, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointsApplyApi - object-oriented interface
 * @export
 * @class PointsApplyApi
 * @extends {BaseAPI}
 */
export class PointsApplyApi extends BaseAPI {
    /**
     *
     * @summary 添加积分申请
     * @param {SystemGenerateObject120} systemGenerateObject120
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public addPointsApplypointsApply(systemGenerateObject120: SystemGenerateObject120, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).addPointsApplypointsApply(systemGenerateObject120, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 存入超过限额时需要指定convertType（积分转换类型）
     * @summary 审批积分申请
     * @param {number} applyId
     * @param {SystemGenerateObject122} systemGenerateObject122
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public approvePointsApplypointsApply(applyId: number, systemGenerateObject122: SystemGenerateObject122, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).approvePointsApplypointsApply(applyId, systemGenerateObject122, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 一次性补录历史数据的收益积分字段，仅需执行一次
     * @summary 补录历史收益积分
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public backfillProfitPointspointsApply(options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).backfillProfitPointspointsApply(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除积分申请
     * @param {number} applyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public delPointsApplypointsApply(applyId: number, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).delPointsApplypointsApply(applyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取积分申请列表
     * @param {SystemGenerateObject117} systemGenerateObject117
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public listPointsApplypointsApply(systemGenerateObject117: SystemGenerateObject117, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).listPointsApplypointsApply(systemGenerateObject117, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 分页获取我的积分申请列表
     * @param {SystemGenerateObject119} systemGenerateObject119
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public pageMyPointsApplypointsApply(systemGenerateObject119: SystemGenerateObject119, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).pageMyPointsApplypointsApply(systemGenerateObject119, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取积分申请列表(分页)
     * @param {SystemGenerateObject118} systemGenerateObject118
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public pagePointsApplypointsApply(systemGenerateObject118: SystemGenerateObject118, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).pagePointsApplypointsApply(systemGenerateObject118, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新积分申请
     * @param {SystemGenerateObject121} systemGenerateObject121
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsApplyApi
     */
    public updatePointsApplypointsApply(systemGenerateObject121: SystemGenerateObject121, options?: AxiosRequestConfig) {
        return PointsApplyApiFp(this.configuration).updatePointsApplypointsApply(systemGenerateObject121, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointsRecordApi - axios parameter creator
 * @export
 */
export const PointsRecordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加积分记录
         * @param {SystemGenerateObject95} systemGenerateObject95
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointsRecordpointsRecord: async (systemGenerateObject95: SystemGenerateObject95, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject95' is not null or undefined
            assertParamExists('addPointsRecordpointsRecord', 'systemGenerateObject95', systemGenerateObject95)
            const localVarPath = `/pointsRecord/addPointsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject95, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除积分记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPointsRecordpointsRecord: async (recordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('delPointsRecordpointsRecord', 'recordId', recordId)
            const localVarPath = `/pointsRecord/delPointsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取积分记录列表
         * @param {SystemGenerateObject93} systemGenerateObject93
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsRecordpointsRecord: async (systemGenerateObject93: SystemGenerateObject93, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject93' is not null or undefined
            assertParamExists('listPointsRecordpointsRecord', 'systemGenerateObject93', systemGenerateObject93)
            const localVarPath = `/pointsRecord/listPointsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject93, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取积分记录列表(分页)
         * @param {SystemGenerateObject94} systemGenerateObject94
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePointsRecordpointsRecord: async (systemGenerateObject94: SystemGenerateObject94, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject94' is not null or undefined
            assertParamExists('pagePointsRecordpointsRecord', 'systemGenerateObject94', systemGenerateObject94)
            const localVarPath = `/pointsRecord/pagePointsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject94, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新积分记录
         * @param {SystemGenerateObject96} systemGenerateObject96
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsRecordpointsRecord: async (systemGenerateObject96: SystemGenerateObject96, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject96' is not null or undefined
            assertParamExists('updatePointsRecordpointsRecord', 'systemGenerateObject96', systemGenerateObject96)
            const localVarPath = `/pointsRecord/updatePointsRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject96, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointsRecordApi - functional programming interface
 * @export
 */
export const PointsRecordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointsRecordApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加积分记录
         * @param {SystemGenerateObject95} systemGenerateObject95
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPointsRecordpointsRecord(systemGenerateObject95: SystemGenerateObject95, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPointsRecordpointsRecord(systemGenerateObject95, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除积分记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delPointsRecordpointsRecord(recordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delPointsRecordpointsRecord(recordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取积分记录列表
         * @param {SystemGenerateObject93} systemGenerateObject93
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPointsRecordpointsRecord(systemGenerateObject93: SystemGenerateObject93, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPointsRecordpointsRecord(systemGenerateObject93, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取积分记录列表(分页)
         * @param {SystemGenerateObject94} systemGenerateObject94
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePointsRecordpointsRecord(systemGenerateObject94: SystemGenerateObject94, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePointsRecordpointsRecord(systemGenerateObject94, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新积分记录
         * @param {SystemGenerateObject96} systemGenerateObject96
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePointsRecordpointsRecord(systemGenerateObject96: SystemGenerateObject96, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePointsRecordpointsRecord(systemGenerateObject96, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointsRecordApi - factory interface
 * @export
 */
export const PointsRecordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointsRecordApiFp(configuration)
    return {
        /**
         *
         * @summary 添加积分记录
         * @param {SystemGenerateObject95} systemGenerateObject95
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointsRecordpointsRecord(systemGenerateObject95: SystemGenerateObject95, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addPointsRecordpointsRecord(systemGenerateObject95, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除积分记录
         * @param {number} recordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPointsRecordpointsRecord(recordId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delPointsRecordpointsRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取积分记录列表
         * @param {SystemGenerateObject93} systemGenerateObject93
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsRecordpointsRecord(systemGenerateObject93: SystemGenerateObject93, options?: any): AxiosPromise<any> {
            return localVarFp.listPointsRecordpointsRecord(systemGenerateObject93, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取积分记录列表(分页)
         * @param {SystemGenerateObject94} systemGenerateObject94
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePointsRecordpointsRecord(systemGenerateObject94: SystemGenerateObject94, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pagePointsRecordpointsRecord(systemGenerateObject94, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新积分记录
         * @param {SystemGenerateObject96} systemGenerateObject96
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsRecordpointsRecord(systemGenerateObject96: SystemGenerateObject96, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updatePointsRecordpointsRecord(systemGenerateObject96, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointsRecordApi - object-oriented interface
 * @export
 * @class PointsRecordApi
 * @extends {BaseAPI}
 */
export class PointsRecordApi extends BaseAPI {
    /**
     *
     * @summary 添加积分记录
     * @param {SystemGenerateObject95} systemGenerateObject95
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRecordApi
     */
    public addPointsRecordpointsRecord(systemGenerateObject95: SystemGenerateObject95, options?: AxiosRequestConfig) {
        return PointsRecordApiFp(this.configuration).addPointsRecordpointsRecord(systemGenerateObject95, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除积分记录
     * @param {number} recordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRecordApi
     */
    public delPointsRecordpointsRecord(recordId: number, options?: AxiosRequestConfig) {
        return PointsRecordApiFp(this.configuration).delPointsRecordpointsRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取积分记录列表
     * @param {SystemGenerateObject93} systemGenerateObject93
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRecordApi
     */
    public listPointsRecordpointsRecord(systemGenerateObject93: SystemGenerateObject93, options?: AxiosRequestConfig) {
        return PointsRecordApiFp(this.configuration).listPointsRecordpointsRecord(systemGenerateObject93, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取积分记录列表(分页)
     * @param {SystemGenerateObject94} systemGenerateObject94
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRecordApi
     */
    public pagePointsRecordpointsRecord(systemGenerateObject94: SystemGenerateObject94, options?: AxiosRequestConfig) {
        return PointsRecordApiFp(this.configuration).pagePointsRecordpointsRecord(systemGenerateObject94, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新积分记录
     * @param {SystemGenerateObject96} systemGenerateObject96
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRecordApi
     */
    public updatePointsRecordpointsRecord(systemGenerateObject96: SystemGenerateObject96, options?: AxiosRequestConfig) {
        return PointsRecordApiFp(this.configuration).updatePointsRecordpointsRecord(systemGenerateObject96, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointsRuleApi - axios parameter creator
 * @export
 */
export const PointsRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取积分规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointsRulepointsRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pointsRule/getPointsRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 重置积分规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPointsRulepointsRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pointsRule/resetPointsRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置积分规则
         * @param {SystemGenerateObject104} systemGenerateObject104
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPointsRulepointsRule: async (systemGenerateObject104: SystemGenerateObject104, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject104' is not null or undefined
            assertParamExists('setPointsRulepointsRule', 'systemGenerateObject104', systemGenerateObject104)
            const localVarPath = `/pointsRule/setPointsRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject104, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新积分规则
         * @param {SystemGenerateObject105} systemGenerateObject105
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsRulepointsRule: async (systemGenerateObject105: SystemGenerateObject105, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject105' is not null or undefined
            assertParamExists('updatePointsRulepointsRule', 'systemGenerateObject105', systemGenerateObject105)
            const localVarPath = `/pointsRule/updatePointsRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject105, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointsRuleApi - functional programming interface
 * @export
 */
export const PointsRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointsRuleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取积分规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPointsRulepointsRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPointsRulepointsRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 重置积分规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPointsRulepointsRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPointsRulepointsRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置积分规则
         * @param {SystemGenerateObject104} systemGenerateObject104
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPointsRulepointsRule(systemGenerateObject104: SystemGenerateObject104, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPointsRulepointsRule(systemGenerateObject104, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新积分规则
         * @param {SystemGenerateObject105} systemGenerateObject105
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePointsRulepointsRule(systemGenerateObject105: SystemGenerateObject105, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePointsRulepointsRule(systemGenerateObject105, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointsRuleApi - factory interface
 * @export
 */
export const PointsRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointsRuleApiFp(configuration)
    return {
        /**
         *
         * @summary 获取积分规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointsRulepointsRule(options?: any): AxiosPromise<any> {
            return localVarFp.getPointsRulepointsRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 重置积分规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPointsRulepointsRule(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.resetPointsRulepointsRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置积分规则
         * @param {SystemGenerateObject104} systemGenerateObject104
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPointsRulepointsRule(systemGenerateObject104: SystemGenerateObject104, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setPointsRulepointsRule(systemGenerateObject104, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新积分规则
         * @param {SystemGenerateObject105} systemGenerateObject105
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointsRulepointsRule(systemGenerateObject105: SystemGenerateObject105, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updatePointsRulepointsRule(systemGenerateObject105, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointsRuleApi - object-oriented interface
 * @export
 * @class PointsRuleApi
 * @extends {BaseAPI}
 */
export class PointsRuleApi extends BaseAPI {
    /**
     *
     * @summary 获取积分规则
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRuleApi
     */
    public getPointsRulepointsRule(options?: AxiosRequestConfig) {
        return PointsRuleApiFp(this.configuration).getPointsRulepointsRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 重置积分规则为默认值
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRuleApi
     */
    public resetPointsRulepointsRule(options?: AxiosRequestConfig) {
        return PointsRuleApiFp(this.configuration).resetPointsRulepointsRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置积分规则
     * @param {SystemGenerateObject104} systemGenerateObject104
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRuleApi
     */
    public setPointsRulepointsRule(systemGenerateObject104: SystemGenerateObject104, options?: AxiosRequestConfig) {
        return PointsRuleApiFp(this.configuration).setPointsRulepointsRule(systemGenerateObject104, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新积分规则
     * @param {SystemGenerateObject105} systemGenerateObject105
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsRuleApi
     */
    public updatePointsRulepointsRule(systemGenerateObject105: SystemGenerateObject105, options?: AxiosRequestConfig) {
        return PointsRuleApiFp(this.configuration).updatePointsRulepointsRule(systemGenerateObject105, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RechargeApi - axios parameter creator
 * @export
 */
export const RechargeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加充值套餐
         * @param {SystemGenerateObject114} systemGenerateObject114
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRechargerecharge: async (systemGenerateObject114: SystemGenerateObject114, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject114' is not null or undefined
            assertParamExists('addRechargerecharge', 'systemGenerateObject114', systemGenerateObject114)
            const localVarPath = `/recharge/addRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject114, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除充值套餐
         * @param {number} rechargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRechargerecharge: async (rechargeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rechargeId' is not null or undefined
            assertParamExists('delRechargerecharge', 'rechargeId', rechargeId)
            const localVarPath = `/recharge/delRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rechargeId !== undefined) {
                localVarQueryParameter['rechargeId'] = rechargeId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 用户选择充值套餐进行充值
         * @summary 用户充值
         * @param {SystemGenerateObject116} systemGenerateObject116
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRechargerecharge: async (systemGenerateObject116: SystemGenerateObject116, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject116' is not null or undefined
            assertParamExists('doRechargerecharge', 'systemGenerateObject116', systemGenerateObject116)
            const localVarPath = `/recharge/doRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject116, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 首次打开充值弹窗时，回填用户是否具有首充翻倍资格
         * @summary 获取用户首充翻倍资格
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirstChargeEligibilityrecharge: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recharge/getFirstChargeEligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject112} systemGenerateObject112
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRechargerecharge: async (systemGenerateObject112: SystemGenerateObject112, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject112' is not null or undefined
            assertParamExists('listRechargerecharge', 'systemGenerateObject112', systemGenerateObject112)
            const localVarPath = `/recharge/listRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject112, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject113} systemGenerateObject113
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRechargerecharge: async (systemGenerateObject113: SystemGenerateObject113, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject113' is not null or undefined
            assertParamExists('pageRechargerecharge', 'systemGenerateObject113', systemGenerateObject113)
            const localVarPath = `/recharge/pageRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject113, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新充值套餐
         * @param {SystemGenerateObject115} systemGenerateObject115
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechargerecharge: async (systemGenerateObject115: SystemGenerateObject115, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject115' is not null or undefined
            assertParamExists('updateRechargerecharge', 'systemGenerateObject115', systemGenerateObject115)
            const localVarPath = `/recharge/updateRecharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject115, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RechargeApi - functional programming interface
 * @export
 */
export const RechargeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RechargeApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加充值套餐
         * @param {SystemGenerateObject114} systemGenerateObject114
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRechargerecharge(systemGenerateObject114: SystemGenerateObject114, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRechargerecharge(systemGenerateObject114, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除充值套餐
         * @param {number} rechargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRechargerecharge(rechargeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRechargerecharge(rechargeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 用户选择充值套餐进行充值
         * @summary 用户充值
         * @param {SystemGenerateObject116} systemGenerateObject116
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doRechargerecharge(systemGenerateObject116: SystemGenerateObject116, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doRechargerecharge(systemGenerateObject116, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 首次打开充值弹窗时，回填用户是否具有首充翻倍资格
         * @summary 获取用户首充翻倍资格
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirstChargeEligibilityrecharge(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirstChargeEligibilityrecharge(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject112} systemGenerateObject112
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRechargerecharge(systemGenerateObject112: SystemGenerateObject112, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRechargerecharge(systemGenerateObject112, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject113} systemGenerateObject113
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRechargerecharge(systemGenerateObject113: SystemGenerateObject113, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRechargerecharge(systemGenerateObject113, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新充值套餐
         * @param {SystemGenerateObject115} systemGenerateObject115
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRechargerecharge(systemGenerateObject115: SystemGenerateObject115, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRechargerecharge(systemGenerateObject115, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RechargeApi - factory interface
 * @export
 */
export const RechargeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RechargeApiFp(configuration)
    return {
        /**
         *
         * @summary 添加充值套餐
         * @param {SystemGenerateObject114} systemGenerateObject114
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRechargerecharge(systemGenerateObject114: SystemGenerateObject114, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addRechargerecharge(systemGenerateObject114, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除充值套餐
         * @param {number} rechargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRechargerecharge(rechargeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delRechargerecharge(rechargeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 用户选择充值套餐进行充值
         * @summary 用户充值
         * @param {SystemGenerateObject116} systemGenerateObject116
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRechargerecharge(systemGenerateObject116: SystemGenerateObject116, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.doRechargerecharge(systemGenerateObject116, options).then((request) => request(axios, basePath));
        },
        /**
         * 首次打开充值弹窗时，回填用户是否具有首充翻倍资格
         * @summary 获取用户首充翻倍资格
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirstChargeEligibilityrecharge(options?: any): AxiosPromise<any> {
            return localVarFp.getFirstChargeEligibilityrecharge(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject112} systemGenerateObject112
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRechargerecharge(systemGenerateObject112: SystemGenerateObject112, options?: any): AxiosPromise<any> {
            return localVarFp.listRechargerecharge(systemGenerateObject112, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject113} systemGenerateObject113
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRechargerecharge(systemGenerateObject113: SystemGenerateObject113, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageRechargerecharge(systemGenerateObject113, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新充值套餐
         * @param {SystemGenerateObject115} systemGenerateObject115
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechargerecharge(systemGenerateObject115: SystemGenerateObject115, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateRechargerecharge(systemGenerateObject115, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RechargeApi - object-oriented interface
 * @export
 * @class RechargeApi
 * @extends {BaseAPI}
 */
export class RechargeApi extends BaseAPI {
    /**
     *
     * @summary 添加充值套餐
     * @param {SystemGenerateObject114} systemGenerateObject114
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public addRechargerecharge(systemGenerateObject114: SystemGenerateObject114, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).addRechargerecharge(systemGenerateObject114, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除充值套餐
     * @param {number} rechargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public delRechargerecharge(rechargeId: number, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).delRechargerecharge(rechargeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 用户选择充值套餐进行充值
     * @summary 用户充值
     * @param {SystemGenerateObject116} systemGenerateObject116
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public doRechargerecharge(systemGenerateObject116: SystemGenerateObject116, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).doRechargerecharge(systemGenerateObject116, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 首次打开充值弹窗时，回填用户是否具有首充翻倍资格
     * @summary 获取用户首充翻倍资格
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public getFirstChargeEligibilityrecharge(options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).getFirstChargeEligibilityrecharge(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取充值套餐列表
     * @param {SystemGenerateObject112} systemGenerateObject112
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public listRechargerecharge(systemGenerateObject112: SystemGenerateObject112, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).listRechargerecharge(systemGenerateObject112, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取充值套餐列表(分页)
     * @param {SystemGenerateObject113} systemGenerateObject113
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public pageRechargerecharge(systemGenerateObject113: SystemGenerateObject113, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).pageRechargerecharge(systemGenerateObject113, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新充值套餐
     * @param {SystemGenerateObject115} systemGenerateObject115
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargeApi
     */
    public updateRechargerecharge(systemGenerateObject115: SystemGenerateObject115, options?: AxiosRequestConfig) {
        return RechargeApiFp(this.configuration).updateRechargerecharge(systemGenerateObject115, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignRuleApi - axios parameter creator
 * @export
 */
export const SignRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取签到规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignRulesignRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signRule/getSignRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 重置签到规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetSignRulesignRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signRule/resetSignRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置签到规则
         * @param {SystemGenerateObject108} systemGenerateObject108
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSignRulesignRule: async (systemGenerateObject108: SystemGenerateObject108, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject108' is not null or undefined
            assertParamExists('setSignRulesignRule', 'systemGenerateObject108', systemGenerateObject108)
            const localVarPath = `/signRule/setSignRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject108, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新签到规则
         * @param {SystemGenerateObject109} systemGenerateObject109
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSignRulesignRule: async (systemGenerateObject109: SystemGenerateObject109, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject109' is not null or undefined
            assertParamExists('updateSignRulesignRule', 'systemGenerateObject109', systemGenerateObject109)
            const localVarPath = `/signRule/updateSignRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject109, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignRuleApi - functional programming interface
 * @export
 */
export const SignRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignRuleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取签到规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignRulesignRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignRulesignRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 重置签到规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetSignRulesignRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetSignRulesignRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置签到规则
         * @param {SystemGenerateObject108} systemGenerateObject108
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSignRulesignRule(systemGenerateObject108: SystemGenerateObject108, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSignRulesignRule(systemGenerateObject108, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新签到规则
         * @param {SystemGenerateObject109} systemGenerateObject109
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSignRulesignRule(systemGenerateObject109: SystemGenerateObject109, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSignRulesignRule(systemGenerateObject109, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignRuleApi - factory interface
 * @export
 */
export const SignRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignRuleApiFp(configuration)
    return {
        /**
         *
         * @summary 获取签到规则
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignRulesignRule(options?: any): AxiosPromise<any> {
            return localVarFp.getSignRulesignRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 重置签到规则为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetSignRulesignRule(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.resetSignRulesignRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置签到规则
         * @param {SystemGenerateObject108} systemGenerateObject108
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSignRulesignRule(systemGenerateObject108: SystemGenerateObject108, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setSignRulesignRule(systemGenerateObject108, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新签到规则
         * @param {SystemGenerateObject109} systemGenerateObject109
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSignRulesignRule(systemGenerateObject109: SystemGenerateObject109, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateSignRulesignRule(systemGenerateObject109, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignRuleApi - object-oriented interface
 * @export
 * @class SignRuleApi
 * @extends {BaseAPI}
 */
export class SignRuleApi extends BaseAPI {
    /**
     *
     * @summary 获取签到规则
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignRuleApi
     */
    public getSignRulesignRule(options?: AxiosRequestConfig) {
        return SignRuleApiFp(this.configuration).getSignRulesignRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 重置签到规则为默认值
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignRuleApi
     */
    public resetSignRulesignRule(options?: AxiosRequestConfig) {
        return SignRuleApiFp(this.configuration).resetSignRulesignRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置签到规则
     * @param {SystemGenerateObject108} systemGenerateObject108
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignRuleApi
     */
    public setSignRulesignRule(systemGenerateObject108: SystemGenerateObject108, options?: AxiosRequestConfig) {
        return SignRuleApiFp(this.configuration).setSignRulesignRule(systemGenerateObject108, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新签到规则
     * @param {SystemGenerateObject109} systemGenerateObject109
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignRuleApi
     */
    public updateSignRulesignRule(systemGenerateObject109: SystemGenerateObject109, options?: AxiosRequestConfig) {
        return SignRuleApiFp(this.configuration).updateSignRulesignRule(systemGenerateObject109, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 按日期范围统计每日收入
         * @summary 获取日收入统计
         * @param {SystemGenerateObject125} systemGenerateObject125
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyIncomestatistics: async (systemGenerateObject125: SystemGenerateObject125, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject125' is not null or undefined
            assertParamExists('getDailyIncomestatistics', 'systemGenerateObject125', systemGenerateObject125)
            const localVarPath = `/statistics/daily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject125, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本日用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyProfitRankstatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/profitRank/daily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按年份统计每月收入
         * @summary 获取月收入统计
         * @param {SystemGenerateObject126} systemGenerateObject126
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyIncomestatistics: async (systemGenerateObject126: SystemGenerateObject126, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject126' is not null or undefined
            assertParamExists('getMonthlyIncomestatistics', 'systemGenerateObject126', systemGenerateObject126)
            const localVarPath = `/statistics/monthly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject126, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本月用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyProfitRankstatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/profitRank/monthly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按年份统计每季度收入
         * @summary 获取季度收入统计
         * @param {SystemGenerateObject127} systemGenerateObject127
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuarterlyIncomestatistics: async (systemGenerateObject127: SystemGenerateObject127, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject127' is not null or undefined
            assertParamExists('getQuarterlyIncomestatistics', 'systemGenerateObject127', systemGenerateObject127)
            const localVarPath = `/statistics/quarterly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject127, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本季度用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuarterlyProfitRankstatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/profitRank/quarterly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 统计今日总收入（微信支付）和总订单数
         * @summary 获取今日统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayStatisticsstatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/today`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按年份范围统计每年收入
         * @summary 获取年度收入统计
         * @param {SystemGenerateObject128} systemGenerateObject128
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearlyIncomestatistics: async (systemGenerateObject128: SystemGenerateObject128, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject128' is not null or undefined
            assertParamExists('getYearlyIncomestatistics', 'systemGenerateObject128', systemGenerateObject128)
            const localVarPath = `/statistics/yearly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject128, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本年用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearlyProfitRankstatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/profitRank/yearly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 按日期范围统计每日收入
         * @summary 获取日收入统计
         * @param {SystemGenerateObject125} systemGenerateObject125
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyIncomestatistics(systemGenerateObject125: SystemGenerateObject125, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyIncomestatistics(systemGenerateObject125, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本日用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyProfitRankstatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyProfitRankstatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按年份统计每月收入
         * @summary 获取月收入统计
         * @param {SystemGenerateObject126} systemGenerateObject126
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyIncomestatistics(systemGenerateObject126: SystemGenerateObject126, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyIncomestatistics(systemGenerateObject126, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本月用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyProfitRankstatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyProfitRankstatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按年份统计每季度收入
         * @summary 获取季度收入统计
         * @param {SystemGenerateObject127} systemGenerateObject127
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuarterlyIncomestatistics(systemGenerateObject127: SystemGenerateObject127, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuarterlyIncomestatistics(systemGenerateObject127, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本季度用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuarterlyProfitRankstatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuarterlyProfitRankstatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 统计今日总收入（微信支付）和总订单数
         * @summary 获取今日统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodayStatisticsstatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodayStatisticsstatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按年份范围统计每年收入
         * @summary 获取年度收入统计
         * @param {SystemGenerateObject128} systemGenerateObject128
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYearlyIncomestatistics(systemGenerateObject128: SystemGenerateObject128, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYearlyIncomestatistics(systemGenerateObject128, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本年用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYearlyProfitRankstatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYearlyProfitRankstatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiFp(configuration)
    return {
        /**
         * 按日期范围统计每日收入
         * @summary 获取日收入统计
         * @param {SystemGenerateObject125} systemGenerateObject125
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyIncomestatistics(systemGenerateObject125: SystemGenerateObject125, options?: any): AxiosPromise<any> {
            return localVarFp.getDailyIncomestatistics(systemGenerateObject125, options).then((request) => request(axios, basePath));
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本日用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyProfitRankstatistics(options?: any): AxiosPromise<any> {
            return localVarFp.getDailyProfitRankstatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 按年份统计每月收入
         * @summary 获取月收入统计
         * @param {SystemGenerateObject126} systemGenerateObject126
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyIncomestatistics(systemGenerateObject126: SystemGenerateObject126, options?: any): AxiosPromise<any> {
            return localVarFp.getMonthlyIncomestatistics(systemGenerateObject126, options).then((request) => request(axios, basePath));
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本月用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyProfitRankstatistics(options?: any): AxiosPromise<any> {
            return localVarFp.getMonthlyProfitRankstatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 按年份统计每季度收入
         * @summary 获取季度收入统计
         * @param {SystemGenerateObject127} systemGenerateObject127
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuarterlyIncomestatistics(systemGenerateObject127: SystemGenerateObject127, options?: any): AxiosPromise<any> {
            return localVarFp.getQuarterlyIncomestatistics(systemGenerateObject127, options).then((request) => request(axios, basePath));
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本季度用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuarterlyProfitRankstatistics(options?: any): AxiosPromise<any> {
            return localVarFp.getQuarterlyProfitRankstatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 统计今日总收入（微信支付）和总订单数
         * @summary 获取今日统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayStatisticsstatistics(options?: any): AxiosPromise<any> {
            return localVarFp.getTodayStatisticsstatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 按年份范围统计每年收入
         * @summary 获取年度收入统计
         * @param {SystemGenerateObject128} systemGenerateObject128
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearlyIncomestatistics(systemGenerateObject128: SystemGenerateObject128, options?: any): AxiosPromise<any> {
            return localVarFp.getYearlyIncomestatistics(systemGenerateObject128, options).then((request) => request(axios, basePath));
        },
        /**
         * 按收益积分值从大到小排序，取前20个用户
         * @summary 获取本年用户积分收益排行
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearlyProfitRankstatistics(options?: any): AxiosPromise<any> {
            return localVarFp.getYearlyProfitRankstatistics(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     * 按日期范围统计每日收入
     * @summary 获取日收入统计
     * @param {SystemGenerateObject125} systemGenerateObject125
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getDailyIncomestatistics(systemGenerateObject125: SystemGenerateObject125, options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getDailyIncomestatistics(systemGenerateObject125, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按收益积分值从大到小排序，取前20个用户
     * @summary 获取本日用户积分收益排行
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getDailyProfitRankstatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getDailyProfitRankstatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按年份统计每月收入
     * @summary 获取月收入统计
     * @param {SystemGenerateObject126} systemGenerateObject126
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getMonthlyIncomestatistics(systemGenerateObject126: SystemGenerateObject126, options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getMonthlyIncomestatistics(systemGenerateObject126, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按收益积分值从大到小排序，取前20个用户
     * @summary 获取本月用户积分收益排行
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getMonthlyProfitRankstatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getMonthlyProfitRankstatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按年份统计每季度收入
     * @summary 获取季度收入统计
     * @param {SystemGenerateObject127} systemGenerateObject127
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getQuarterlyIncomestatistics(systemGenerateObject127: SystemGenerateObject127, options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getQuarterlyIncomestatistics(systemGenerateObject127, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按收益积分值从大到小排序，取前20个用户
     * @summary 获取本季度用户积分收益排行
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getQuarterlyProfitRankstatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getQuarterlyProfitRankstatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 统计今日总收入（微信支付）和总订单数
     * @summary 获取今日统计
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getTodayStatisticsstatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getTodayStatisticsstatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按年份范围统计每年收入
     * @summary 获取年度收入统计
     * @param {SystemGenerateObject128} systemGenerateObject128
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getYearlyIncomestatistics(systemGenerateObject128: SystemGenerateObject128, options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getYearlyIncomestatistics(systemGenerateObject128, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 按收益积分值从大到小排序，取前20个用户
     * @summary 获取本年用户积分收益排行
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getYearlyProfitRankstatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getYearlyProfitRankstatistics(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreNoticeApi - axios parameter creator
 * @export
 */
export const StoreNoticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取本店须知信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreNoticestoreNotice: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storeNotice/getStoreNotice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 重置本店须知信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStoreNoticestoreNotice: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storeNotice/resetStoreNotice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置本店须知信息
         * @param {SystemGenerateObject123} systemGenerateObject123
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStoreNoticestoreNotice: async (systemGenerateObject123: SystemGenerateObject123, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject123' is not null or undefined
            assertParamExists('setStoreNoticestoreNotice', 'systemGenerateObject123', systemGenerateObject123)
            const localVarPath = `/storeNotice/setStoreNotice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject123, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新本店须知信息
         * @param {SystemGenerateObject124} systemGenerateObject124
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStoreNoticestoreNotice: async (systemGenerateObject124: SystemGenerateObject124, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject124' is not null or undefined
            assertParamExists('updateStoreNoticestoreNotice', 'systemGenerateObject124', systemGenerateObject124)
            const localVarPath = `/storeNotice/updateStoreNotice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject124, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreNoticeApi - functional programming interface
 * @export
 */
export const StoreNoticeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreNoticeApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取本店须知信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreNoticestoreNotice(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreNoticestoreNotice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 重置本店须知信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetStoreNoticestoreNotice(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetStoreNoticestoreNotice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置本店须知信息
         * @param {SystemGenerateObject123} systemGenerateObject123
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStoreNoticestoreNotice(systemGenerateObject123: SystemGenerateObject123, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStoreNoticestoreNotice(systemGenerateObject123, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新本店须知信息
         * @param {SystemGenerateObject124} systemGenerateObject124
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStoreNoticestoreNotice(systemGenerateObject124: SystemGenerateObject124, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStoreNoticestoreNotice(systemGenerateObject124, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreNoticeApi - factory interface
 * @export
 */
export const StoreNoticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreNoticeApiFp(configuration)
    return {
        /**
         *
         * @summary 获取本店须知信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreNoticestoreNotice(options?: any): AxiosPromise<any> {
            return localVarFp.getStoreNoticestoreNotice(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 重置本店须知信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStoreNoticestoreNotice(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.resetStoreNoticestoreNotice(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置本店须知信息
         * @param {SystemGenerateObject123} systemGenerateObject123
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStoreNoticestoreNotice(systemGenerateObject123: SystemGenerateObject123, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setStoreNoticestoreNotice(systemGenerateObject123, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新本店须知信息
         * @param {SystemGenerateObject124} systemGenerateObject124
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStoreNoticestoreNotice(systemGenerateObject124: SystemGenerateObject124, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStoreNoticestoreNotice(systemGenerateObject124, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreNoticeApi - object-oriented interface
 * @export
 * @class StoreNoticeApi
 * @extends {BaseAPI}
 */
export class StoreNoticeApi extends BaseAPI {
    /**
     *
     * @summary 获取本店须知信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreNoticeApi
     */
    public getStoreNoticestoreNotice(options?: AxiosRequestConfig) {
        return StoreNoticeApiFp(this.configuration).getStoreNoticestoreNotice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 重置本店须知信息为默认值
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreNoticeApi
     */
    public resetStoreNoticestoreNotice(options?: AxiosRequestConfig) {
        return StoreNoticeApiFp(this.configuration).resetStoreNoticestoreNotice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置本店须知信息
     * @param {SystemGenerateObject123} systemGenerateObject123
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreNoticeApi
     */
    public setStoreNoticestoreNotice(systemGenerateObject123: SystemGenerateObject123, options?: AxiosRequestConfig) {
        return StoreNoticeApiFp(this.configuration).setStoreNoticestoreNotice(systemGenerateObject123, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新本店须知信息
     * @param {SystemGenerateObject124} systemGenerateObject124
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreNoticeApi
     */
    public updateStoreNoticestoreNotice(systemGenerateObject124: SystemGenerateObject124, options?: AxiosRequestConfig) {
        return StoreNoticeApiFp(this.configuration).updateStoreNoticestoreNotice(systemGenerateObject124, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _7250000000000000000system: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swagger.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _7250000000000000000system(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._7250000000000000000system(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _7250000000000000000system(options?: any): AxiosPromise<any> {
            return localVarFp._7250000000000000000system(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 获取swagger.json
     * @summary swagger接口文档
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public _7250000000000000000system(options?: AxiosRequestConfig) {
        return SystemApiFp(this.configuration)._7250000000000000000system(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestApi - axios parameter creator
 * @export
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加test
         * @param {SystemGenerateObject27} systemGenerateObject27
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTesttest: async (systemGenerateObject27: SystemGenerateObject27, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject27' is not null or undefined
            assertParamExists('addTesttest', 'systemGenerateObject27', systemGenerateObject27)
            const localVarPath = `/test/addTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject27, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除test
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTesttest: async (testId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('delTesttest', 'testId', testId)
            const localVarPath = `/test/delTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取test列表
         * @param {SystemGenerateObject25} systemGenerateObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTesttest: async (systemGenerateObject25: SystemGenerateObject25, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject25' is not null or undefined
            assertParamExists('listTesttest', 'systemGenerateObject25', systemGenerateObject25)
            const localVarPath = `/test/listTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject25, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取test列表(分页)
         * @param {SystemGenerateObject26} systemGenerateObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTesttest: async (systemGenerateObject26: SystemGenerateObject26, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject26' is not null or undefined
            assertParamExists('pageTesttest', 'systemGenerateObject26', systemGenerateObject26)
            const localVarPath = `/test/pageTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject26, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新test
         * @param {SystemGenerateObject28} systemGenerateObject28
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTesttest: async (systemGenerateObject28: SystemGenerateObject28, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject28' is not null or undefined
            assertParamExists('updateTesttest', 'systemGenerateObject28', systemGenerateObject28)
            const localVarPath = `/test/updateTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject28, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 * @export
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加test
         * @param {SystemGenerateObject27} systemGenerateObject27
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTesttest(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTesttest(systemGenerateObject27, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除test
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTesttest(testId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTesttest(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取test列表
         * @param {SystemGenerateObject25} systemGenerateObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTesttest(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTesttest(systemGenerateObject25, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取test列表(分页)
         * @param {SystemGenerateObject26} systemGenerateObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTesttest(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTesttest(systemGenerateObject26, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新test
         * @param {SystemGenerateObject28} systemGenerateObject28
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTesttest(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTesttest(systemGenerateObject28, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestApi - factory interface
 * @export
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         *
         * @summary 添加test
         * @param {SystemGenerateObject27} systemGenerateObject27
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTesttest(systemGenerateObject27: SystemGenerateObject27, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addTesttest(systemGenerateObject27, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除test
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTesttest(testId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTesttest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取test列表
         * @param {SystemGenerateObject25} systemGenerateObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTesttest(systemGenerateObject25: SystemGenerateObject25, options?: any): AxiosPromise<any> {
            return localVarFp.listTesttest(systemGenerateObject25, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取test列表(分页)
         * @param {SystemGenerateObject26} systemGenerateObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTesttest(systemGenerateObject26: SystemGenerateObject26, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageTesttest(systemGenerateObject26, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新test
         * @param {SystemGenerateObject28} systemGenerateObject28
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTesttest(systemGenerateObject28: SystemGenerateObject28, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateTesttest(systemGenerateObject28, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApi - object-oriented interface
 * @export
 * @class TestApi
 * @extends {BaseAPI}
 */
export class TestApi extends BaseAPI {
    /**
     *
     * @summary 添加test
     * @param {SystemGenerateObject27} systemGenerateObject27
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public addTesttest(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).addTesttest(systemGenerateObject27, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除test
     * @param {number} testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public delTesttest(testId: number, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).delTesttest(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取test列表
     * @param {SystemGenerateObject25} systemGenerateObject25
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public listTesttest(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).listTesttest(systemGenerateObject25, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取test列表(分页)
     * @param {SystemGenerateObject26} systemGenerateObject26
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public pageTesttest(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).pageTesttest(systemGenerateObject26, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新test
     * @param {SystemGenerateObject28} systemGenerateObject28
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public updateTesttest(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).updateTesttest(systemGenerateObject28, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUpload: async (files: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('filesUpload', 'files', files)
            const localVarPath = `/upload/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }



            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesUpload(files: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesUpload(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUpload(files: Array<File>, options?: any): AxiosPromise<any> {
            return localVarFp.filesUpload(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * 上传文件
     * @summary 上传文件
     * @param {Array<File>} files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public filesUpload(files: Array<File>, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).filesUpload(files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 创建新用户
         * @summary 添加用户
         * @param {SystemGenerateObject44} systemGenerateObject44
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUseruser: async (systemGenerateObject44: SystemGenerateObject44, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject44' is not null or undefined
            assertParamExists('addUseruser', 'systemGenerateObject44', systemGenerateObject44)
            const localVarPath = `/user/addUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject44, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理员改变用户积分
         * @summary 改变用户积分
         * @param {SystemGenerateObject47} systemGenerateObject47
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePointsuser: async (systemGenerateObject47: SystemGenerateObject47, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject47' is not null or undefined
            assertParamExists('changePointsuser', 'systemGenerateObject47', systemGenerateObject47)
            const localVarPath = `/user/changePoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject47, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 用户每日签到获取积分
         * @summary 每日签到
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailySignuser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/dailySign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据用户ID删除用户
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUseruser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUseruser', 'userId', userId)
            const localVarPath = `/user/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据用户ID查询用户详情
         * @summary 查询单个用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUseruser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('findUseruser', 'userId', userId)
            const localVarPath = `/user/findUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 通过用户ID进行服务端登录
         * @summary 服务端登录
         * @param {SystemGenerateObject42} systemGenerateObject42
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByBackuser: async (systemGenerateObject42: SystemGenerateObject42, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject42' is not null or undefined
            assertParamExists('loginByBackuser', 'systemGenerateObject42', systemGenerateObject42)
            const localVarPath = `/user/loginByBack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject42, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据条件分页查询用户列表
         * @summary 分页查询用户
         * @param {SystemGenerateObject43} systemGenerateObject43
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersuser: async (systemGenerateObject43: SystemGenerateObject43, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject43' is not null or undefined
            assertParamExists('pageUsersuser', 'systemGenerateObject43', systemGenerateObject43)
            const localVarPath = `/user/pageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject43, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 更新当前用户的昵称和头像信息
         * @summary 更新个人信息
         * @param {SystemGenerateObject46} systemGenerateObject46
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileuser: async (systemGenerateObject46: SystemGenerateObject46, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject46' is not null or undefined
            assertParamExists('updateProfileuser', 'systemGenerateObject46', systemGenerateObject46)
            const localVarPath = `/user/updateProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject46, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 更新用户信息
         * @summary 更新用户
         * @param {SystemGenerateObject45} systemGenerateObject45
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUseruser: async (systemGenerateObject45: SystemGenerateObject45, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject45' is not null or undefined
            assertParamExists('updateUseruser', 'systemGenerateObject45', systemGenerateObject45)
            const localVarPath = `/user/updateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject45, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 创建新用户
         * @summary 添加用户
         * @param {SystemGenerateObject44} systemGenerateObject44
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUseruser(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUseruser(systemGenerateObject44, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理员改变用户积分
         * @summary 改变用户积分
         * @param {SystemGenerateObject47} systemGenerateObject47
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePointsuser(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePointsuser(systemGenerateObject47, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 用户每日签到获取积分
         * @summary 每日签到
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailySignuser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailySignuser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据用户ID删除用户
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUseruser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUseruser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据用户ID查询用户详情
         * @summary 查询单个用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUseruser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUseruser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 通过用户ID进行服务端登录
         * @summary 服务端登录
         * @param {SystemGenerateObject42} systemGenerateObject42
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByBackuser(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByBackuser(systemGenerateObject42, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据条件分页查询用户列表
         * @summary 分页查询用户
         * @param {SystemGenerateObject43} systemGenerateObject43
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUsersuser(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUsersuser(systemGenerateObject43, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 更新当前用户的昵称和头像信息
         * @summary 更新个人信息
         * @param {SystemGenerateObject46} systemGenerateObject46
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileuser(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileuser(systemGenerateObject46, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 更新用户信息
         * @summary 更新用户
         * @param {SystemGenerateObject45} systemGenerateObject45
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUseruser(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUseruser(systemGenerateObject45, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 创建新用户
         * @summary 添加用户
         * @param {SystemGenerateObject44} systemGenerateObject44
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUseruser(systemGenerateObject44: SystemGenerateObject44, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addUseruser(systemGenerateObject44, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理员改变用户积分
         * @summary 改变用户积分
         * @param {SystemGenerateObject47} systemGenerateObject47
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePointsuser(systemGenerateObject47: SystemGenerateObject47, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.changePointsuser(systemGenerateObject47, options).then((request) => request(axios, basePath));
        },
        /**
         * 用户每日签到获取积分
         * @summary 每日签到
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailySignuser(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.dailySignuser(options).then((request) => request(axios, basePath));
        },
        /**
         * 根据用户ID删除用户
         * @summary 删除用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUseruser(userId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteUseruser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据用户ID查询用户详情
         * @summary 查询单个用户
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUseruser(userId: number, options?: any): AxiosPromise<any> {
            return localVarFp.findUseruser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 通过用户ID进行服务端登录
         * @summary 服务端登录
         * @param {SystemGenerateObject42} systemGenerateObject42
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByBackuser(systemGenerateObject42: SystemGenerateObject42, options?: any): AxiosPromise<any> {
            return localVarFp.loginByBackuser(systemGenerateObject42, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据条件分页查询用户列表
         * @summary 分页查询用户
         * @param {SystemGenerateObject43} systemGenerateObject43
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersuser(systemGenerateObject43: SystemGenerateObject43, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageUsersuser(systemGenerateObject43, options).then((request) => request(axios, basePath));
        },
        /**
         * 更新当前用户的昵称和头像信息
         * @summary 更新个人信息
         * @param {SystemGenerateObject46} systemGenerateObject46
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileuser(systemGenerateObject46: SystemGenerateObject46, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateProfileuser(systemGenerateObject46, options).then((request) => request(axios, basePath));
        },
        /**
         * 更新用户信息
         * @summary 更新用户
         * @param {SystemGenerateObject45} systemGenerateObject45
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUseruser(systemGenerateObject45: SystemGenerateObject45, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateUseruser(systemGenerateObject45, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 创建新用户
     * @summary 添加用户
     * @param {SystemGenerateObject44} systemGenerateObject44
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public addUseruser(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).addUseruser(systemGenerateObject44, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理员改变用户积分
     * @summary 改变用户积分
     * @param {SystemGenerateObject47} systemGenerateObject47
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public changePointsuser(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).changePointsuser(systemGenerateObject47, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 用户每日签到获取积分
     * @summary 每日签到
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public dailySignuser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).dailySignuser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据用户ID删除用户
     * @summary 删除用户
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUseruser(userId: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUseruser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据用户ID查询用户详情
     * @summary 查询单个用户
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public findUseruser(userId: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).findUseruser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 通过用户ID进行服务端登录
     * @summary 服务端登录
     * @param {SystemGenerateObject42} systemGenerateObject42
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginByBackuser(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).loginByBackuser(systemGenerateObject42, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据条件分页查询用户列表
     * @summary 分页查询用户
     * @param {SystemGenerateObject43} systemGenerateObject43
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public pageUsersuser(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).pageUsersuser(systemGenerateObject43, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 更新当前用户的昵称和头像信息
     * @summary 更新个人信息
     * @param {SystemGenerateObject46} systemGenerateObject46
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateProfileuser(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateProfileuser(systemGenerateObject46, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 更新用户信息
     * @summary 更新用户
     * @param {SystemGenerateObject45} systemGenerateObject45
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUseruser(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUseruser(systemGenerateObject45, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserLevelRuleApi - axios parameter creator
 * @export
 */
export const UserLevelRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加会员等级规则
         * @param {SystemGenerateObject101} systemGenerateObject101
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserLevelRuleuserLevelRule: async (systemGenerateObject101: SystemGenerateObject101, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject101' is not null or undefined
            assertParamExists('addUserLevelRuleuserLevelRule', 'systemGenerateObject101', systemGenerateObject101)
            const localVarPath = `/userLevelRule/addUserLevelRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject101, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除会员等级规则
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserLevelRuleuserLevelRule: async (index: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'index' is not null or undefined
            assertParamExists('delUserLevelRuleuserLevelRule', 'index', index)
            const localVarPath = `/userLevelRule/delUserLevelRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取会员等级规则列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLevelRuleuserLevelRule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userLevelRule/listUserLevelRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 批量设置会员等级规则
         * @param {SystemGenerateObject103} systemGenerateObject103
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserLevelRulesuserLevelRule: async (systemGenerateObject103: SystemGenerateObject103, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject103' is not null or undefined
            assertParamExists('setUserLevelRulesuserLevelRule', 'systemGenerateObject103', systemGenerateObject103)
            const localVarPath = `/userLevelRule/setUserLevelRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject103, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新会员等级规则
         * @param {number} index
         * @param {SystemGenerateObject102} systemGenerateObject102
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLevelRuleuserLevelRule: async (index: number, systemGenerateObject102: SystemGenerateObject102, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'index' is not null or undefined
            assertParamExists('updateUserLevelRuleuserLevelRule', 'index', index)
            // verify required parameter 'systemGenerateObject102' is not null or undefined
            assertParamExists('updateUserLevelRuleuserLevelRule', 'systemGenerateObject102', systemGenerateObject102)
            const localVarPath = `/userLevelRule/updateUserLevelRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject102, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLevelRuleApi - functional programming interface
 * @export
 */
export const UserLevelRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLevelRuleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加会员等级规则
         * @param {SystemGenerateObject101} systemGenerateObject101
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserLevelRuleuserLevelRule(systemGenerateObject101: SystemGenerateObject101, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserLevelRuleuserLevelRule(systemGenerateObject101, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除会员等级规则
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delUserLevelRuleuserLevelRule(index: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delUserLevelRuleuserLevelRule(index, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取会员等级规则列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserLevelRuleuserLevelRule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserLevelRuleuserLevelRule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 批量设置会员等级规则
         * @param {SystemGenerateObject103} systemGenerateObject103
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserLevelRulesuserLevelRule(systemGenerateObject103: SystemGenerateObject103, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserLevelRulesuserLevelRule(systemGenerateObject103, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新会员等级规则
         * @param {number} index
         * @param {SystemGenerateObject102} systemGenerateObject102
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserLevelRuleuserLevelRule(index: number, systemGenerateObject102: SystemGenerateObject102, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserLevelRuleuserLevelRule(index, systemGenerateObject102, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserLevelRuleApi - factory interface
 * @export
 */
export const UserLevelRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLevelRuleApiFp(configuration)
    return {
        /**
         *
         * @summary 添加会员等级规则
         * @param {SystemGenerateObject101} systemGenerateObject101
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserLevelRuleuserLevelRule(systemGenerateObject101: SystemGenerateObject101, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addUserLevelRuleuserLevelRule(systemGenerateObject101, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除会员等级规则
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserLevelRuleuserLevelRule(index: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delUserLevelRuleuserLevelRule(index, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取会员等级规则列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLevelRuleuserLevelRule(options?: any): AxiosPromise<any> {
            return localVarFp.listUserLevelRuleuserLevelRule(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 批量设置会员等级规则
         * @param {SystemGenerateObject103} systemGenerateObject103
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserLevelRulesuserLevelRule(systemGenerateObject103: SystemGenerateObject103, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setUserLevelRulesuserLevelRule(systemGenerateObject103, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新会员等级规则
         * @param {number} index
         * @param {SystemGenerateObject102} systemGenerateObject102
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLevelRuleuserLevelRule(index: number, systemGenerateObject102: SystemGenerateObject102, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateUserLevelRuleuserLevelRule(index, systemGenerateObject102, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLevelRuleApi - object-oriented interface
 * @export
 * @class UserLevelRuleApi
 * @extends {BaseAPI}
 */
export class UserLevelRuleApi extends BaseAPI {
    /**
     *
     * @summary 添加会员等级规则
     * @param {SystemGenerateObject101} systemGenerateObject101
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLevelRuleApi
     */
    public addUserLevelRuleuserLevelRule(systemGenerateObject101: SystemGenerateObject101, options?: AxiosRequestConfig) {
        return UserLevelRuleApiFp(this.configuration).addUserLevelRuleuserLevelRule(systemGenerateObject101, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除会员等级规则
     * @param {number} index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLevelRuleApi
     */
    public delUserLevelRuleuserLevelRule(index: number, options?: AxiosRequestConfig) {
        return UserLevelRuleApiFp(this.configuration).delUserLevelRuleuserLevelRule(index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取会员等级规则列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLevelRuleApi
     */
    public listUserLevelRuleuserLevelRule(options?: AxiosRequestConfig) {
        return UserLevelRuleApiFp(this.configuration).listUserLevelRuleuserLevelRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 批量设置会员等级规则
     * @param {SystemGenerateObject103} systemGenerateObject103
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLevelRuleApi
     */
    public setUserLevelRulesuserLevelRule(systemGenerateObject103: SystemGenerateObject103, options?: AxiosRequestConfig) {
        return UserLevelRuleApiFp(this.configuration).setUserLevelRulesuserLevelRule(systemGenerateObject103, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新会员等级规则
     * @param {number} index
     * @param {SystemGenerateObject102} systemGenerateObject102
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLevelRuleApi
     */
    public updateUserLevelRuleuserLevelRule(index: number, systemGenerateObject102: SystemGenerateObject102, options?: AxiosRequestConfig) {
        return UserLevelRuleApiFp(this.configuration).updateUserLevelRuleuserLevelRule(index, systemGenerateObject102, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserweappApi - axios parameter creator
 * @export
 */
export const UserweappApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 微信小程序用户登录
         * @param {SystemGenerateObject48} systemGenerateObject48
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginuserweapp: async (systemGenerateObject48: SystemGenerateObject48, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject48' is not null or undefined
            assertParamExists('loginuserweapp', 'systemGenerateObject48', systemGenerateObject48)
            const localVarPath = `/userweapp/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject48, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 微信小程序用户注册
         * @param {SystemGenerateObject49} systemGenerateObject49
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registeruserweapp: async (systemGenerateObject49: SystemGenerateObject49, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject49' is not null or undefined
            assertParamExists('registeruserweapp', 'systemGenerateObject49', systemGenerateObject49)
            const localVarPath = `/userweapp/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject49, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veryfyTokenuserweapp: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userweapp/veryfyToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserweappApi - functional programming interface
 * @export
 */
export const UserweappApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserweappApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 微信小程序用户登录
         * @param {SystemGenerateObject48} systemGenerateObject48
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginuserweapp(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginuserweapp(systemGenerateObject48, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 微信小程序用户注册
         * @param {SystemGenerateObject49} systemGenerateObject49
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registeruserweapp(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registeruserweapp(systemGenerateObject49, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veryfyTokenuserweapp(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veryfyTokenuserweapp(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserweappApi - factory interface
 * @export
 */
export const UserweappApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserweappApiFp(configuration)
    return {
        /**
         *
         * @summary 微信小程序用户登录
         * @param {SystemGenerateObject48} systemGenerateObject48
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginuserweapp(systemGenerateObject48: SystemGenerateObject48, options?: any): AxiosPromise<any> {
            return localVarFp.loginuserweapp(systemGenerateObject48, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 微信小程序用户注册
         * @param {SystemGenerateObject49} systemGenerateObject49
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registeruserweapp(systemGenerateObject49: SystemGenerateObject49, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.registeruserweapp(systemGenerateObject49, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veryfyTokenuserweapp(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.veryfyTokenuserweapp(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserweappApi - object-oriented interface
 * @export
 * @class UserweappApi
 * @extends {BaseAPI}
 */
export class UserweappApi extends BaseAPI {
    /**
     *
     * @summary 微信小程序用户登录
     * @param {SystemGenerateObject48} systemGenerateObject48
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserweappApi
     */
    public loginuserweapp(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig) {
        return UserweappApiFp(this.configuration).loginuserweapp(systemGenerateObject48, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 微信小程序用户注册
     * @param {SystemGenerateObject49} systemGenerateObject49
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserweappApi
     */
    public registeruserweapp(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig) {
        return UserweappApiFp(this.configuration).registeruserweapp(systemGenerateObject49, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 微信小程序验证token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserweappApi
     */
    public veryfyTokenuserweapp(options?: AxiosRequestConfig) {
        return UserweappApiFp(this.configuration).veryfyTokenuserweapp(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WaitingDeskApi - axios parameter creator
 * @export
 */
export const WaitingDeskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 添加侯桌
         * @param {SystemGenerateObject82} systemGenerateObject82
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaitingDeskwaitingDesk: async (systemGenerateObject82: SystemGenerateObject82, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject82' is not null or undefined
            assertParamExists('addWaitingDeskwaitingDesk', 'systemGenerateObject82', systemGenerateObject82)
            const localVarPath = `/waitingDesk/addWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject82, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 删除侯桌
         * @param {number} waitingDeskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWaitingDeskwaitingDesk: async (waitingDeskId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waitingDeskId' is not null or undefined
            assertParamExists('delWaitingDeskwaitingDesk', 'waitingDeskId', waitingDeskId)
            const localVarPath = `/waitingDesk/delWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (waitingDeskId !== undefined) {
                localVarQueryParameter['waitingDeskId'] = waitingDeskId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 用户侯桌
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinWaitingDeskwaitingDesk: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/waitingDesk/joinWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取侯桌列表
         * @param {SystemGenerateObject80} systemGenerateObject80
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaitingDeskwaitingDesk: async (systemGenerateObject80: SystemGenerateObject80, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject80' is not null or undefined
            assertParamExists('listWaitingDeskwaitingDesk', 'systemGenerateObject80', systemGenerateObject80)
            const localVarPath = `/waitingDesk/listWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject80, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 获取侯桌列表(分页)
         * @param {SystemGenerateObject81} systemGenerateObject81
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWaitingDeskwaitingDesk: async (systemGenerateObject81: SystemGenerateObject81, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject81' is not null or undefined
            assertParamExists('pageWaitingDeskwaitingDesk', 'systemGenerateObject81', systemGenerateObject81)
            const localVarPath = `/waitingDesk/pageWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject81, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新侯桌
         * @param {SystemGenerateObject83} systemGenerateObject83
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaitingDeskwaitingDesk: async (systemGenerateObject83: SystemGenerateObject83, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject83' is not null or undefined
            assertParamExists('updateWaitingDeskwaitingDesk', 'systemGenerateObject83', systemGenerateObject83)
            const localVarPath = `/waitingDesk/updateWaitingDesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject83, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaitingDeskApi - functional programming interface
 * @export
 */
export const WaitingDeskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaitingDeskApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 添加侯桌
         * @param {SystemGenerateObject82} systemGenerateObject82
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaitingDeskwaitingDesk(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWaitingDeskwaitingDesk(systemGenerateObject82, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 删除侯桌
         * @param {number} waitingDeskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWaitingDeskwaitingDesk(waitingDeskId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWaitingDeskwaitingDesk(waitingDeskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 用户侯桌
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinWaitingDeskwaitingDesk(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinWaitingDeskwaitingDesk(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取侯桌列表
         * @param {SystemGenerateObject80} systemGenerateObject80
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaitingDeskwaitingDesk(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaitingDeskwaitingDesk(systemGenerateObject80, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 获取侯桌列表(分页)
         * @param {SystemGenerateObject81} systemGenerateObject81
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWaitingDeskwaitingDesk(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWaitingDeskwaitingDesk(systemGenerateObject81, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新侯桌
         * @param {SystemGenerateObject83} systemGenerateObject83
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaitingDeskwaitingDesk(systemGenerateObject83: SystemGenerateObject83, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWaitingDeskwaitingDesk(systemGenerateObject83, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaitingDeskApi - factory interface
 * @export
 */
export const WaitingDeskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaitingDeskApiFp(configuration)
    return {
        /**
         *
         * @summary 添加侯桌
         * @param {SystemGenerateObject82} systemGenerateObject82
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaitingDeskwaitingDesk(systemGenerateObject82: SystemGenerateObject82, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWaitingDeskwaitingDesk(systemGenerateObject82, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 删除侯桌
         * @param {number} waitingDeskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWaitingDeskwaitingDesk(waitingDeskId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWaitingDeskwaitingDesk(waitingDeskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 用户侯桌
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinWaitingDeskwaitingDesk(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.joinWaitingDeskwaitingDesk(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取侯桌列表
         * @param {SystemGenerateObject80} systemGenerateObject80
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaitingDeskwaitingDesk(systemGenerateObject80: SystemGenerateObject80, options?: any): AxiosPromise<any> {
            return localVarFp.listWaitingDeskwaitingDesk(systemGenerateObject80, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 获取侯桌列表(分页)
         * @param {SystemGenerateObject81} systemGenerateObject81
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWaitingDeskwaitingDesk(systemGenerateObject81: SystemGenerateObject81, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWaitingDeskwaitingDesk(systemGenerateObject81, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新侯桌
         * @param {SystemGenerateObject83} systemGenerateObject83
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaitingDeskwaitingDesk(systemGenerateObject83: SystemGenerateObject83, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWaitingDeskwaitingDesk(systemGenerateObject83, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaitingDeskApi - object-oriented interface
 * @export
 * @class WaitingDeskApi
 * @extends {BaseAPI}
 */
export class WaitingDeskApi extends BaseAPI {
    /**
     *
     * @summary 添加侯桌
     * @param {SystemGenerateObject82} systemGenerateObject82
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public addWaitingDeskwaitingDesk(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).addWaitingDeskwaitingDesk(systemGenerateObject82, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 删除侯桌
     * @param {number} waitingDeskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public delWaitingDeskwaitingDesk(waitingDeskId: number, options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).delWaitingDeskwaitingDesk(waitingDeskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 用户侯桌
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public joinWaitingDeskwaitingDesk(options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).joinWaitingDeskwaitingDesk(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取侯桌列表
     * @param {SystemGenerateObject80} systemGenerateObject80
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public listWaitingDeskwaitingDesk(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).listWaitingDeskwaitingDesk(systemGenerateObject80, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 获取侯桌列表(分页)
     * @param {SystemGenerateObject81} systemGenerateObject81
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public pageWaitingDeskwaitingDesk(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).pageWaitingDeskwaitingDesk(systemGenerateObject81, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新侯桌
     * @param {SystemGenerateObject83} systemGenerateObject83
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingDeskApi
     */
    public updateWaitingDeskwaitingDesk(systemGenerateObject83: SystemGenerateObject83, options?: AxiosRequestConfig) {
        return WaitingDeskApiFp(this.configuration).updateWaitingDeskwaitingDesk(systemGenerateObject83, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WifiApi - axios parameter creator
 * @export
 */
export const WifiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 获取WiFi信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWifiwifi: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wifi/getWifi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 重置WiFi信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWifiwifi: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wifi/resetWifi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 设置WiFi信息
         * @param {SystemGenerateObject110} systemGenerateObject110
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWifiwifi: async (systemGenerateObject110: SystemGenerateObject110, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject110' is not null or undefined
            assertParamExists('setWifiwifi', 'systemGenerateObject110', systemGenerateObject110)
            const localVarPath = `/wifi/setWifi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject110, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 更新WiFi信息
         * @param {SystemGenerateObject111} systemGenerateObject111
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWifiwifi: async (systemGenerateObject111: SystemGenerateObject111, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject111' is not null or undefined
            assertParamExists('updateWifiwifi', 'systemGenerateObject111', systemGenerateObject111)
            const localVarPath = `/wifi/updateWifi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject111, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WifiApi - functional programming interface
 * @export
 */
export const WifiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WifiApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 获取WiFi信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWifiwifi(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWifiwifi(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 重置WiFi信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetWifiwifi(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetWifiwifi(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 设置WiFi信息
         * @param {SystemGenerateObject110} systemGenerateObject110
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWifiwifi(systemGenerateObject110: SystemGenerateObject110, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWifiwifi(systemGenerateObject110, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary 更新WiFi信息
         * @param {SystemGenerateObject111} systemGenerateObject111
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWifiwifi(systemGenerateObject111: SystemGenerateObject111, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWifiwifi(systemGenerateObject111, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WifiApi - factory interface
 * @export
 */
export const WifiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WifiApiFp(configuration)
    return {
        /**
         *
         * @summary 获取WiFi信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWifiwifi(options?: any): AxiosPromise<any> {
            return localVarFp.getWifiwifi(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 重置WiFi信息为默认值
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWifiwifi(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.resetWifiwifi(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 设置WiFi信息
         * @param {SystemGenerateObject110} systemGenerateObject110
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWifiwifi(systemGenerateObject110: SystemGenerateObject110, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setWifiwifi(systemGenerateObject110, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 更新WiFi信息
         * @param {SystemGenerateObject111} systemGenerateObject111
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWifiwifi(systemGenerateObject111: SystemGenerateObject111, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWifiwifi(systemGenerateObject111, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WifiApi - object-oriented interface
 * @export
 * @class WifiApi
 * @extends {BaseAPI}
 */
export class WifiApi extends BaseAPI {
    /**
     *
     * @summary 获取WiFi信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WifiApi
     */
    public getWifiwifi(options?: AxiosRequestConfig) {
        return WifiApiFp(this.configuration).getWifiwifi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 重置WiFi信息为默认值
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WifiApi
     */
    public resetWifiwifi(options?: AxiosRequestConfig) {
        return WifiApiFp(this.configuration).resetWifiwifi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 设置WiFi信息
     * @param {SystemGenerateObject110} systemGenerateObject110
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WifiApi
     */
    public setWifiwifi(systemGenerateObject110: SystemGenerateObject110, options?: AxiosRequestConfig) {
        return WifiApiFp(this.configuration).setWifiwifi(systemGenerateObject110, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 更新WiFi信息
     * @param {SystemGenerateObject111} systemGenerateObject111
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WifiApi
     */
    public updateWifiwifi(systemGenerateObject111: SystemGenerateObject111, options?: AxiosRequestConfig) {
        return WifiApiFp(this.configuration).updateWifiwifi(systemGenerateObject111, options).then((request) => request(this.axios, this.basePath));
    }
}



